// cache-bust 1760375000
const MM2PX = 3.7795275591;
const EXPORT_DPI = 300;
const EXPORT_MAX_DPI = 450;
const EXPORT_MAX_IMAGE_PIXELS = 36000000;
// 300 DPI of the largest sheet (57 × 100 cm) is about 80 Mpx. Vector redraws
// keep that budget so a logo larger than the current sheet stays at 300 DPI.
const VECTOR_RASTER_MAX_PIXELS = 85000000;
const UNDO_LIMIT = 20;
const WARN_IMPORT_FILE_BYTES = 20 * 1024 * 1024;
const MAX_IMPORT_FILE_BYTES = 80 * 1024 * 1024;
const WARN_IMPORT_IMAGE_PIXELS = 32000000;
const MAX_IMPORT_IMAGE_PIXELS = 90000000;
const PDF_IMPORT_DPI = 300;
const PDF_IMPORT_MAX_PIXELS = 36000000;
const vectorPdfSources = new Map();
const vectorPdfDocs = new Map();
let vectorPdfDocSeq = 0;
const THUMB_MAX_SIZE = 180;
const MM2EXPORT = EXPORT_DPI / 25.4;
const DEFAULT_GAP_MM = 10;
const FORMATS = [
  {value:'420x580', label:'A2', exportLabel:'A2', w:420, h:580},
  {value:'300x430', label:'A3+', exportLabel:'A3plus', w:300, h:430},
  {value:'280x420', label:'A3', exportLabel:'A3', w:280, h:420},
  {value:'210x300', label:'A4+', exportLabel:'A4plus', w:210, h:300},
  {value:'210x280', label:'A4', exportLabel:'A4', w:210, h:280},
  {value:'140x210', label:'A5', exportLabel:'A5', w:140, h:210},
  {value:'100x140', label:'A6', exportLabel:'A6', w:100, h:140},
  {value:'60x100', label:'A7', exportLabel:'A7', w:60, h:100},
  {value:'570x1000', label:'Mètre', exportLabel:'metre', w:570, h:1000}
];
const GOOGLE_TEXT_FONTS = [
  {family:'Chewy', label:'Chewy', google:false, local:true},
  // Installed face. The PDF paints this same font: swapping in Anton changes
  // digit advances and the "1" foot, so rotated text no longer matches the sheet.
  {family:'Impact', label:'Impact', google:false, system:true},
  {family:'Poppins', label:'Poppins'},
  {family:'Montserrat', label:'Montserrat'},
  {family:'Roboto', label:'Roboto'},
  {family:'Open Sans', label:'Open Sans'},
  {family:'Lato', label:'Lato'},
  {family:'Oswald', label:'Oswald'},
  {family:'Raleway', label:'Raleway'},
  {family:'Nunito', label:'Nunito'},
  {family:'Inter', label:'Inter'},
  {family:'Ubuntu', label:'Ubuntu'},
  {family:'Source Sans 3', label:'Source Sans 3'},
  {family:'Work Sans', label:'Work Sans'},
  {family:'Noto Sans', label:'Noto Sans'},
  {family:'Merriweather', label:'Merriweather'},
  {family:'Playfair Display', label:'Playfair Display'},
  {family:'Roboto Slab', label:'Roboto Slab'},
  {family:'Lora', label:'Lora'},
  {family:'Mulish', label:'Mulish'},
  {family:'Quicksand', label:'Quicksand'},
  {family:'Rubik', label:'Rubik'},
  {family:'PT Sans', label:'PT Sans'},
  {family:'Libre Franklin', label:'Libre Franklin'},
  {family:'Manrope', label:'Manrope'},
  {family:'DM Sans', label:'DM Sans'},
  {family:'Archivo', label:'Archivo'},
  {family:'Barlow', label:'Barlow'},
  {family:'Fira Sans', label:'Fira Sans'},
  {family:'Titillium Web', label:'Titillium Web'},
  {family:'Exo 2', label:'Exo 2'},
  {family:'Josefin Sans', label:'Josefin Sans'},
  {family:'Kanit', label:'Kanit'},
  {family:'Urbanist', label:'Urbanist'},
  {family:'Bebas Neue', label:'Bebas Neue'},
  {family:'Anton', label:'Anton'},
  {family:'Bangers', label:'Bangers'},
  {family:'Bree Serif', label:'Bree Serif'},
  {family:'Cabin', label:'Cabin'},
  {family:'Caveat', label:'Caveat'},
  {family:'Cinzel', label:'Cinzel'},
  {family:'Comfortaa', label:'Comfortaa'},
  {family:'Cormorant Garamond', label:'Cormorant Garamond'},
  {family:'Crimson Text', label:'Crimson Text'},
  {family:'Dancing Script', label:'Dancing Script'},
  {family:'Domine', label:'Domine'},
  {family:'Fjalla One', label:'Fjalla One'},
  {family:'Fredoka', label:'Fredoka'},
  {family:'Great Vibes', label:'Great Vibes'},
  {family:'Heebo', label:'Heebo'},
  {family:'IBM Plex Sans', label:'IBM Plex Sans'},
  {family:'IBM Plex Serif', label:'IBM Plex Serif'},
  {family:'Inconsolata', label:'Inconsolata'},
  {family:'Kalam', label:'Kalam'},
  {family:'Libre Baskerville', label:'Libre Baskerville'},
  {family:'Lilita One', label:'Lilita One'},
  {family:'Lobster', label:'Lobster'},
  {family:'Lobster Two', label:'Lobster Two'},
  {family:'M PLUS Rounded 1c', label:'M PLUS Rounded 1c'},
  {family:'Maven Pro', label:'Maven Pro'},
  {family:'Merriweather Sans', label:'Merriweather Sans'},
  {family:'Mukta', label:'Mukta'},
  {family:'Nanum Gothic', label:'Nanum Gothic'},
  {family:'Noto Serif', label:'Noto Serif'},
  {family:'Nunito Sans', label:'Nunito Sans'},
  {family:'Pacifico', label:'Pacifico'},
  {family:'Pathway Gothic One', label:'Pathway Gothic One'},
  {family:'Permanent Marker', label:'Permanent Marker'},
  {family:'Plus Jakarta Sans', label:'Plus Jakarta Sans'},
  {family:'Prata', label:'Prata'},
  {family:'Prompt', label:'Prompt'},
  {family:'Public Sans', label:'Public Sans'},
  {family:'Rajdhani', label:'Rajdhani'},
  {family:'Righteous', label:'Righteous'},
  {family:'Saira Condensed', label:'Saira Condensed'},
  {family:'Signika', label:'Signika'},
  {family:'Space Grotesk', label:'Space Grotesk'},
  {family:'Space Mono', label:'Space Mono'},
  {family:'Spectral', label:'Spectral'},
  {family:'Teko', label:'Teko'},
  {family:'Varela Round', label:'Varela Round'},
  {family:'Vollkorn', label:'Vollkorn'},
  {family:'Yanone Kaffeesatz', label:'Yanone Kaffeesatz'},
  {family:'Yellowtail', label:'Yellowtail'},
  {family:'Zilla Slab', label:'Zilla Slab'},
  {family:'Abril Fatface', label:'Abril Fatface'},
  {family:'Alfa Slab One', label:'Alfa Slab One'},
  {family:'Amatic SC', label:'Amatic SC'},
  {family:'Arvo', label:'Arvo'},
  {family:'Assistant', label:'Assistant'},
  {family:'Atkinson Hyperlegible', label:'Atkinson Hyperlegible'},
  {family:'Baloo 2', label:'Baloo 2'},
  {family:'Cardo', label:'Cardo'},
  {family:'Chivo', label:'Chivo'},
  {family:'Cookie', label:'Cookie'},
  {family:'Courgette', label:'Courgette'},
  {family:'Crete Round', label:'Crete Round'},
  {family:'EB Garamond', label:'EB Garamond'},
  {family:'Economica', label:'Economica'},
  {family:'Forum', label:'Forum'},
  {family:'Frank Ruhl Libre', label:'Frank Ruhl Libre'},
  {family:'Gloria Hallelujah', label:'Gloria Hallelujah'},
  {family:'Hind', label:'Hind'},
  {family:'Jost', label:'Jost'},
  {family:'Lexend', label:'Lexend'},
  {family:'Martel', label:'Martel'},
  {family:'Montserrat Alternates', label:'Montserrat Alternates'},
  {family:'Neuton', label:'Neuton'},
  {family:'Noto Sans Display', label:'Noto Sans Display'},
  {family:'Noto Serif Display', label:'Noto Serif Display'},
  {family:'Orbitron', label:'Orbitron'},
  {family:'Overpass', label:'Overpass'},
  {family:'Philosopher', label:'Philosopher'},
  {family:'Poiret One', label:'Poiret One'},
  {family:'Questrial', label:'Questrial'},
  {family:'Red Hat Display', label:'Red Hat Display'},
  {family:'Rokkitt', label:'Rokkitt'},
  {family:'Sacramento', label:'Sacramento'},
  {family:'Sanchez', label:'Sanchez'},
  {family:'Secular One', label:'Secular One'},
  {family:'Shadows Into Light', label:'Shadows Into Light'},
  {family:'Slabo 27px', label:'Slabo 27px'},
  {family:'Sora', label:'Sora'},
  {family:'Special Elite', label:'Special Elite'},
  {family:'Syne', label:'Syne'},
  {family:'Unbounded', label:'Unbounded'},
  {family:'Vidaloka', label:'Vidaloka'},
  {family:'Yeseva One', label:'Yeseva One'}
];
const DEFAULT_TEXT_FONT = 'Poppins';
const UPLOADED_FONTS = new Map();
const MAX_UPLOADED_FONT_BYTES = 25 * 1024 * 1024;
const DEFAULT_TEXT_COLOR = '#111827';

// Native `<input type="color">` opens the browser popover, which shows RVB.
// Selectors display #RRGGBB instead. Stored colours stay `#rrggbb` (no alpha:
// this editor does not expose an alpha channel).
function parseColorToHex(value){
  const raw = String(value ?? '').trim();
  if(!raw) return null;
  const body = raw.charAt(0) === '#' ? raw.slice(1) : raw;
  if(/^[0-9a-fA-F]{3}$/.test(body) || /^[0-9a-fA-F]{6}$/.test(body) || /^[0-9a-fA-F]{8}$/.test(body)){
    const expanded = body.length === 3 ? body.split('').map(ch => ch + ch).join('') : body.slice(0, 6);
    return '#' + expanded.toLowerCase();
  }
  const match = raw.match(/^rgba?\(\s*([^)]+)\)$/i);
  if(!match) return null;
  const parts = match[1].trim().split(/[,/]\s*|\s+/).map(part => part.trim()).filter(Boolean);
  if(parts.length < 3) return null;
  const channels = parts.slice(0, 3).map(token => {
    const percent = token.endsWith('%');
    const n = parseFloat(percent ? token.slice(0, -1) : token);
    if(!Number.isFinite(n)) return null;
    const scaled = percent ? (n / 100) * 255 : n;
    return Math.min(255, Math.max(0, Math.round(scaled)));
  });
  if(channels.some(channel => channel == null)) return null;
  return '#' + channels.map(channel => channel.toString(16).padStart(2, '0')).join('');
}

function formatDisplayHex(value){
  return (parseColorToHex(value) || '#000000').toUpperCase();
}

function isReadyColorDraft(value){
  const raw = String(value ?? '').trim();
  const body = raw.charAt(0) === '#' ? raw.slice(1) : raw;
  if(/^[0-9a-fA-F]{6}$/.test(body) || /^[0-9a-fA-F]{8}$/.test(body)) return true;
  return /^rgba?\(/i.test(raw) && parseColorToHex(raw) != null;
}

const DEFAULT_TEXT_SIZE_MM = 12;
const TUTORIAL_STORAGE_KEY = 'sherpa_tutorial_done';
const TUTORIAL_STEPS = [
  {
    selector:'.format-select',
    title:'Choisissez le format',
    text:'Sélectionnez la taille de la planche active avant de placer vos visuels.'
  },
  {
    selector:'#upload-btn',
    title:'Importez vos fichiers',
    text:'Ajoutez des PNG, JPG, PDF ou AI. Les fichiers sont automatiquement préparés et placés sur la planche.'
  },
  {
    selector:'.text-add-btn',
    title:'Ajoutez du texte',
    text:'Créez un texte, choisissez une Google Font, changez sa couleur et exportez-le en vectoriel dans le PDF.'
  },
  {
    selector:'#canvas-zone',
    title:'Travaillez sur la planche',
    text:'Zoomez, déplacez-vous avec la molette et glissez les éléments dans la zone de travail.'
  },
  {
    selector:'.smart-layout',
    title:'Rangez automatiquement',
    text:'Utilisez la création auto ou Ranger la planche pour remplir la surface avec l’espace défini dans les réglages.'
  },
  {
    selector:'#propbar',
    title:'Modifiez la sélection',
    text:'Quand un élément est sélectionné, réglez sa position, sa taille, sa rotation, sa quantité ou ses options de texte.'
  },
  {
    selector:'.sheets-panel',
    title:'Gérez plusieurs planches',
    text:'Ajoutez plusieurs planches, changez leur format et ouvrez la vue d’ensemble pour les contrôler rapidement.'
  },
  {
    selector:'.sheets-panel',
    title:'Téléchargez vos PDF',
    text:'Dans la colonne de droite, téléchargez chaque planche en PDF une par une.'
  }
];

let sheetW = 420, sheetH = 580; // active sheet in mm
let elements = [];
let images = [];
let selected = null;
let selectedIds = new Set();
let clipboard = null;
let nextId = 1;
let nextSheetId = 1;
let sheets = [];
let activeSheetId = null;
let undoStack = [], redoStack = [];
let autoLocks = {};
let autoGapMm = DEFAULT_GAP_MM;
let checkerTheme = 'dark';
let zoomLevel = 1.0;
let isSpaceDown = false;
let busyOperations = new Map();
let nextBusyId = 1;
let tutorialIndex = 0;
let tutorialActive = false;
let creditModalResolve = null;

const EDITOR_ROOT = document.getElementById('sherpa-editor-app');
const ORDER_CTX_KEY = 'sherpa_order_ctx';
const ORDER_PENDING_KEY = 'sherpa_order_pending';
const ORDER_IDB_NAME = 'sherpa-order-db';
const ORDER_IDB_STORE = 'files';
const ORDER_IDB_VERSION = 1;

function readOrderModeFlag(){
  try{
    return new URLSearchParams(window.location.search).get('mode') === 'order';
  }catch(_){
    return false;
  }
}

function readEmbedFlag(){
  try{
    const params = new URLSearchParams(window.location.search);
    return params.get('embed') === '1' || params.get('embed') === 'true';
  }catch(_){
    return false;
  }
}

const editorEmbedded = readEmbedFlag();
// Do NOT add sherpa-embed just because we are in a frame (theme preview / tooling).
// That class locks body scroll and hides page chrome — only ?embed=1 opts in.

function notifyParent(type, payload){
  if(!editorEmbedded) return false;
  try{
    window.parent.postMessage(
      Object.assign({ source: 'editeur-sherpa', type }, payload || {}),
      window.location.origin
    );
    return true;
  }catch(_){
    return false;
  }
}

function normalizeOptionText(value){
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function formatKeyFromOption(text){
  const t = normalizeOptionText(text);
  if(!t) return null;
  if(/\bmetre\b|\bmeter\b/.test(t) || /57\s*x\s*100/.test(t)) return '570x1000';
  if(/\ba7\b/.test(t) || /6\s*x\s*10/.test(t)) return '60x100';
  if(/\ba6\b/.test(t) || /10\s*x\s*14/.test(t)) return '100x140';
  if(/\ba5\b/.test(t) || /14\s*x\s*21/.test(t)) return '140x210';
  if(/\ba4\+/.test(t) || /a4\s*\+/.test(t) || /21\s*x\s*30/.test(t)) return '210x300';
  if(/\ba4\b/.test(t) || /21\s*x\s*28/.test(t)) return '210x280';
  if(/\ba3\+/.test(t) || /a3\s*\+/.test(t) || /30\s*x\s*43/.test(t)) return '300x430';
  if(/\ba3\b/.test(t) || /28\s*x\s*42/.test(t)) return '280x420';
  if(/\ba2\b/.test(t) || /42\s*x\s*58/.test(t)) return '420x580';
  return null;
}

function loadOrderContext(){
  try{
    const raw = sessionStorage.getItem(ORDER_CTX_KEY);
    if(!raw) return null;
    const ctx = JSON.parse(raw);
    if(!ctx || typeof ctx !== 'object') return null;
    return ctx;
  }catch(_){
    return null;
  }
}

function optionIndexByPattern(optionNames, pattern){
  const list = Array.isArray(optionNames) ? optionNames : [];
  return list.findIndex(name => pattern.test(normalizeOptionText(name)));
}

let orderModeEnabled = readOrderModeFlag();
const isPdpEmbed = EDITOR_ROOT?.dataset.pdpEmbed === 'true';
let orderContext = orderModeEnabled ? loadOrderContext() : null;
let orderVariantId = orderContext?.variantId ? Number(orderContext.variantId) : null;

const creditConfig = {
  // Credits apply to PDF download (1 credit). Continuer / order attach stays free.
  required: EDITOR_ROOT?.dataset.creditRequired === 'true',
  apiBase: EDITOR_ROOT?.dataset.creditApiBase || 'https://innovative-stack-i1z8l.ampt.app/api/v1',
  // Jetons PMD+ live on the credits worker (Shopify custom.sub_usage). Ampt is images only.
  ledgerBase: EDITOR_ROOT?.dataset.creditLedgerBase || 'https://pmd-credits.jet-feast.workers.dev/api/v1',
  buyUrl: EDITOR_ROOT?.dataset.creditBuyUrl || 'https://www.sherpa-transfert.com/products/credits-supplementaires-printmydtf',
  loginUrl: EDITOR_ROOT?.dataset.loginUrl || '/account/login',
  customerId: EDITOR_ROOT?.dataset.customerId || '',
  isLoggedIn: EDITOR_ROOT?.dataset.customerLoggedIn === 'true',
  initialBalance: parseCreditBalance(EDITOR_ROOT?.dataset.creditBalance),
  freeDownloadEnabled: EDITOR_ROOT?.dataset.freeDownloadEnabled !== 'false',
  freeDownloadUsed: parseFlag(EDITOR_ROOT?.dataset.freeDownloadUsed),
  freeDownloadStoragePrefix: EDITOR_ROOT?.dataset.freeDownloadStoragePrefix || 'sherpa-amalgame-free-download'
};
const creditState = {
  balance: creditConfig.initialBalance,
  ready: !creditConfig.required || creditConfig.initialBalance !== null,
  loading: false,
  consuming: false,
  freeDownloadUsed: readFreeDownloadUsed()
};

if(EDITOR_ROOT){
  EDITOR_ROOT.addEventListener('click', event=>{
    const trigger = event.target.closest('[data-action="quit-editor"]');
    if(!trigger || !EDITOR_ROOT.contains(trigger)) return;
    event.preventDefault();
    quitEditor();
  });
}

// ── UNIT HELPERS ──
// Internal: mm. Display: cm.
function mm2s(mm){ return mm * MM2PX; }          // mm → screen px (unscaled)
function s2mm(px){ return px / MM2PX; }           // screen px → mm
function mm2e(mm){ return mm * MM2EXPORT; }        // mm → export px
function mm2cm(mm){ return Math.round(mm/10*100)/100; }  // mm → cm (2 decimal)
function cm2mm(cm){ return cm * 10; }
function px2cm(px){ return px / EXPORT_DPI * 2.54; }
function formatPrintCm(cm){ return (Math.round(cm * 10) / 10).toFixed(1); }
function imagePrintSizeLabel(wPx, hPx){
  return `${formatPrintCm(px2cm(wPx))} × ${formatPrintCm(px2cm(hPx))} cm`;
}

function imageAssetPrintSizeLabel(img){
  if(img?.printWmm > 0 && img?.printHmm > 0){
    return `${formatPrintCm(img.printWmm / 10)} × ${formatPrintCm(img.printHmm / 10)} cm`;
  }
  return imagePrintSizeLabel(img?.naturalW || 1, img?.naturalH || 1);
}

function sizeFromPrintMm(printWmm, printHmm){
  const w = Number(printWmm);
  const h = Number(printHmm);
  if(!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) return null;
  return {w: Math.round(w * 100) / 100, h: Math.round(h * 100) / 100};
}

function placeSizeForImage(nw, nh, printWmm=null, printHmm=null){
  return sizeFromPrintMm(printWmm, printHmm) || fitDefaultSize(nw, nh);
}

function isTextElement(el){
  return el?.type === 'text';
}

function getTextFont(el){
  return el?.fontFamily || DEFAULT_TEXT_FONT;
}

function getTextWeight(el){
  return Number(el?.fontWeight) >= 700 ? 700 : 400;
}

function getTextAlign(el){
  const align = String(el?.align || 'left').toLowerCase();
  return align === 'center' || align === 'right' ? align : 'left';
}

function visibleImages(){
  return images.filter(img=>!img.hidden);
}

function findImageById(id){
  return images.find(img=>img.id === id) || null;
}

function dataUrlByteSize(src){
  const value = String(src || '');
  const match = value.match(/^data:[^,]*;base64,(.*)$/);
  return match ? Math.ceil(match[1].length * 3 / 4) : value.length;
}

function createImageAsset(src, name, nw, nh, opts={}){
  const shortName = String(name || 'visuel').length > 22 ? String(name).substring(0,20)+'…' : String(name || 'visuel');
  const printWmm = Number(opts.printWmm);
  const printHmm = Number(opts.printHmm);
  const asset = {
    id: opts.id || nextId++,
    src,
    thumbSrc: opts.thumbSrc || src,
    name: shortName,
    naturalW: Math.max(1, Math.round(nw || 1)),
    naturalH: Math.max(1, Math.round(nh || 1)),
    printWmm: Number.isFinite(printWmm) && printWmm > 0 ? printWmm : null,
    printHmm: Number.isFinite(printHmm) && printHmm > 0 ? printHmm : null,
    byteSize: opts.byteSize || dataUrlByteSize(src),
    hidden: !!opts.hidden,
    derivedFrom: opts.derivedFrom || null,
    vectorSvg: opts.vectorSvg || null,
    vectorPdfDataUrl: opts.vectorPdfDataUrl || null,
    isVector: !!(opts.isVector || opts.vectorSvg || opts.vectorPdfDataUrl)
  };
  images.push(asset);
  return asset;
}

function assetBaseName(name){
  return String(name || 'visuel')
    .replace(/…$/g, '')
    .replace(/\s+v\d+$/i, '')
    .trim() || 'visuel';
}

function nextVersionedAssetName(name){
  const base = assetBaseName(name);
  let max = 1;
  images.forEach(img=>{
    if(assetBaseName(img.name) !== base) return;
    const match = String(img.name || '').match(/\bv(\d+)\s*$/i);
    max = Math.max(max, match ? parseInt(match[1], 10) : 1);
  });
  const label = `${base} v${max + 1}`;
  return label.length > 22 ? `${label.substring(0, 20)}…` : label;
}

function assetStoredPrintSizeMm(asset){
  if(asset?.printWmm > 0 && asset?.printHmm > 0){
    return {
      w: Math.round(asset.printWmm * 10) / 10,
      h: Math.round(asset.printHmm * 10) / 10
    };
  }
  const wPx = Math.max(1, asset?.naturalW || 1);
  const hPx = Math.max(1, asset?.naturalH || 1);
  return {
    w: Math.round(px2cm(wPx) * 10 * 10) / 10,
    h: Math.round(px2cm(hPx) * 10 * 10) / 10
  };
}

function elementPrintSizeMm(el){
  const rotated = isQuarterTurn(el?.rotation);
  const w = Math.round((rotated ? el.h : el.w) * 10) / 10;
  const h = Math.round((rotated ? el.w : el.h) * 10) / 10;
  return {w, h};
}

function samePrintSizeMm(a, b, eps=0.15){
  return Math.abs((a?.w || 0) - (b?.w || 0)) <= eps && Math.abs((a?.h || 0) - (b?.h || 0)) <= eps;
}

function isImageAssetUsedByOthers(assetId, elementId){
  if(elements.some(el => !isTextElement(el) && el.imageId === assetId && el.id !== elementId)) return true;
  return sheets.some(sheet => (sheet.elements || []).some(el =>
    !isTextElement(el) && el.imageId === assetId && el.id !== elementId
  ));
}

function syncElementImageVersion(el, opts={}){
  if(!el || isTextElement(el)) return null;
  const asset = imageForElement(el);
  if(!asset) return null;

  const print = elementPrintSizeMm(el);
  const nextSrc = opts.src || asset.src;
  const nextNw = Math.max(1, Math.round(opts.w || asset.naturalW || 1));
  const nextNh = Math.max(1, Math.round(opts.h || asset.naturalH || 1));
  const pixelsChanged = !!(opts.src && opts.src !== asset.src);
  const sizeChanged = !samePrintSizeMm(assetStoredPrintSizeMm(asset), print);
  if(!pixelsChanged && !sizeChanged) return asset;

  const vectorChanged = !!(opts.vectorSvg || opts.vectorPdfDataUrl || opts.isVector);
  const exclusive = !isImageAssetUsedByOthers(asset.id, el.id);
  if(!pixelsChanged && !vectorChanged && exclusive && !asset.hidden && (asset.derivedFrom || vectorSourceForAsset(asset))){
    asset.printWmm = print.w;
    asset.printHmm = print.h;
    renderThumbList();
    return asset;
  }

  const newAsset = createImageAsset(nextSrc, nextVersionedAssetName(asset.name), nextNw, nextNh, {
    thumbSrc: opts.thumbSrc || (pixelsChanged ? nextSrc : (asset.thumbSrc || nextSrc)),
    printWmm: print.w,
    printHmm: print.h,
    hidden: false,
    derivedFrom: asset.derivedFrom || asset.id,
    vectorSvg: opts.vectorSvg || asset.vectorSvg || null,
    vectorPdfDataUrl: opts.vectorPdfDataUrl || asset.vectorPdfDataUrl || null,
    isVector: !!(opts.isVector || opts.vectorSvg || opts.vectorPdfDataUrl || asset.isVector || asset.vectorSvg || asset.vectorPdfDataUrl)
  });
  const vectorSource = vectorSourceForAsset(asset);
  if(vectorSource) vectorPdfSources.set(newAsset.id, vectorSource);
  el.imageId = newAsset.id;
  el.name = newAsset.name;
  el.naturalW = newAsset.naturalW;
  el.naturalH = newAsset.naturalH;
  delete el.src;
  delete el.thumbSrc;
  renderThumbList();
  return newAsset;
}

function ensureImageAssetForElement(el, opts={}){
  if(!el || isTextElement(el)) return null;
  let asset = findImageById(el.imageId);
  if(asset) return asset;
  if(!el.src) return null;
  asset = createImageAsset(
    el.src,
    el.name || 'visuel',
    el.naturalW || 1,
    el.naturalH || 1,
    {thumbSrc:el.thumbSrc || el.src, hidden:opts.hidden ?? true}
  );
  el.imageId = asset.id;
  el.name = el.name || asset.name;
  delete el.src;
  delete el.thumbSrc;
  return asset;
}

function imageForElement(el){
  if(!el || isTextElement(el)) return null;
  return ensureImageAssetForElement(el, {hidden:true});
}

function isImageAssetUsed(id){
  if(elements.some(el=>!isTextElement(el) && el.imageId === id)) return true;
  return sheets.some(sheet=>(sheet.elements || []).some(el=>!isTextElement(el) && el.imageId === id));
}

function elementSrc(el){
  return imageForElement(el)?.src || '';
}

function elementName(el){
  return imageForElement(el)?.name || el?.name || 'visuel';
}

function elementNaturalW(el){
  return imageForElement(el)?.naturalW || el?.naturalW || 1;
}

function elementNaturalH(el){
  return imageForElement(el)?.naturalH || el?.naturalH || 1;
}

function cloneElementForState(el){
  ensureImageAssetForElement(el, {hidden:true});
  const copy = JSON.parse(JSON.stringify(el || {}));
  if(!isTextElement(copy) && copy.imageId){
    delete copy.src;
    delete copy.thumbSrc;
  }
  return copy;
}

function fontFamilyCss(family){
  return `"${String(family).replaceAll('"','')}", sans-serif`;
}

function googleFontParam(family, weights='400;700'){
  return String(family).trim().replace(/\s+/g, '+') + `:wght@${weights}`;
}

function loadLocalTextFonts(){
  if(document.getElementById('local-text-fonts')) return;
  const urls = window.EDITEUR_SHERPA_LOCAL_FONTS || {};
  const faces = GOOGLE_TEXT_FONTS
    .filter(font=>font.local && urls[font.family])
    .map(font=>`@font-face{font-family:"${font.family}";src:url("${urls[font.family]}") format("truetype");font-weight:100 900;font-style:normal;font-display:swap;}`)
    .join('\n');
  if(!faces) return;
  const style = document.createElement('style');
  style.id = 'local-text-fonts';
  style.textContent = faces;
  document.head.appendChild(style);
}

function loadGoogleTextFonts(){
  if(document.getElementById('google-text-fonts-0')) return;
  const chunkSize = 24;
  const googleFonts = GOOGLE_TEXT_FONTS.filter(font=>font.google !== false);
  for(let i=0; i<googleFonts.length; i+=chunkSize){
    const chunk = googleFonts.slice(i, i + chunkSize);
    const link = document.createElement('link');
    link.id = `google-text-fonts-${Math.floor(i / chunkSize)}`;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?${chunk.map(f=>`family=${googleFontParam(f.family)}`).join('&')}&display=swap`;
    document.head.appendChild(link);
  }
}

function fontFormatFromFile(name){
  const ext = String(name || '').split('.').pop().toLowerCase();
  if(ext === 'ttf') return 'truetype';
  if(ext === 'otf') return 'opentype';
  if(ext === 'woff') return 'woff';
  if(ext === 'woff2') return 'woff2';
  return '';
}

function fontFamilyFromFileName(name){
  const base = String(name || '')
    .replace(/\.[^.]+$/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/["'\\]/g, '')
    .slice(0, 80);
  return base || 'Police importee';
}

function uniqueUploadedFamily(baseName){
  const taken = new Set([
    ...GOOGLE_TEXT_FONTS.map(font=>font.family),
    ...UPLOADED_FONTS.keys()
  ]);
  if(!taken.has(baseName)) return baseName;
  let index = 2;
  while(taken.has(`${baseName} ${index}`)) index += 1;
  return `${baseName} ${index}`;
}

function bindFontUpload(){
  const input = document.getElementById('font-upload');
  if(!input || input.dataset.bound === '1') return;
  input.dataset.bound = '1';
  input.addEventListener('change', handleFontUpload);
}

async function handleFontUpload(event){
  const file = event.target.files && event.target.files[0];
  if(!file) return;
  const format = fontFormatFromFile(file.name);
  if(!format){
    showToast('Format de police non supporté.');
    event.target.value = '';
    return;
  }
  if(file.size > MAX_UPLOADED_FONT_BYTES){
    showToast('Police trop lourde. Limite : 25 Mo.');
    event.target.value = '';
    return;
  }
  try{
    const bytes = new Uint8Array(await file.arrayBuffer());
    const kit = getPdfFontkit();
    if(kit?.create) kit.create(bytes.slice());
    const family = uniqueUploadedFamily(fontFamilyFromFileName(file.name));
    if(typeof FontFace === 'function'){
      let face;
      try{
        face = new FontFace(family, bytes, {weight:'100 900', style:'normal', display:'swap'});
      }catch{
        face = new FontFace(family, bytes, {weight:'400', style:'normal', display:'swap'});
      }
      document.fonts.add(await face.load());
    }
    UPLOADED_FONTS.set(family, {family, label:family, format, bytes});
    const name = document.getElementById('font-upload-name');
    if(name) name.textContent = family;
    chooseFont(family);
    showToast('Police importée.');
  }catch(error){
    console.error(error);
    showToast('Impossible de charger cette police.');
  }finally{
    event.target.value = '';
  }
}

function populateTextFontSelects(){
  const input = document.getElementById('prop-font');
  if(input && input.tagName === 'SELECT'){
    input.innerHTML = GOOGLE_TEXT_FONTS.map(font=>`<option value="${escapeAttr(font.family)}">${escapeHtml(font.label)}</option>`).join('');
    input.onchange = ()=>applyTextPropChange('font');
  }
  if(input && !input.value) input.value = DEFAULT_TEXT_FONT;
  updateFontPickerButton(input?.value || DEFAULT_TEXT_FONT);
}

function findTextFont(family){
  return UPLOADED_FONTS.get(family) || GOOGLE_TEXT_FONTS.find(item=>item.family === family) || null;
}

function updateFontPickerButton(family){
  const label = document.getElementById('prop-font-button-label');
  const button = document.getElementById('prop-font-button');
  const font = findTextFont(family) || findTextFont(DEFAULT_TEXT_FONT) || GOOGLE_TEXT_FONTS[0];
  if(label) label.textContent = font?.label || family || DEFAULT_TEXT_FONT;
  if(button && font) button.style.fontFamily = fontFamilyCss(font.family);
}

function getFontPreviewText(){
  const el = selected ? getEl(selected) : null;
  const source = isTextElement(el)
    ? el.text
    : document.getElementById('prop-text')?.value;
  const normalized = String(source || 'Votre texte').replace(/\s+/g, ' ').trim();
  return normalized || 'Votre texte';
}

function fontCardHtml(font, text, current){
  return `
    <button type="button" class="font-card ${font.family === current ? 'active' : ''}" data-font-family="${escapeAttr(font.family)}">
      <span class="font-card__sample" style="font-family:${escapeAttr(fontFamilyCss(font.family))}">${escapeHtml(text)}</span>
      <span class="font-card__name">${escapeHtml(font.label)}</span>
    </button>
  `;
}

function fontsMatchingQuery(fonts, query){
  if(!query) return fonts;
  return fonts.filter(font=>(font.label || font.family).toLowerCase().includes(query) || font.family.toLowerCase().includes(query));
}

function renderFontGrid(){
  const grid = document.getElementById('font-grid');
  const sample = document.getElementById('font-preview-sample');
  const search = document.getElementById('font-search');
  if(!grid) return;
  const text = getFontPreviewText();
  const current = document.getElementById('prop-font')?.value || getTextFont(getEl(selected)) || DEFAULT_TEXT_FONT;
  const query = String(search?.value || '').trim().toLowerCase();
  const uploaded = fontsMatchingQuery([...UPLOADED_FONTS.values()], query);
  const local = fontsMatchingQuery(GOOGLE_TEXT_FONTS.filter(font=>font.local), query);
  const fonts = fontsMatchingQuery(GOOGLE_TEXT_FONTS.filter(font=>!font.local), query);
  if(sample) sample.textContent = text;
  const uploadedHtml = uploaded.length
    ? `<div class="font-group-label">Polices importées</div>${uploaded.map(font=>fontCardHtml(font, text, current)).join('')}`
    : '';
  const localHtml = local.length
    ? `<div class="font-group-label">Polices Sherpa</div>${local.map(font=>fontCardHtml(font, text, current)).join('')}`
    : '';
  const catalogHtml = fonts.map(font=>fontCardHtml(font, text, current)).join('');
  grid.innerHTML = uploadedHtml || localHtml || catalogHtml
    ? uploadedHtml + localHtml + catalogHtml
    : '<div class="font-empty">Aucune police trouvée</div>';
  grid.onclick = event=>{
    const card = event.target.closest?.('.font-card[data-font-family]');
    if(!card) return;
    event.preventDefault();
    event.stopPropagation();
    chooseFont(card.dataset.fontFamily);
  };
}

function openFontModal(id=null, event=null){
  event?.preventDefault();
  event?.stopPropagation();
  if(id !== null && id !== undefined) selectElem(id);
  if(!selected || !isTextElement(getEl(selected))){
    showToast('Sélectionnez un texte pour choisir une police');
    return;
  }
  const search = document.getElementById('font-search');
  if(search){
    search.value = '';
    search.oninput = renderFontGrid;
  }
  renderFontGrid();
  document.getElementById('font-overlay')?.classList.add('open');
  requestAnimationFrame(()=>search?.focus());
}

function closeFontModal(event){
  if(event && event.target !== document.getElementById('font-overlay')) return;
  document.getElementById('font-overlay')?.classList.remove('open');
}

function chooseFont(family){
  const font = findTextFont(family);
  if(!font) return;
  const input = document.getElementById('prop-font');
  if(input) input.value = font.family;
  updateFontPickerButton(font.family);
  applyTextPropChange('font');
  closeFontModal();
}

document.addEventListener('click', event=>{
  const card = event.target.closest?.('.font-card[data-font-family]');
  if(!card) return;
  event.preventDefault();
  event.stopPropagation();
  chooseFont(card.dataset.fontFamily);
});

window.openFontModal = openFontModal;
window.closeFontModal = closeFontModal;
window.chooseFont = chooseFont;

function measureTextBox(text, family=DEFAULT_TEXT_FONT, fontSizeMm=DEFAULT_TEXT_SIZE_MM, fontWeight=400){
  const lines = String(text || 'Texte').split(/\r?\n/);
  const canvas = measureTextBox.canvas || (measureTextBox.canvas = document.createElement('canvas'));
  const ctx = canvas.getContext('2d');
  const fontPx = mm2s(fontSizeMm);
  ctx.font = `${fontWeight} ${fontPx}px ${fontFamilyCss(family)}`;
  let maxWidthPx = 0;
  let maxLineInkPx = 0;
  lines.forEach(line=>{
    const metrics = ctx.measureText(line || ' ');
    maxWidthPx = Math.max(maxWidthPx, metrics.width || 0);
    const ascent = metrics.actualBoundingBoxAscent;
    const descent = metrics.actualBoundingBoxDescent;
    if(Number.isFinite(ascent) && Number.isFinite(descent)){
      maxLineInkPx = Math.max(maxLineInkPx, ascent + descent);
    }
  });
  const width = Math.max(12, s2mm(maxWidthPx) + 6);
  // Keep enough room for ascenders/descenders so CSS never clips glyphs.
  const lineH = maxLineInkPx > 0
    ? Math.max(fontSizeMm * 1.15, s2mm(maxLineInkPx) * 1.12)
    : fontSizeMm * 1.45;
  const height = Math.max(fontSizeMm * 1.45, lines.length * lineH + Math.max(0, lines.length - 1) * fontSizeMm * 0.12);
  return {w:Math.round(width*10)/10, h:Math.round(height*10)/10};
}

function measureTextInkBox(el){
  const lines = String(el?.text || 'Texte').split(/\r?\n/);
  const fontSizeMm = el?.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  const fontWeight = getTextWeight(el);
  const rot = normalizeRotation(el?.rotation);
  const drawWmm = isQuarterTurn(rot) ? el.h : el.w;
  const fontPx = mm2s(fontSizeMm);
  const lineHeightPx = mm2s(fontSizeMm * 1.18);
  const blockHPx = lineHeightPx * lines.length;
  const padding = Math.max(16, Math.ceil(fontPx));
  const sourceCanvas = measureTextInkBox.canvas || (measureTextInkBox.canvas = document.createElement('canvas'));
  const sourceCtx = sourceCanvas.getContext('2d', {willReadFrequently:true});
  sourceCtx.font = `${fontWeight} ${fontPx}px ${fontFamilyCss(getTextFont(el))}`;
  const measuredMaxPx = Math.max(...lines.map(line=>sourceCtx.measureText(line || ' ').width), 1);
  const maxWidthPx = Math.max(1, mm2s(drawWmm || s2mm(measuredMaxPx)));
  const layoutW = Math.ceil(Math.max(measuredMaxPx, maxWidthPx) + padding * 2);
  const layoutH = Math.ceil(blockHPx + padding * 2 + fontPx * 2);
  const renderScale = Math.min(1, 1800 / Math.max(layoutW, layoutH));
  sourceCanvas.width = Math.max(1, Math.ceil(layoutW * renderScale));
  sourceCanvas.height = Math.max(1, Math.ceil(layoutH * renderScale));
  sourceCtx.setTransform(renderScale, 0, 0, renderScale, 0, 0);
  sourceCtx.clearRect(0, 0, layoutW, layoutH);
  sourceCtx.font = `${fontWeight} ${fontPx}px ${fontFamilyCss(getTextFont(el))}`;
  sourceCtx.fillStyle = '#000';
  sourceCtx.textAlign = 'left';
  sourceCtx.textBaseline = 'middle';
  const startY = layoutH / 2 - blockHPx / 2 + lineHeightPx / 2;
  lines.forEach((line, index)=>{
    sourceCtx.fillText(line || ' ', padding, startY + index * lineHeightPx);
  });
  const imageData = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
  const {data, width, height} = imageData;
  let minX = width, minY = height, maxX = -1, maxY = -1;
  for(let y=0; y<height; y++){
    for(let x=0; x<width; x++){
      if(data[(y * width + x) * 4 + 3] > 8){
        if(x < minX) minX = x;
        if(x > maxX) maxX = x;
        if(y < minY) minY = y;
        if(y > maxY) maxY = y;
      }
    }
  }
  if(maxX < minX || maxY < minY) return {w:el.w, h:el.h};
  const inkW = s2mm((maxX - minX + 1) / renderScale);
  const inkH = s2mm((maxY - minY + 1) / renderScale);
  const size = {
    w:Math.max(0.1, Math.round(inkW * 10) / 10),
    h:Math.max(0.1, Math.round(inkH * 10) / 10)
  };
  return isQuarterTurn(rot) ? {w:size.h, h:size.w} : size;
}

function getElementDisplayedSize(el){
  if(isTextElement(el)) return measureTextInkBox(el);
  return {w:el.w, h:el.h};
}

/** Real glyph ink height (cm UI "Taille"), not CSS em-size / selection box. */
function getTextCharHeightMm(el){
  if(!el || !isTextElement(el)) return DEFAULT_TEXT_SIZE_MM;
  const fontSizeMm = el.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  const family = getTextFont(el);
  const weight = getTextWeight(el);
  const firstLine = String(el.text || 'Hg').split(/\r?\n/).find(line => String(line).trim().length) || 'Hg';
  const box = measureTextBox(firstLine, family, fontSizeMm, weight);
  const ink = measureTextInkBox({
    text: firstLine,
    fontFamily: family,
    fontSizeMm,
    fontWeight: weight,
    rotation: 0,
    w: box.w,
    h: box.h
  });
  // If ink detection failed (fallback = box), approximate typical cap height.
  if(!(ink.h > 0) || ink.h >= box.h * 0.96){
    return Math.max(0.1, Math.round(fontSizeMm * 0.72 * 10) / 10);
  }
  return ink.h;
}

function setTextCharHeightMm(el, targetCharMm){
  if(!el || !isTextElement(el)) return;
  const target = Math.max(2, targetCharMm);
  const current = getTextCharHeightMm(el);
  const scale = current > 0 ? target / current : 1;
  el.fontSizeMm = Math.max(2, Math.round((el.fontSizeMm || DEFAULT_TEXT_SIZE_MM) * scale * 10) / 10);
}

function resizeTextToContent(el){
  const size = measureTextBox(el.text, getTextFont(el), el.fontSizeMm || DEFAULT_TEXT_SIZE_MM, getTextWeight(el));
  el.w = size.w;
  el.h = size.h;
}

function ensureTextFontLoaded(family, fontSizeMm=DEFAULT_TEXT_SIZE_MM, fontWeight=400){
  if(!document.fonts?.load) return Promise.resolve();
  return document.fonts.load(`${fontWeight} ${mm2s(fontSizeMm)}px ${fontFamilyCss(family)}`).catch(()=>{});
}

function resetOrderButtonState(){
  const orderBtn = document.getElementById('sherpa-order-btn');
  if(!orderBtn) return;
  orderBtn.disabled = false;
  orderBtn.removeAttribute('aria-disabled');
}

function closePdpOrderMode(){
  EDITOR_ROOT?.classList.remove('is-open');
  document.documentElement.classList.remove('sherpa-editor-open');
  document.documentElement.style.overflow = '';
  if(document.body){
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.height = '';
  }
  resetOrderButtonState();
}

function openPdpOrderMode(ctx){
  if(!EDITOR_ROOT || !isPdpEmbed) return;
  orderModeEnabled = true;
  orderContext = ctx || loadOrderContext() || orderContext;
  orderVariantId = Number(orderContext?.variantId || orderVariantId || 0) || null;
  // Keep credits for PDF download; only Continuer (order attach) is free.
  creditConfig.required = EDITOR_ROOT?.dataset.creditRequired === 'true';
  applyOrderModeUi();
  resetOrderButtonState();
  void refreshCredits();
  const startFormat = initialOrderFormatValue();
  syncOrderFormatSelect(startFormat);
  orderVariantId = resolveOrderVariantIdForFormat(startFormat) || orderVariantId;
  if(typeof changeSheetFormat === 'function' && activeSheetId != null){
    changeSheetFormat(activeSheetId, startFormat);
  } else {
    const sel = document.getElementById('format-sel');
    if(sel){
      sel.value = startFormat;
      onFormatChange();
    }
  }
  EDITOR_ROOT.classList.add('is-open');
  document.documentElement.classList.add('sherpa-editor-open');
  document.body.style.overflow = 'hidden';
  // Layout was display:none while closed — refit once the overlay is visible.
  if(typeof scheduleFitAll === 'function') scheduleFitAll();
  else requestAnimationFrame(()=>{ try{ fitAll(); }catch(_){} });
}

window.SherpaEditorPdp = {
  openOrderMode: openPdpOrderMode,
  close: closePdpOrderMode
};

function quitEditor(){
  if(isPdpEmbed){
    closePdpOrderMode();
    document.dispatchEvent(new CustomEvent('sherpa:close'));
    return;
  }
  if(notifyParent('sherpa:close')) return;
  const params = new URLSearchParams(window.location.search);
  const returnUrl = safeLocalUrl(params.get('return_url'));
  const closeUrl = safeLocalUrl(EDITOR_ROOT?.dataset.closeUrl) || '/pages/editeur-en-ligne-amalgame-dtf';
  window.location.href = returnUrl || closeUrl;
}

window.quitEditor = quitEditor;

function safeLocalUrl(value){
  if(!value) return '';
  try{
    const url = new URL(value, window.location.origin);
    if(url.origin !== window.location.origin) return '';
    return url.pathname + url.search + url.hash;
  }catch(error){
    return '';
  }
}

function normalizeRotation(rot){
  return ((Math.round(rot || 0) % 360) + 360) % 360;
}

function isQuarterTurn(rotation){
  return normalizeRotation(rotation) % 180 === 90;
}

function displayRatio(el){
  if(isTextElement(el)) return el.h / el.w;
  const nw = elementNaturalW(el);
  const nh = elementNaturalH(el);
  if(!nw || !nh) return el.h / el.w;
  return isQuarterTurn(el.rotation) ? (nw / nh) : (nh / nw);
}

function elementPixelDensity(el){
  if(isTextElement(el)) return {wPx:Infinity, hPx:Infinity};
  const rotated = isQuarterTurn(el.rotation);
  const nw = elementNaturalW(el);
  const nh = elementNaturalH(el);
  return {
    wPx: rotated ? nh : nw,
    hPx: rotated ? nw : nh
  };
}

function repairElementRotation(el){
  if(isTextElement(el) || el?.lockRotation) return;
  const nw = elementNaturalW(el);
  const nh = elementNaturalH(el);
  if(!nw || !nh || !el.w || !el.h || Math.abs(el.w - el.h) < 0.01) return;
  const actual = el.h / el.w;
  const evenRatio = nh / nw;
  const oddRatio = nw / nh;
  const evenError = Math.abs(Math.log(actual / evenRatio));
  const oddError = Math.abs(Math.log(actual / oddRatio));
  if(oddError + 0.15 < evenError && !isQuarterTurn(el.rotation)){
    el.rotation = normalizeRotation((el.rotation || 0) + 90);
  } else if(evenError + 0.15 < oddError && isQuarterTurn(el.rotation)){
    el.rotation = normalizeRotation((el.rotation || 0) - 90);
  }
}

function isLandscapeSize(w, h){
  return Number(w) > Number(h) + 0.01;
}

function rotateImageSrc90CW(src){
  return new Promise((resolve, reject)=>{
    const img = new Image();
    img.onload = ()=>{
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalHeight;
      canvas.height = img.naturalWidth;
      const ctx = canvas.getContext('2d');
      ctx.translate(canvas.width, 0);
      ctx.rotate(Math.PI / 2);
      ctx.drawImage(img, 0, 0);
      resolve({
        src: canvas.toDataURL('image/png'),
        w: canvas.width,
        h: canvas.height
      });
    };
    img.onerror = ()=>reject(new Error('Rotation image impossible'));
    img.src = src;
  });
}

async function ensureRasterMatchesPrintOrientation(src, nw, nh, printWmm, printHmm){
  const printW = Number(printWmm);
  const printH = Number(printHmm);
  if(!(printW > 0 && printH > 0 && nw > 0 && nh > 0)){
    return {src, w: nw, h: nh};
  }
  if(isLandscapeSize(printW, printH) === isLandscapeSize(nw, nh)){
    return {src, w: nw, h: nh};
  }
  // Preview/PDF sometimes arrives rotated vs declared print size — straighten pixels.
  try{
    return await rotateImageSrc90CW(src);
  }catch(error){
    console.warn('[Sherpa] orient raster failed:', error);
    return {src, w: nw, h: nh};
  }
}

function cloneRect(el){
  return {x:el.x, y:el.y, w:el.w, h:el.h, id:el.id};
}

function fitsInsideSheet(rect){
  return rect.x >= 0 && rect.y >= 0 && rect.w > 0 && rect.h > 0 &&
    rect.x + rect.w <= sheetW + 0.001 &&
    rect.y + rect.h <= sheetH + 0.001;
}

function rectsOverlap(a, b, gap=0){
  return a.x < b.x + b.w + gap &&
    a.x + a.w + gap > b.x &&
    a.y < b.y + b.h + gap &&
    a.y + a.h + gap > b.y;
}

function getLayoutGap(){
  return Math.max(0, Number.isFinite(autoGapMm) ? autoGapMm : DEFAULT_GAP_MM);
}

function isRectAvailable(rect, placed=elements, ignoreId=null, gap=null){
  if(!fitsInsideSheet(rect)) return false;
  gap = gap ?? getLayoutGap();
  return !placed.some(el => el.id !== ignoreId && rectsOverlap(rect, cloneRect(el), gap));
}

function clampElementToSheet(el){
  // Free placement: elements may sit partially or fully outside the sheet.
  // Export still crops to the sheet bounds.
  if(!el) return;
}

function findFreePosition(w, h, opts={}){
  const placed = opts.placed || elements;
  const ignoreId = opts.ignoreId ?? null;
  const gap = opts.gap ?? getLayoutGap();
  const step = opts.step || 2;
  const orientations = opts.allowRotate && Math.abs(w-h) > 0.01
    ? [{w,h,rot:0},{w:h,h:w,rot:90}]
    : [{w,h,rot:0}];
  for(const orient of orientations){
    if(orient.w > sheetW || orient.h > sheetH) continue;
    for(let y=0; y<=sheetH-orient.h+0.001; y+=step){
      for(let x=0; x<=sheetW-orient.w+0.001; x+=step){
        const rect = {x:Math.round(x*10)/10,y:Math.round(y*10)/10,w:orient.w,h:orient.h};
        if(isRectAvailable(rect, placed, ignoreId, gap)) return {...rect, rot:orient.rot};
      }
    }
  }
  return null;
}

/** Scale a print size so it fits the current sheet (optionally preferring a rotation). */
function fitSizeToSheet(w, h, rot = 0){
  const placeW = rot === 90 ? h : w;
  const placeH = rot === 90 ? w : h;
  const scale = Math.min(1, sheetW / placeW, sheetH / placeH);
  if(!(scale > 0) || !Number.isFinite(scale)){
    return {w: Math.min(w, sheetW), h: Math.min(h, sheetH), rot: 0, scaled: true};
  }
  return {
    w: Math.round(placeW * scale * 10) / 10,
    h: Math.round(placeH * scale * 10) / 10,
    rot,
    scaled: scale < 0.999
  };
}

/**
 * Resolve a free rect on the sheet. If native print size does not fit,
 * rotate and/or scale down so Mes fichiers imports are never rejected.
 */
function resolveSheetPlacement(w, h, opts={}){
  const preferNoRotate = !!opts.preferNoRotate;
  if(preferNoRotate){
    const locked = findFreePosition(w, h, {allowRotate: false});
    if(locked) return {pos: locked, lockRotation: true, scaled: false};
  }
  const free = findFreePosition(w, h, {allowRotate: true});
  if(free) return {pos: free, lockRotation: false, scaled: false};

  const candidates = [fitSizeToSheet(w, h, 0), fitSizeToSheet(w, h, 90)]
    .filter(c => c.w > 0 && c.h > 0)
    .sort((a, b) => (b.w * b.h) - (a.w * a.h));
  for(const candidate of candidates){
    const pos = findFreePosition(candidate.w, candidate.h, {allowRotate: false});
    if(pos){
      return {
        pos: {...pos, rot: candidate.rot},
        lockRotation: false,
        scaled: candidate.scaled
      };
    }
  }
  const overlap = overlappingSheetPlacement(w, h);
  return {
    pos: overlap,
    lockRotation: false,
    scaled: overlap.w < w - 0.05 || overlap.h < h - 0.05
  };
}

function fitDefaultSize(nw, nh){
  const targetW = sheetW / 3;
  const scale = Math.min(targetW / nw, sheetW / nw, sheetH / nh);
  return {w:Math.round(nw*scale*10)/10, h:Math.round(nh*scale*10)/10};
}

function parseLibraryPrintMm(fileMeta){
  const w = Number(fileMeta?.metadata?.width_mm ?? fileMeta?.width_mm);
  const h = Number(fileMeta?.metadata?.height_mm ?? fileMeta?.height_mm);
  if(!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) return null;
  return {printWmm: w, printHmm: h};
}

function orderFormatOptionIndex(){
  return optionIndexByPattern(orderContext?.optionNames, /format/);
}

function orderDelayOptionIndex(){
  return optionIndexByPattern(orderContext?.optionNames, /delai|d[eé]lai|production/);
}

function orderVariantById(id){
  const variants = Array.isArray(orderContext?.variants) ? orderContext.variants : [];
  return variants.find(v => Number(v.id) === Number(id)) || null;
}

function orderCurrentDelayValue(){
  const variant = orderVariantById(orderVariantId) || orderVariantById(orderContext?.variantId);
  const delayIdx = orderDelayOptionIndex();
  if(!variant || delayIdx < 0) return null;
  return variant.options?.[delayIdx] ?? null;
}

function forfaitFormatFromProductTitle(title){
  const t = normalizeOptionText(title);
  if(!/forfait\s+impression/.test(t)) return null;
  return formatKeyFromOption(title);
}

function selectableFormats(){
  if(orderModeEnabled){
    const available = availableOrderFormats();
    if(available.length) return available;
  }
  return FORMATS;
}

function availableOrderFormats(){
  const variants = Array.isArray(orderContext?.variants) ? orderContext.variants : [];
  const formatIdx = orderFormatOptionIndex();
  const delayIdx = orderDelayOptionIndex();
  const delayValue = orderCurrentDelayValue();
  const keys = new Set();
  variants.forEach(variant=>{
    if(delayIdx >= 0 && delayValue != null && variant.options?.[delayIdx] !== delayValue) return;
    const key = formatIdx >= 0
      ? formatKeyFromOption(variant.options?.[formatIdx])
      : formatKeyFromOption(variant.title);
    if(key) keys.add(key);
  });
  const fromVariants = FORMATS.filter(f => keys.has(f.value));
  if(fromVariants.length) return fromVariants;

  // Forfait client PDPs have no Format variant: lock to the size in the product title
  // (e.g. "Forfait Impression DTF MÈTRE", "FORFAIT IMPRESSION A2").
  const fromTitle = forfaitFormatFromProductTitle(orderContext?.productTitle);
  if(fromTitle) return FORMATS.filter(f => f.value === fromTitle);

  return [];
}

function resolveOrderVariantIdForFormat(formatValue){
  const variants = Array.isArray(orderContext?.variants) ? orderContext.variants : [];
  const formatIdx = orderFormatOptionIndex();
  const delayIdx = orderDelayOptionIndex();
  const delayValue = orderCurrentDelayValue();
  const match = variants.find(variant=>{
    if(delayIdx >= 0 && delayValue != null && variant.options?.[delayIdx] !== delayValue) return false;
    const key = formatIdx >= 0
      ? formatKeyFromOption(variant.options?.[formatIdx])
      : formatKeyFromOption(variant.title);
    return key === formatValue;
  });
  return match ? Number(match.id) : orderVariantId;
}

function initialOrderFormatValue(){
  const params = new URLSearchParams(window.location.search);
  const variantId = Number(params.get('variant') || orderContext?.variantId || 0) || null;
  if(variantId) orderVariantId = variantId;
  const variant = orderVariantById(orderVariantId);
  const formatIdx = orderFormatOptionIndex();
  const fromVariant = variant
    ? (formatIdx >= 0 ? formatKeyFromOption(variant.options?.[formatIdx]) : formatKeyFromOption(variant.title))
    : null;
  const fromUrl = params.get('sherpa_format') || orderContext?.format || null;
  const available = availableOrderFormats();
  const preferred = fromVariant || fromUrl;
  if(preferred && (!available.length || available.some(f => f.value === preferred)) && getFormat(preferred)){
    return preferred;
  }
  if(available[0]) return available[0].value;
  return preferred && getFormat(preferred) ? preferred : '420x580';
}

function syncOrderFormatSelect(selectedValue){
  const select = document.getElementById('format-sel');
  if(!select) return;
  const options = selectableFormats();
  select.innerHTML = options.map(f=>{
    const cmW = Math.round(f.w/10);
    const cmH = Math.round(f.h/10);
    return `<option value="${f.value}">${f.label} — ${cmW} × ${cmH} cm</option>`;
  }).join('');
  const value = options.some(f => f.value === selectedValue)
    ? selectedValue
    : options[0]?.value;
  if(value) select.value = value;
  select.disabled = orderModeEnabled && options.length === 1;
}

function setOrderButtonVisible(visible){
  const orderBtn = document.getElementById('sherpa-order-btn');
  if(!orderBtn) return;
  orderBtn.hidden = !visible;
  // Belt-and-suspenders: .btn { display:inline-flex } can override [hidden].
  orderBtn.style.display = visible ? '' : 'none';
}

function applyOrderModeUi(){
  if(!orderModeEnabled || !EDITOR_ROOT) return;
  EDITOR_ROOT.dataset.orderMode = 'true';
  // Continuer only on PDP embed — never on /pages/editeur-sherpa standalone.
  setOrderButtonVisible(!!isPdpEmbed);
}

function openOrderIdb(){
  return new Promise((resolve, reject)=>{
    const req = indexedDB.open(ORDER_IDB_NAME, ORDER_IDB_VERSION);
    req.onupgradeneeded = ()=>{
      const db = req.result;
      if(!db.objectStoreNames.contains(ORDER_IDB_STORE)) db.createObjectStore(ORDER_IDB_STORE);
    };
    req.onsuccess = ()=> resolve(req.result);
    req.onerror = ()=> reject(req.error || new Error('IndexedDB unavailable'));
  });
}

async function storeOrderPdfBlob(blob, filename){
  const db = await openOrderIdb();
  await new Promise((resolve, reject)=>{
    const tx = db.transaction(ORDER_IDB_STORE, 'readwrite');
    const store = tx.objectStore(ORDER_IDB_STORE);
    const req = store.put({ blob, type: blob.type || 'application/pdf', filename }, 'pending');
    req.onsuccess = ()=> resolve();
    req.onerror = ()=> reject(req.error);
  });
}

async function commandOrderToProduct(){
  if(!orderModeEnabled) return;
  saveActiveSheet();
  const sheet = sheets.find(s => s.id === activeSheetId) || sheets[0];
  if(!sheet){ showToast('Planche introuvable'); return; }
  if(!sheet.elements.length){ showToast('Ajoutez des éléments avant de commander'); return; }
  warnIfOutOfSheet(sheet.elements, sheet.w, sheet.h);

  const orderBtn = document.getElementById('sherpa-order-btn');
  if(orderBtn) orderBtn.disabled = true;
  const busyId = beginBusy('Préparation de la commande…');
  showToast('Génération du fichier…');
  try{
    const formatVal = formatValue(sheet.w, sheet.h);
    orderVariantId = resolveOrderVariantIdForFormat(formatVal) || orderVariantId;
    const blob = await buildSheetPDFBlob(sheet, busyId, 'Commande · ');
    const filename = sheetExportFileName(sheet, 'pdf');
    await storeOrderPdfBlob(blob, filename);
    const pending = {
      productHandle: orderContext?.productHandle || new URLSearchParams(window.location.search).get('product') || '',
      variantId: orderVariantId,
      filename,
      idbKey: 'pending'
    };
    sessionStorage.setItem(ORDER_PENDING_KEY, JSON.stringify(pending));
    if(orderContext){
      orderContext.variantId = orderVariantId;
      sessionStorage.setItem(ORDER_CTX_KEY, JSON.stringify(orderContext));
    }
    if(isPdpEmbed){
      showToast('Retour à la fiche produit…');
      closePdpOrderMode();
      document.dispatchEvent(new CustomEvent('sherpa:order', { detail: { pending } }));
      return;
    }
    if(notifyParent('sherpa:order', { pending })){
      showToast('Retour à la fiche produit…');
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const returnUrl = safeLocalUrl(params.get('return_url')) || safeLocalUrl(orderContext?.returnPath);
    if(!returnUrl){
      throw new Error('URL de retour introuvable');
    }
    const target = new URL(returnUrl, window.location.origin);
    target.searchParams.set('sherpa_order', '1');
    const previewThemeId = params.get('preview_theme_id');
    if(previewThemeId && !target.searchParams.get('preview_theme_id')){
      target.searchParams.set('preview_theme_id', previewThemeId);
    }
    showToast('Retour à la fiche produit…');
    window.location.href = target.pathname + target.search + target.hash;
  }catch(err){
    console.error(err);
    showToast('Erreur commande : ' + (err?.message || err));
  }finally{
    endBusy(busyId);
    // Always re-enable: embed success path used to leave the button stuck disabled.
    if(orderBtn) orderBtn.disabled = false;
  }
}

window.commandOrderToProduct = commandOrderToProduct;

// ── INIT ──
function init(){
  loadSettings();
  loadLocalTextFonts();
  loadGoogleTextFonts();
  bindFontUpload();
  populateTextFontSelects();
  applyOrderModeUi();
  // Standalone page: never show Continuer (PDP-only).
  if(!isPdpEmbed) setOrderButtonVisible(false);
  const startFormat = orderModeEnabled ? initialOrderFormatValue() : '420x580';
  if(orderModeEnabled){
    syncOrderFormatSelect(startFormat);
    orderVariantId = resolveOrderVariantIdForFormat(startFormat) || orderVariantId;
  }
  const firstSheet = createSheet('Planche 1', startFormat);
  sheets.push(firstSheet);
  activeSheetId = firstSheet.id;
  loadSheetState(firstSheet, {renderPanel:false});
  updateCanvas();
  renderSheetsPanel();
  updateCreditUI();
  void refreshCredits();
  setupZoom();
  initPdfJs();
  scheduleFitAll();
  if(!orderModeEnabled && !isPdpEmbed) setTimeout(maybeStartTutorial, 900);
}

function loadSettings(){
  const savedGap = parseFloat(localStorage.getItem('sherpa_auto_gap_mm'));
  if(Number.isFinite(savedGap) && savedGap >= 0) autoGapMm = savedGap;
  const savedChecker = localStorage.getItem('sherpa_checker_theme');
  checkerTheme = savedChecker === 'light' ? 'light' : 'dark';
  applyCheckerTheme();
  syncSettingsInputs();
}

function applyCheckerTheme(){
  document.documentElement.classList.toggle('checker-theme-light', checkerTheme === 'light');
  document.documentElement.classList.toggle('checker-theme-dark', checkerTheme !== 'light');
  const btn = document.getElementById('checker-toggle');
  if(btn){
    btn.classList.toggle('active', checkerTheme === 'light');
    btn.title = checkerTheme === 'light' ? 'Damier foncé' : 'Damier clair';
  }
}

function getCheckerColors(){
  return checkerTheme === 'light'
    ? ['#f0f0f0', '#ffffff']
    : ['#d7dbe2', '#eef1f5'];
}

function syncSettingsInputs(){
  const settingsGap = document.getElementById('setting-gap-cm');
  if(settingsGap) settingsGap.value = mm2cm(getLayoutGap());
  const autoGap = document.getElementById('margin-image');
  if(autoGap) autoGap.value = getLayoutGap();
}

function toggleCheckerTheme(){
  checkerTheme = checkerTheme === 'light' ? 'dark' : 'light';
  localStorage.setItem('sherpa_checker_theme', checkerTheme);
  applyCheckerTheme();
  if(document.getElementById('auto-overlay')?.classList.contains('open')) updateAutoPreview();
  if(document.getElementById('overview-overlay')?.classList.contains('open')) renderOverview();
}

function openSettingsModal(){
  syncSettingsInputs();
  document.getElementById('settings-overlay').classList.add('open');
}

function closeSettingsModal(e){
  if(e && e.target !== document.getElementById('settings-overlay')) return;
  document.getElementById('settings-overlay').classList.remove('open');
}

function applySettings(){
  const cm = parseFloat(document.getElementById('setting-gap-cm').value);
  autoGapMm = Math.max(0, cm2mm(Number.isFinite(cm) ? cm : 1));
  localStorage.setItem('sherpa_auto_gap_mm', String(autoGapMm));
  syncSettingsInputs();
  if(document.getElementById('auto-overlay')?.classList.contains('open')) updateAutoPreview();
  if(document.getElementById('overview-overlay')?.classList.contains('open')) renderOverview();
  closeSettingsModal();
  showToast(`Espace automatique réglé à ${mm2cm(autoGapMm)} cm ✓`);
}

function maybeStartTutorial(){
  if(localStorage.getItem(TUTORIAL_STORAGE_KEY) === '1') return;
  startTutorial(0);
}

async function refreshCredits(){
  if(!creditConfig.required){
    updateCreditUI();
    return null;
  }
  if(!creditConfig.isLoggedIn || !creditConfig.customerId){
    creditState.ready = true;
    updateCreditUI();
    return null;
  }

  creditState.loading = true;
  updateCreditUI();

  // Same source of truth as the logo / BAT editors: pmd-credits (Jetons PMD+).
  // Shopify metafield is only a fallback when the API is unreachable.
  const metafieldBalance = parseCreditBalance(EDITOR_ROOT?.dataset.creditBalance);
  try{
    const response = await fetch(
      `${creditConfig.ledgerBase}/credit/balance?customer_id=${encodeURIComponent(creditConfig.customerId)}`,
      {signal: AbortSignal.timeout(8000)}
    );
    if(response.ok){
      const data = await response.json().catch(()=>({}));
      const ledgerBalance = parseCreditBalance(data.balance ?? data);
      if(ledgerBalance !== null) creditState.balance = ledgerBalance;
      else if(metafieldBalance !== null) creditState.balance = metafieldBalance;
    }else if(creditState.balance === null){
      creditState.balance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
    }
  }catch(error){
    console.warn('Credit balance failed:', error);
    if(creditState.balance === null){
      creditState.balance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
    }
  }
  if(creditState.balance === null) creditState.balance = 0;
  creditState.ready = true;
  creditState.loading = false;
  if(EDITOR_ROOT) EDITOR_ROOT.dataset.creditBalance = String(creditState.balance);
  updateCreditUI();
  return creditState.balance;
}

async function confirmDownloadCredit(formatLabel='PDF'){
  if(!creditConfig.required) return true;
  if(!creditConfig.isLoggedIn || !creditConfig.customerId){
    redirectToLogin();
    return false;
  }
  await refreshCredits();
  if(!creditState.ready){
    showToast('Vérification des crédits impossible');
    return false;
  }

  const balance = Math.max(0, Number(creditState.balance) || 0);
  const freeDownloadAvailable = hasFreeDownloadAvailable();
  if(balance <= 0 && !freeDownloadAvailable){
    redirectToBuyCredits();
    return false;
  }

  const overlay = document.getElementById('credit-overlay');
  if(!overlay){
    return window.confirm(
      freeDownloadAvailable
        ? 'Votre premier téléchargement est offert. Aucun jeton IA ne sera consommé. Après cet essai gratuit, des jetons IA seront nécessaires pour télécharger.'
        : 'Ce téléchargement va consommer 1 jeton IA.'
    );
  }

  document.getElementById('credit-modal-title').textContent = `Télécharger ${formatLabel}`;
  document.getElementById('credit-modal-text').textContent = freeDownloadAvailable
    ? 'Votre premier téléchargement est offert. Aucun jeton IA ne sera consommé.'
    : 'Ce téléchargement va consommer 1 jeton IA.';
  document.getElementById('credit-modal-balance').textContent = freeDownloadAvailable
    ? 'Après cet essai gratuit, des jetons IA seront nécessaires pour télécharger vos prochains fichiers.'
    : `Jetons IA disponibles : ${balance}. Après téléchargement : ${Math.max(0, balance - 1)}.`;
  document.getElementById('credit-modal-confirm').textContent = freeDownloadAvailable
    ? 'Télécharger gratuitement'
    : 'Télécharger et utiliser 1 jeton IA';

  overlay.classList.add('open');
  document.getElementById('credit-modal-confirm')?.focus();
  return new Promise(resolve => {
    creditModalResolve = resolve;
  });
}

function closeCreditModal(confirmed, event){
  if(event && event.target !== document.getElementById('credit-overlay')) return;
  document.getElementById('credit-overlay')?.classList.remove('open');
  if(creditModalResolve){
    creditModalResolve(Boolean(confirmed));
    creditModalResolve = null;
  }
}

async function consumeDownloadCredit(){
  if(!creditConfig.required) return true;
  if(!creditConfig.isLoggedIn || !creditConfig.customerId){
    redirectToLogin();
    return false;
  }
  if(hasFreeDownloadAvailable()){
    markFreeDownloadUsed();
    showToast('Téléchargement test gratuit utilisé');
    updateCreditUI();
    return true;
  }
  if(!creditState.ready) await refreshCredits();
  if(!creditState.ready){
    showToast('Vérification des crédits impossible');
    return false;
  }
  if(Number(creditState.balance) <= 0){
    redirectToBuyCredits();
    return false;
  }

  const beforeBalance = Number(creditState.balance);
  creditState.consuming = true;
  updateCreditUI();
  const busyId = beginBusy('Vérification crédit…');
  try {
    const response = await fetch(`${creditConfig.ledgerBase}/credit/use`, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({customer_id:creditConfig.customerId})
    });
    if(!response.ok){
      if(response.status >= 400 && response.status < 500) redirectToBuyCredits();
      else showToast('Vérification des crédits impossible');
      return false;
    }
    const data = await response.json().catch(()=>({}));
    const responseBalance = parseCreditBalance(data.balance ?? data);
    creditState.balance = responseBalance !== null ? responseBalance : Math.max(0, beforeBalance - 1);
    creditState.ready = true;
    if(EDITOR_ROOT) EDITOR_ROOT.dataset.creditBalance = String(creditState.balance);
    updateCreditUI();
    showToast('1 crédit consommé');
    return true;
  } catch(err){
    console.warn('Credit use failed:', err);
    showToast('Vérification des crédits impossible');
    return false;
  } finally {
    creditState.consuming = false;
    endBusy(busyId);
    updateCreditUI();
  }
}

async function prepareDownloadCredit(formatLabel){
  if(!(await confirmDownloadCredit(formatLabel))) return false;
  return consumeDownloadCredit();
}

function updateCreditUI(){
  const pill = document.getElementById('editor-credit-pill');
  if(!pill) return;
  if(!creditConfig.required){
    pill.hidden = true;
    return;
  }

  const label = document.getElementById('editor-credit-label');
  const count = document.getElementById('editor-credit-count');
  const balance = Math.max(0, Number(creditState.balance) || 0);
  const freeDownloadAvailable = hasFreeDownloadAvailable();

  pill.hidden = false;
  pill.classList.toggle('is-loading', creditState.loading || creditState.consuming);
  pill.classList.toggle('is-empty', creditState.ready && !freeDownloadAvailable && balance <= 0);
  pill.classList.toggle('is-good', freeDownloadAvailable || (creditState.ready && balance > 0));

  if(!creditConfig.isLoggedIn){
    label.textContent = 'Connexion requise';
    count.textContent = '-';
    return;
  }
  if(creditState.loading && !creditState.ready){
    label.textContent = 'Crédits';
    count.textContent = '...';
    return;
  }
  if(!creditState.ready){
    label.textContent = 'Crédits';
    count.textContent = '?';
    return;
  }
  if(freeDownloadAvailable){
    label.textContent = 'Essai gratuit';
    count.textContent = '1';
    return;
  }
  label.textContent = balance > 1 ? 'Crédits' : 'Crédit';
  count.textContent = String(balance);
}

function hasFreeDownloadAvailable(){
  return creditConfig.freeDownloadEnabled &&
    creditConfig.isLoggedIn &&
    Boolean(creditConfig.customerId) &&
    !creditState.freeDownloadUsed;
}

function readFreeDownloadUsed(){
  if(!creditConfig.freeDownloadEnabled || !creditConfig.customerId) return false;
  if(creditConfig.freeDownloadUsed) return true;
  try {
    return localStorage.getItem(freeDownloadStorageKey()) === 'true';
  } catch(err){
    return false;
  }
}

function markFreeDownloadUsed(){
  creditState.freeDownloadUsed = true;
  if(EDITOR_ROOT) EDITOR_ROOT.dataset.freeDownloadUsed = 'true';
  try {
    localStorage.setItem(freeDownloadStorageKey(), 'true');
  } catch(err){
    console.warn('Free download flag failed:', err);
  }
}

function freeDownloadStorageKey(){
  return `${creditConfig.freeDownloadStoragePrefix}:${creditConfig.customerId}`;
}

function parseCreditBalance(value){
  if(value === null || typeof value === 'undefined' || value === '') return null;
  if(typeof value === 'number') return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : null;
  if(typeof value === 'string'){
    const match = value.replace(',', '.').match(/-?\d+(\.\d+)?/);
    if(!match) return null;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : null;
  }
  if(typeof value === 'object'){
    return parseCreditBalance(value.remaining ?? value.balance ?? value.credits ?? value.value ?? value.data);
  }
  return null;
}

function parseFlag(value){
  if(value === true || value === 1) return true;
  if(typeof value !== 'string') return false;
  return ['true','1','yes','oui'].includes(value.trim().toLowerCase());
}

function redirectToBuyCredits(){
  showToast("Vous n'avez plus de crédits. Le téléchargement reste dans l'éditeur.");
}

function redirectToLogin(){
  showToast("Connectez-vous pour télécharger. L'éditeur reste ouvert.");
}

function restartTutorial(){
  closeSettingsModal();
  localStorage.removeItem(TUTORIAL_STORAGE_KEY);
  setTimeout(()=>startTutorial(0), 120);
}

function startTutorial(index=0){
  tutorialIndex = Math.min(Math.max(0, index), TUTORIAL_STEPS.length - 1);
  tutorialActive = true;
  document.getElementById('tour-overlay')?.classList.add('open');
  renderTutorialStep();
}

function finishTutorial(save=true){
  tutorialActive = false;
  document.getElementById('tour-overlay')?.classList.remove('open');
  if(save) localStorage.setItem(TUTORIAL_STORAGE_KEY, '1');
}

function skipTutorial(){
  finishTutorial(true);
}

function nextTutorialStep(){
  if(tutorialIndex >= TUTORIAL_STEPS.length - 1){
    finishTutorial(true);
    return;
  }
  tutorialIndex++;
  renderTutorialStep();
}

function prevTutorialStep(){
  tutorialIndex = Math.max(0, tutorialIndex - 1);
  renderTutorialStep();
}

function getTutorialTarget(step){
  return step.selector ? document.querySelector(step.selector) : null;
}

function renderTutorialStep(){
  if(!tutorialActive) return;
  const step = TUTORIAL_STEPS[tutorialIndex];
  const overlay = document.getElementById('tour-overlay');
  const spotlight = document.getElementById('tour-spotlight');
  const card = document.getElementById('tour-card');
  const target = getTutorialTarget(step);
  if(!overlay || !spotlight || !card || !step) return;
  document.getElementById('tour-kicker').textContent = `Tutoriel ${tutorialIndex + 1}/${TUTORIAL_STEPS.length}`;
  document.getElementById('tour-title').textContent = step.title;
  document.getElementById('tour-text').textContent = step.text;
  document.getElementById('tour-count').textContent = `${tutorialIndex + 1} / ${TUTORIAL_STEPS.length}`;
  document.getElementById('tour-prev').style.display = tutorialIndex === 0 ? 'none' : '';
  document.getElementById('tour-next').textContent = tutorialIndex === TUTORIAL_STEPS.length - 1 ? 'Terminer' : 'Suivant';

  const viewportW = window.innerWidth;
  const viewportH = window.innerHeight;
  let rect;
  if(target){
    rect = target.getBoundingClientRect();
  } else {
    rect = {left:viewportW/2-60, top:viewportH/2-40, width:120, height:80, right:viewportW/2+60, bottom:viewportH/2+40};
  }
  const pad = 8;
  const spotLeft = Math.max(8, rect.left - pad);
  const spotTop = Math.max(8, rect.top - pad);
  const spotWidth = Math.min(viewportW - spotLeft - 8, rect.width + pad * 2);
  const spotHeight = Math.min(viewportH - spotTop - 8, rect.height + pad * 2);
  spotlight.style.left = spotLeft + 'px';
  spotlight.style.top = spotTop + 'px';
  spotlight.style.width = Math.max(42, spotWidth) + 'px';
  spotlight.style.height = Math.max(34, spotHeight) + 'px';

  const cardW = Math.min(330, viewportW - 32);
  const cardH = card.offsetHeight || 188;
  let left = rect.left;
  if(left + cardW > viewportW - 16) left = viewportW - cardW - 16;
  left = Math.max(16, left);
  let top = rect.bottom + 16;
  if(top + cardH > viewportH - 16) top = rect.top - cardH - 16;
  if(top < 16) top = Math.min(viewportH - cardH - 16, Math.max(16, rect.top + 16));
  card.style.left = left + 'px';
  card.style.top = top + 'px';
}

window.addEventListener('resize', ()=>{ if(tutorialActive) renderTutorialStep(); });
document.getElementById('canvas-zone')?.addEventListener('scroll', ()=>{ if(tutorialActive) renderTutorialStep(); }, {passive:true});

// ── SHEETS ──
function createSheet(name, formatValue='420x580'){
  const fmt = getFormat(formatValue) || FORMATS[0];
  return {id:nextSheetId++, name, w:fmt.w, h:fmt.h, elements:[], undoStack:[], redoStack:[]};
}

function getFormat(value){
  return FORMATS.find(f => f.value === value);
}

function getFormatBySize(w, h){
  return FORMATS.find(f => f.w === w && f.h === h);
}

function formatValue(w, h){
  return `${w}x${h}`;
}

function formatName(w, h){
  const fmt = getFormatBySize(w, h);
  return fmt ? fmt.label : `${w} × ${h} mm`;
}

function activeSheet(){
  return sheets.find(s => s.id === activeSheetId);
}

function cloneElements(list){
  return (list || []).map(el=>cloneElementForState(el));
}

function compactHistoryStack(stack){
  return (stack || []).slice(-UNDO_LIMIT).map(entry=>{
    try{
      return JSON.stringify(cloneElements(JSON.parse(entry)));
    }catch(error){
      return entry;
    }
  });
}

function saveActiveSheet(){
  const sheet = activeSheet();
  if(!sheet) return;
  sheet.w = sheetW;
  sheet.h = sheetH;
  sheet.elements = cloneElements(elements);
  sheet.undoStack = compactHistoryStack(undoStack);
  sheet.redoStack = compactHistoryStack(redoStack);
}

function loadSheetState(sheet, opts={}){
  sheetW = sheet.w;
  sheetH = sheet.h;
  elements = cloneElements(sheet.elements);
  undoStack = compactHistoryStack(sheet.undoStack);
  redoStack = compactHistoryStack(sheet.redoStack);
  selected = null;
  selectedIds.clear();
  document.getElementById('format-sel').value = formatValue(sheetW, sheetH);
  updateCanvas();
  reRenderAll();
  updatePropBar();
  updateCoverage({skipSave:true});
  updateUndoBtns();
  showEmptyHint(elements.length === 0);
  if(opts.renderPanel !== false) renderSheetsPanel();
  if(opts.fitAll) scheduleFitAll();
}

function renderSheetsPanel(){
  const list = document.getElementById('sheets-list');
  const summary = document.getElementById('sheets-summary');
  if(!list || !summary) return;
  summary.textContent = `${sheets.length} planche${sheets.length>1?'s':''}`;
  list.innerHTML = '';
  sheets.forEach((sheet, index)=>{
    const isActive = sheet.id === activeSheetId;
    const card = document.createElement('div');
    card.className = `sheet-card${isActive ? ' active' : ''}`;
    card.onclick = () => selectSheet(sheet.id);
    const deleteBtn = sheets.length > 1
      ? `<button class="sheet-mini-btn danger" onclick="deleteSheet(${sheet.id},event)" title="Supprimer la planche"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 4h10M6 4V2h4v2M5 4v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`
      : '';
    const formatsForSelect = selectableFormats();
    const formatSelectDisabled = orderModeEnabled && formatsForSelect.length === 1 ? ' disabled' : '';
    const activeControls = isActive ? `
      <div class="sheet-format-row">
        <select onclick="event.stopPropagation()" onchange="changeSheetFormat(${sheet.id},this.value)"${formatSelectDisabled}>
          ${formatsForSelect.map(f=>`<option value="${f.value}" ${formatValue(sheet.w,sheet.h)===f.value?'selected':''}>${f.label} — ${Math.round(f.w/10)} × ${Math.round(f.h/10)} cm</option>`).join('')}
        </select>
        <button class="sheet-mini-btn" onclick="duplicateSheet(${sheet.id},event)" title="Dupliquer la planche"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5" y="5" width="8" height="8" rx="1"/><path d="M3 11V3h8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      </div>` : '';
    const nameControl = isActive
      ? `<input class="sheet-name" value="${escapeAttr(sheet.name)}" onclick="event.stopPropagation()" onfocus="event.stopPropagation()" oninput="renameSheet(${sheet.id},this.value,false)" onblur="renameSheet(${sheet.id},this.value,true)" onkeydown="if(event.key==='Enter')this.blur()">`
      : `<div class="sheet-name sheet-name-static">${escapeHtml(sheet.name)}</div>`;
    const exportTitle = sheet.elements.length
      ? `Télécharger ${escapeAttr(sheet.name)} en PDF`
      : 'Ajoutez des éléments avant de télécharger';
    const saveTitle = sheet.elements.length
      ? `Sauvegarder ${escapeAttr(sheet.name)} dans Mes fichiers`
      : 'Ajoutez des éléments avant de sauvegarder';
    const exportActions = `
      <div class="sheet-export-actions">
        <button class="sheet-export-btn" onclick="exportSheetPDF(${sheet.id},event)" title="${exportTitle}" ${sheet.elements.length ? '' : 'disabled'}>
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2v8M5.5 7.5L8 10l2.5-2.5M3 12.5h10" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Télécharger en PDF
        </button>
        <button class="sheet-export-btn sheet-save-btn" onclick="saveSheetToLibrary(${sheet.id},event)" title="${saveTitle}" ${sheet.elements.length ? '' : 'disabled'}>
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.5 3.5h7l2 2V12.5h-9v-9z" stroke-linejoin="round"/><path d="M5.5 3.5v4h5v-4M5.5 12.5v-3h5v3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Sauvegarder dans Mes fichiers
        </button>
      </div>`;
    card.innerHTML = `
      <div class="sheet-main">
        <div class="sheet-chevron"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="${isActive?'M4 6l4 4 4-4':'M6 4l4 4-4 4'}" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
        <div class="sheet-content">
          ${nameControl}
          <div class="sheet-meta"><span>${formatName(sheet.w,sheet.h)}</span><span>${sheet.elements.length} élément${sheet.elements.length>1?'s':''}</span></div>
        </div>
        ${deleteBtn}
      </div>
      ${activeControls}
      ${exportActions}`;
    list.appendChild(card);
  });
}

function openOverviewModal(){
  saveActiveSheet();
  renderOverview();
  document.getElementById('overview-overlay').classList.add('open');
}

function closeOverviewModal(e){
  if(e && e.target !== document.getElementById('overview-overlay')) return;
  document.getElementById('overview-overlay').classList.remove('open');
}

function renderOverview(){
  const grid = document.getElementById('overview-grid');
  if(!grid) return;
  grid.innerHTML = '';
  sheets.forEach(sheet=>{
    const card = document.createElement('div');
    card.className = `overview-card${sheet.id === activeSheetId ? ' active' : ''}`;
    card.innerHTML = `
      <div class="overview-preview"><canvas></canvas></div>
      <div class="overview-info">
        <div style="min-width:0">
          <div class="overview-name" title="${escapeAttr(sheet.name)}">${escapeHtml(sheet.name)}</div>
          <div class="overview-meta">${formatName(sheet.w,sheet.h)} · ${sheet.elements.length} élément${sheet.elements.length>1?'s':''}</div>
        </div>
        ${sheet.id === activeSheetId ? '<span class="overview-badge">Active</span>' : ''}
      </div>`;
    grid.appendChild(card);
    drawOverviewPreview(sheet, card.querySelector('canvas'));
  });
}

function drawOverviewPreview(sheet, canvas){
  const previewW = 420;
  canvas.width = previewW;
  canvas.height = Math.max(80, Math.round(previewW * sheet.h / sheet.w));
  const ctx = canvas.getContext('2d');
  const scale = canvas.width / sheet.w;
  const [checkerA, checkerB] = getCheckerColors();
  ctx.save();
  ctx.scale(scale, scale);
  for(let x=0; x<sheet.w; x+=10) for(let y=0; y<sheet.h; y+=10){
    ctx.fillStyle = ((Math.floor(x/10)+Math.floor(y/10))%2===0)?checkerA:checkerB;
    ctx.fillRect(x,y,10,10);
  }
  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = 1 / scale;
  ctx.strokeRect(0,0,sheet.w,sheet.h);
  if(!sheet.elements.length){
    ctx.fillStyle = '#9ca3af';
    ctx.font = `${Math.max(10, 12 / scale)}px -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif`;
    ctx.textAlign = 'center';
    ctx.fillText('Planche vide', sheet.w/2, sheet.h/2);
  }
  sheet.elements.forEach(el=>{
    if(isTextElement(el)){
      drawCanvasTextElement(ctx, el);
      return;
    }
    const img = new Image();
    img.onload = ()=>{
      ctx.save();
      ctx.scale(scale, scale);
      drawImageWithRotation(ctx, img, el.x, el.y, el.w, el.h, el.rotation || 0);
      ctx.restore();
    };
    img.src = elementSrc(el);
  });
  ctx.restore();
}

function selectSheet(id){
  if(id === activeSheetId) return;
  saveActiveSheet();
  const sheet = sheets.find(s => s.id === id);
  if(!sheet) return;
  activeSheetId = id;
  loadSheetState(sheet, {fitAll:true});
}

function addSheet(){
  if(orderModeEnabled){
    showToast('Une seule planche est disponible en mode commande');
    return;
  }
  saveActiveSheet();
  const sheet = createSheet(`Planche ${sheets.length + 1}`, '420x580');
  sheets.push(sheet);
  activeSheetId = sheet.id;
  loadSheetState(sheet);
  showToast('Nouvelle planche A2 créée ✓');
}

function duplicateSheet(id, event){
  event?.stopPropagation();
  if(orderModeEnabled){
    showToast('Une seule planche est disponible en mode commande');
    return;
  }
  saveActiveSheet();
  const source = sheets.find(s => s.id === id);
  if(!source) return;
  const copy = createSheet(`${source.name} copie`, formatValue(source.w, source.h));
  copy.elements = source.elements.map(el => ({...el, id:nextId++}));
  const index = sheets.findIndex(s => s.id === id);
  sheets.splice(index + 1, 0, copy);
  activeSheetId = copy.id;
  loadSheetState(copy);
  showToast('Planche dupliquée ✓');
}

function deleteSheet(id, event){
  event?.stopPropagation();
  if(sheets.length <= 1){ showToast('Gardez au moins une planche'); return; }
  const sheet = sheets.find(s => s.id === id);
  if(sheet?.elements.length && !confirm(`Supprimer "${sheet.name}" ?`)) return;
  const index = sheets.findIndex(s => s.id === id);
  sheets.splice(index, 1);
  if(activeSheetId === id){
    const next = sheets[Math.max(0, index - 1)];
    activeSheetId = next.id;
    loadSheetState(next, {fitAll:true});
  } else {
    renderSheetsPanel();
  }
}

function renameSheet(id, value, render=true){
  const sheet = sheets.find(s => s.id === id);
  if(!sheet) return;
  sheet.name = render ? ((value || '').trim() || `Planche ${sheets.indexOf(sheet) + 1}`) : value;
  if(render) renderSheetsPanel();
}

function changeSheetFormat(id, value){
  if(orderModeEnabled){
    const allowed = availableOrderFormats();
    if(allowed.length && !allowed.some(f => f.value === value)) return;
  }
  const fmt = getFormat(value);
  const sheet = sheets.find(s => s.id === id);
  if(!fmt || !sheet) return;
  if(id === activeSheetId){
    sheetW = fmt.w;
    sheetH = fmt.h;
    document.getElementById('format-sel').value = value;
    updateCanvas();
    updateCoverage();
    saveActiveSheet();
  } else {
    sheet.w = fmt.w;
    sheet.h = fmt.h;
  }
  renderSheetsPanel();
}

function escapeAttr(str){
  return String(str).replaceAll('&','&amp;').replaceAll('"','&quot;').replaceAll('<','&lt;').replaceAll('>','&gt;');
}

function escapeHtml(str){
  return String(str).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;');
}

function updateCanvas(){
  const c = document.getElementById('canvas');
  c.style.width  = mm2s(sheetW) + 'px';
  c.style.height = mm2s(sheetH) + 'px';
  renderRulers();
  applyZoom();
}

// ── ZOOM ──
function setupZoom(){
  const zone = document.getElementById('canvas-zone');
  zone.addEventListener('wheel', e=>{
    if(e.ctrlKey || e.metaKey){
      e.preventDefault();
      const rect = zone.getBoundingClientRect();
      const localX = e.clientX - rect.left;
      const localY = e.clientY - rect.top;
      const contentX = (zone.scrollLeft + localX) / zoomLevel;
      const contentY = (zone.scrollTop + localY) / zoomLevel;
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      setZoom(zoomLevel + delta);
      zone.scrollLeft = contentX * zoomLevel - localX;
      zone.scrollTop = contentY * zoomLevel - localY;
      return;
    }
    if(e.shiftKey){
      e.preventDefault();
      zone.scrollLeft += e.deltaY + e.deltaX;
    }
  }, {passive:false});

  zone.addEventListener('mousedown', e=>{
    if(e.button !== 1 && !isSpaceDown) return;
    e.preventDefault();
    zone.classList.add('panning');
    const startX = e.clientX, startY = e.clientY;
    const startLeft = zone.scrollLeft, startTop = zone.scrollTop;
    function move(ev){
      zone.scrollLeft = startLeft - (ev.clientX - startX);
      zone.scrollTop = startTop - (ev.clientY - startY);
    }
    function up(){
      zone.classList.toggle('panning', isSpaceDown);
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseup', up);
    }
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
  });

  document.addEventListener('keydown', e=>{
    if(e.target.tagName==='INPUT'||e.target.tagName==='SELECT'||e.target.tagName==='TEXTAREA'||e.target.isContentEditable) return;
    if(e.code === 'Space'){
      isSpaceDown = true;
      zone.classList.add('panning');
      e.preventDefault();
    }
  });
  document.addEventListener('keyup', e=>{
    if(e.code === 'Space'){
      isSpaceDown = false;
      zone.classList.remove('panning');
    }
  });
}

function setZoom(z){
  zoomLevel = Math.max(0.15, Math.min(4, Math.round(z*20)/20));
  applyZoom();
}

function changeZoom(delta){
  setZoom(zoomLevel + delta);
}

function getCanvasBaseSize(){
  return {w:mm2s(sheetW)+24, h:mm2s(sheetH)+24};
}

function applyZoom(){
  const wrap = document.getElementById('canvas-scale-wrap');
  const canvas = document.getElementById('canvas');
  wrap.style.transform = `scale(${zoomLevel})`;
  wrap.style.transformOrigin = 'top left';
  canvas.style.setProperty('--zoom', zoomLevel);
  const inv = 1 / zoomLevel;
  const setUi = (name, px) => canvas.style.setProperty(name, (px * inv) + 'px');
  setUi('--select-outline', 2);
  setUi('--handle-size', 9);
  setUi('--handle-border', 2);
  setUi('--handle-radius', 2);
  setUi('--ui-gap', 6);
  setUi('--ui-border', 1);
  setUi('--actions-radius', 7);
  setUi('--tool-w', 32);
  setUi('--tool-h', 30);
  setUi('--tool-icon', 15);
  setUi('--info-gap', 6);
  setUi('--info-h', 26);
  setUi('--info-pad', 9);
  setUi('--info-radius', 4);
  setUi('--info-font', 12);
  setUi('--info-icon', 13);
  setUi('--shadow-y', 8);
  setUi('--shadow-blur', 22);
  setUi('--info-shadow-y', 6);
  setUi('--info-shadow-blur', 16);
  canvas.style.setProperty('--handle-inset', (-5 * inv) + 'px');
  canvas.style.setProperty('--checker-size', Math.max(18, 18 * inv) + 'px');
  const {w:cw, h:ch} = getCanvasBaseSize();
  wrap.style.width  = (cw * zoomLevel) + 'px';
  wrap.style.height = (ch * zoomLevel) + 'px';
  wrap.style.marginRight = '0';
  wrap.style.marginBottom = '0';
  const label = Math.round(zoomLevel*100) + '%';
  const zoomBadge = document.getElementById('zoom-badge');
  if(zoomBadge) zoomBadge.textContent = label;
  document.getElementById('zoom-value').textContent = label;
}

function resetZoom(){ setZoom(1); }

function scheduleFitAll(){
  requestAnimationFrame(()=>{
    fitAll();
    requestAnimationFrame(fitAll);
  });
  setTimeout(fitAll, 150);
}

let fitAllResizeTimer = null;
window.addEventListener('resize', ()=>{
  clearTimeout(fitAllResizeTimer);
  fitAllResizeTimer = setTimeout(fitAll, 120);
});

function fitAll(){
  const zone = document.getElementById('canvas-zone');
  const {w, h} = getCanvasBaseSize();
  const availableW = Math.max(120, zone.clientWidth - 56);
  const availableH = Math.max(120, zone.clientHeight - 56);
  setZoom(Math.min(availableW / w, availableH / h));
  zone.scrollLeft = 0;
  zone.scrollTop = 0;
}

function fitWidth(){
  const zone = document.getElementById('canvas-zone');
  const {w} = getCanvasBaseSize();
  const availableW = Math.max(120, zone.clientWidth - 56);
  setZoom(availableW / w);
  zone.scrollLeft = 0;
  zone.scrollTop = 0;
}

// ── RULERS ──
function renderRulers(){
  const wrap = document.getElementById('canvas-wrap');
  let hr = wrap.querySelector('.ruler-h'), vr = wrap.querySelector('.ruler-v'), corner = wrap.querySelector('.ruler-corner');
  if(!hr){
    corner = document.createElement('div'); corner.className='ruler-corner'; wrap.prepend(corner);
    hr = document.createElement('div'); hr.className='ruler-h'; wrap.prepend(hr);
    vr = document.createElement('div'); vr.className='ruler-v'; wrap.prepend(vr);
  }
  const W = mm2s(sheetW), H = mm2s(sheetH);
  hr.style.width = W + 'px'; hr.style.left = '24px';
  let hhtml = `<svg width="${W}" height="24" style="overflow:visible;display:block">`;
  for(let i=0; i<=sheetW; i+=50){
    const x = mm2s(i);
    hhtml += `<line x1="${x}" y1="14" x2="${x}" y2="24" stroke="#ccc" stroke-width="0.5"/>`;
    if(i>0 && i<sheetW) hhtml += `<text x="${x}" y="11" font-size="9" fill="#9ca3af" text-anchor="middle">${i}</text>`;
  }
  hhtml += '</svg>'; hr.innerHTML = hhtml;

  vr.style.height = H + 'px'; vr.style.top = '24px';
  let vhtml = `<svg height="${H}" width="24" style="overflow:visible;display:block">`;
  for(let i=0; i<=sheetH; i+=50){
    const y = mm2s(i);
    vhtml += `<line x1="14" y1="${y}" x2="24" y2="${y}" stroke="#ccc" stroke-width="0.5"/>`;
    if(i>0 && i<sheetH) vhtml += `<text x="11" y="${y+3}" font-size="9" fill="#9ca3af" text-anchor="middle" transform="rotate(-90,11,${y})">${i}</text>`;
  }
  vhtml += '</svg>'; vr.innerHTML = vhtml;
}

// ── FORMAT (select only, no manual input) ──
function onFormatChange(){
  const select = document.getElementById('format-sel');
  let formatVal = select?.value;
  if(orderModeEnabled){
    const allowed = availableOrderFormats();
    if(allowed.length && !allowed.some(f => f.value === formatVal)){
      formatVal = allowed[0].value;
      if(select) select.value = formatVal;
    }
  }
  const v = formatVal.split('x');
  sheetW = parseInt(v[0]); sheetH = parseInt(v[1]);
  if(orderModeEnabled){
    orderVariantId = resolveOrderVariantIdForFormat(formatVal) || orderVariantId;
    if(orderContext){
      orderContext.variantId = orderVariantId;
      try{ sessionStorage.setItem(ORDER_CTX_KEY, JSON.stringify(orderContext)); }catch(_){}
    }
  }
  updateCanvas();
  scheduleFitAll();
  updateCoverage();
  saveActiveSheet();
  renderSheetsPanel();
}

// ── FILE IMPORT ──
document.getElementById('file-input').addEventListener('change', e=>{
  Array.from(e.target.files).forEach(loadFile);
  e.target.value = '';
});
document.getElementById('canvas-zone').addEventListener('dragover', e=>{ e.preventDefault(); e.stopPropagation(); e.dataTransfer.dropEffect='copy'; });
document.getElementById('canvas-zone').addEventListener('drop', e=>{
  e.preventDefault();
  e.stopPropagation();
  Array.from(e.dataTransfer.files).forEach(f=>{
    // Accept all, let loadFile filter
    loadFile(f);
  });
});

// Configure pdf.js worker (use CDN)
function initPdfJs(){
  if(window.pdfjsLib){
    window.pdfjsLib.GlobalWorkerOptions.workerSrc =
      window.EDITEUR_SHERPA_PDF_WORKER_URL || 'shopify-theme/assets/pdf.worker.min.js';
  }
}

function trimTransparentImage(src){
  return new Promise(resolve=>{
    const img = new Image();
    img.onload = ()=>{
      const c = document.createElement('canvas'); c.width=img.naturalWidth; c.height=img.naturalHeight;
      const ctx = c.getContext('2d'); ctx.drawImage(img,0,0);
      const data = ctx.getImageData(0,0,c.width,c.height).data;
      let minX=c.width, minY=c.height, maxX=-1, maxY=-1;
      for(let y=0; y<c.height; y++) for(let x=0; x<c.width; x++){
        if(data[(y*c.width+x)*4+3] > 10){
          if(x<minX) minX=x; if(x>maxX) maxX=x;
          if(y<minY) minY=y; if(y>maxY) maxY=y;
        }
      }
      if(maxX < minX || maxY < minY){
        resolve({src, w:img.naturalWidth, h:img.naturalHeight, trimmed:false, cropX:0, cropY:0});
        return;
      }
      const cw=maxX-minX+1, ch=maxY-minY+1;
      if(cw === img.naturalWidth && ch === img.naturalHeight){
        resolve({src, w:img.naturalWidth, h:img.naturalHeight, trimmed:false, cropX:0, cropY:0});
        return;
      }
      const c2 = document.createElement('canvas'); c2.width=cw; c2.height=ch;
      c2.getContext('2d').drawImage(img, minX,minY,cw,ch, 0,0,cw,ch);
      resolve({src:c2.toDataURL('image/png'), w:cw, h:ch, trimmed:true, cropX:minX, cropY:minY});
    };
    img.onerror = ()=>resolve({src, w:0, h:0, trimmed:false});
    img.src = src;
  });
}

/** True when page margins are an opaque solid (typical white PDF artboard). */
function rasterHasOpaqueSolidMargins(imageData, w, h){
  const data = imageData.data;
  const samplePoints = [
    [0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1],
    [Math.floor(w / 2), 0], [Math.floor(w / 2), h - 1],
    [0, Math.floor(h / 2)], [w - 1, Math.floor(h / 2)]
  ];
  const samples = samplePoints.map(([x, y])=>{
    const i = (y * w + x) * 4;
    return [data[i], data[i + 1], data[i + 2], data[i + 3]];
  });
  if(samples.some(s => s[3] < 200)) return false; // real transparency → alpha trim only
  const avg = samples.reduce((acc, s)=>[acc[0] + s[0], acc[1] + s[1], acc[2] + s[2]], [0, 0, 0])
    .map(v => v / samples.length);
  const maxChannelDelta = Math.max(...samples.map(s =>
    Math.max(Math.abs(s[0] - avg[0]), Math.abs(s[1] - avg[1]), Math.abs(s[2] - avg[2]))
  ));
  return maxChannelDelta <= 18; // uniform margin color (white/black page)
}

/**
 * Crop empty import margins: solid page backgrounds (white PDF) via flood-fill,
 * otherwise transparent alpha trim only.
 */
function trimEmptyImportMargins(src){
  return new Promise(resolve=>{
    const img = new Image();
    img.onload = ()=>{
      const c = document.createElement('canvas');
      c.width = img.naturalWidth;
      c.height = img.naturalHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, c.width, c.height);
      if(rasterHasOpaqueSolidMargins(imageData, c.width, c.height)){
        removeSolidBackgroundImage(src).then(cleared=>{
          if(cleared.changed && cleared.w > 0 && cleared.h > 0){
            resolve({
            src: cleared.src,
            w: cleared.w,
            h: cleared.h,
            trimmed: true,
            cropX: cleared.cropX || 0,
            cropY: cleared.cropY || 0
          });
            return;
          }
          trimTransparentImage(src).then(resolve);
        });
        return;
      }
      trimTransparentImage(src).then(resolve);
    };
    img.onerror = ()=>resolve({src, w: 0, h: 0, trimmed: false});
    img.src = src;
  });
}

function removeSolidBackgroundImage(src, tolerance=42, feather=24){
  return new Promise(resolve=>{
    const img = new Image();
    img.onload = ()=>{
      const c = document.createElement('canvas'); c.width=img.naturalWidth; c.height=img.naturalHeight;
      const ctx = c.getContext('2d'); ctx.drawImage(img,0,0);
      const imageData = ctx.getImageData(0,0,c.width,c.height);
      const data = imageData.data;
      const w = c.width, h = c.height;
      const samplePoints = [[0,0],[w-1,0],[0,h-1],[w-1,h-1],[Math.floor(w/2),0],[Math.floor(w/2),h-1],[0,Math.floor(h/2)],[w-1,Math.floor(h/2)]];
      const samples = samplePoints.map(([x,y])=>{
        const i = (y*w+x)*4;
        return [data[i], data[i+1], data[i+2]];
      });
      const bg = samples.reduce((acc,s)=>[acc[0]+s[0],acc[1]+s[1],acc[2]+s[2]],[0,0,0]).map(v=>v/samples.length);
      const maxDist = Math.sqrt(255*255*3);
      function distAt(idx){
        const dr=data[idx]-bg[0], dg=data[idx+1]-bg[1], db=data[idx+2]-bg[2];
        return Math.sqrt(dr*dr+dg*dg+db*db);
      }
      const visited = new Uint8Array(w*h);
      const queue = [];
      function enqueue(x,y){
        if(x<0||y<0||x>=w||y>=h) return;
        const p = y*w+x;
        if(visited[p]) return;
        const idx = p*4;
        if(data[idx+3] < 8 || distAt(idx) <= tolerance + feather){
          visited[p] = 1;
          queue.push(p);
        }
      }
      for(let x=0; x<w; x++){ enqueue(x,0); enqueue(x,h-1); }
      for(let y=0; y<h; y++){ enqueue(0,y); enqueue(w-1,y); }
      for(let qi=0; qi<queue.length; qi++){
        const p = queue[qi], x = p % w, y = Math.floor(p / w);
        enqueue(x+1,y); enqueue(x-1,y); enqueue(x,y+1); enqueue(x,y-1);
      }
      let changed = 0;
      for(let p=0; p<visited.length; p++){
        if(!visited[p]) continue;
        const idx = p*4;
        const d = distAt(idx);
        if(d <= tolerance){
          if(data[idx+3] !== 0) changed++;
          data[idx+3] = 0;
        } else if(d <= tolerance + feather){
          const keep = (d - tolerance) / feather;
          const nextAlpha = Math.round(data[idx+3] * keep);
          if(nextAlpha < data[idx+3]) changed++;
          data[idx+3] = nextAlpha;
        }
      }
      if(!changed){
        resolve({src, w:img.naturalWidth, h:img.naturalHeight, changed:false, cropX:0, cropY:0});
        return;
      }
      ctx.putImageData(imageData,0,0);
      const transparentSrc = c.toDataURL('image/png');
      trimTransparentImage(transparentSrc).then(trimmed=>{
        resolve({
          src:trimmed.src,
          w:trimmed.w || w,
          h:trimmed.h || h,
          changed:true,
          cropX:trimmed.cropX || 0,
          cropY:trimmed.cropY || 0
        });
      });
    };
    img.onerror = ()=>resolve({src, w:0, h:0, changed:false});
    img.src = src;
  });
}

/** Top-left of the sheet, scaled down only when the element is larger than the sheet. */
function overlappingSheetPlacement(w, h){
  const fitted = fitSizeToSheet(w, h, 0);
  return {
    x: 0,
    y: 0,
    w: Math.max(0.1, fitted.w),
    h: Math.max(0.1, fitted.h),
    rot: 0
  };
}

function getNextImportPosition(w, h){
  return findFreePosition(w, h, {allowRotate:true}) || overlappingSheetPlacement(w, h);
}

/**
 * Position for a duplicate or paste. Width, height and rotation stay those of
 * the source: a free cell is used only when that exact footprint fits.
 * Otherwise the copy is offset and may overlap or sit outside the sheet.
 */
function placeCopyKeepingSize(el, placed){
  const list = placed || elements;
  const free = findFreePosition(el.w, el.h, {placed: list, allowRotate: false});
  if(free) return {x: free.x, y: free.y};
  const step = Math.max(2, getLayoutGap() || 2);
  for(let i = 1; i <= 80; i++){
    const x = Math.round((el.x + step * i) * 10) / 10;
    const y = Math.round((el.y + step * i) * 10) / 10;
    const stacked = list.some(other =>
      Math.abs((other.x || 0) - x) < 0.05 &&
      Math.abs((other.y || 0) - y) < 0.05
    );
    if(!stacked) return {x, y};
  }
  return {
    x: Math.round((el.x + step) * 10) / 10,
    y: Math.round((el.y + step) * 10) / 10
  };
}

function cloneElementCopy(el, placed){
  const pos = placeCopyKeepingSize(el, placed);
  return {
    ...el,
    id: nextId++,
    x: pos.x,
    y: pos.y,
    w: el.w,
    h: el.h,
    rotation: normalizeRotation(el.rotation || 0)
  };
}

function layoutElementsLikeTidy(list){
  const placed = [];
  const unplaced = [];
  list
    .slice()
    .sort((a,b)=>Math.max(b.w,b.h)-Math.max(a.w,a.h))
    .forEach(el=>{
      const pos = findFreePosition(el.w, el.h, {placed, allowRotate:true});
      if(!pos){ unplaced.push(el); return; }
      if(pos.rot === 90){
        const oldW = el.w;
        el.w = el.h;
        el.h = oldW;
        el.rotation = normalizeRotation((el.rotation || 0) + 90);
      }
      el.x = pos.x;
      el.y = pos.y;
      placed.push(el);
    });
  return {placed, unplaced};
}

function readFileAsDataURL(file){
  return new Promise((resolve, reject)=>{
    const reader = new FileReader();
    reader.onload = ev => resolve(ev.target.result);
    reader.onerror = () => reject(new Error('Lecture du fichier impossible'));
    reader.readAsDataURL(file);
  });
}

function loadImageMeta(src){
  return new Promise((resolve, reject)=>{
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Image illisible'));
    img.src = src;
  });
}

function createImageThumbnail(src, maxSize=THUMB_MAX_SIZE){
  return loadImageMeta(src).then(img=>{
    const scale = Math.min(1, maxSize / Math.max(img.naturalWidth || 1, img.naturalHeight || 1));
    if(scale >= 0.999) return src;
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const ctx = canvas.getContext('2d', {alpha:true});
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/webp', 0.82);
  }).catch(()=>src);
}

function warnHeavyFile(file){
  if(file.size > MAX_IMPORT_FILE_BYTES){
    showToast(`${file.name} est trop lourd (${Math.round(file.size/1024/1024)} Mo). Réduisez le fichier avant import.`);
    return false;
  }
  if(file.size > WARN_IMPORT_FILE_BYTES){
    showToast(`${file.name} est lourd (${Math.round(file.size/1024/1024)} Mo). L’éditeur peut ralentir.`);
  }
  return true;
}

function canUseImagePixels(name, w, h){
  const pixels = (w || 0) * (h || 0);
  if(pixels > MAX_IMPORT_IMAGE_PIXELS){
    showToast(`${name} est trop grand (${Math.round(pixels/1000000)} Mpx). Réduisez la résolution avant import.`);
    return false;
  }
  if(pixels > WARN_IMPORT_IMAGE_PIXELS){
    showToast(`${name} est très grand (${Math.round(pixels/1000000)} Mpx). L’éditeur peut ralentir.`);
  }
  return true;
}

function mmToPrintPx(mm, dpi=EXPORT_DPI){
  return Math.ceil((Math.max(0, Number(mm) || 0) / 25.4) * dpi);
}

/**
 * Print-safe caps: only discard pixels that cannot improve a 300 DPI print
 * on the current sheet (or declared print size). PNG only — no lossy webp.
 */
function workingRasterLimits(printWmm, printHmm){
  const sheetMaxMm = Math.max(Number(sheetW) || 420, Number(sheetH) || 580);
  const sheetMinMm = Math.min(Number(sheetW) || 420, Number(sheetH) || 580);
  let maxEdge = mmToPrintPx(sheetMaxMm, EXPORT_DPI);
  let maxPixels = mmToPrintPx(sheetMaxMm, EXPORT_DPI) * mmToPrintPx(sheetMinMm, EXPORT_DPI);

  const printW = Number(printWmm);
  const printH = Number(printHmm);
  if(printW > 0 && printH > 0){
    const needW = Math.ceil(mmToPrintPx(printW, EXPORT_DPI) * 1.15);
    const needH = Math.ceil(mmToPrintPx(printH, EXPORT_DPI) * 1.15);
    maxEdge = Math.max(needW, needH);
    maxPixels = needW * needH;
    maxEdge = Math.min(maxEdge, mmToPrintPx(sheetMaxMm, EXPORT_DPI));
    maxPixels = Math.min(
      maxPixels,
      mmToPrintPx(sheetMaxMm, EXPORT_DPI) * mmToPrintPx(sheetMinMm, EXPORT_DPI)
    );
  }

  maxEdge = Math.min(Math.max(maxEdge, 2048), 12000);
  maxPixels = Math.min(Math.max(maxPixels, 4_000_000), EXPORT_MAX_IMAGE_PIXELS);
  return {maxEdge, maxPixels};
}

function canvasToWorkingDataURL(canvas){
  return canvas.toDataURL('image/png');
}

/** Downscale a raster under maxPixels and/or maxEdge (file Ko is irrelevant). */
async function downsampleImageSrc(src, maxPixels, maxEdge){
  const fallback = workingRasterLimits();
  if(!(maxPixels > 0)) maxPixels = fallback.maxPixels;
  if(!(maxEdge > 0)) maxEdge = fallback.maxEdge;
  const img = await loadImageMeta(src);
  const w = img.naturalWidth || 0;
  const h = img.naturalHeight || 0;
  const pixels = w * h;
  if(!(w > 0 && h > 0)){
    return {src, w, h, scaled:false, fromPixels:pixels};
  }
  const scale = Math.min(
    1,
    maxEdge / Math.max(w, h),
    Math.sqrt(maxPixels / Math.max(1, pixels))
  );
  if(scale >= 0.999){
    return {src, w, h, scaled:false, fromPixels:pixels};
  }
  const nw = Math.max(1, Math.round(w * scale));
  const nh = Math.max(1, Math.round(h * scale));
  const canvas = document.createElement('canvas');
  canvas.width = nw;
  canvas.height = nh;
  const ctx = canvas.getContext('2d', {alpha:true});
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  let drew = false;
  if(typeof createImageBitmap === 'function'){
    try{
      const bmp = await createImageBitmap(img, {resizeWidth:nw, resizeHeight:nh, resizeQuality:'high'});
      ctx.drawImage(bmp, 0, 0);
      bmp.close?.();
      drew = true;
    }catch(_err){ drew = false; }
  }
  if(!drew) ctx.drawImage(img, 0, 0, nw, nh);
  return {
    src: canvasToWorkingDataURL(canvas),
    w: nw,
    h: nh,
    scaled: true,
    fromPixels: pixels,
    toPixels: nw * nh
  };
}

/** Drop only pixels useless beyond sheet/print @ 300 DPI. */
async function prepareWorkingRaster(src, nw, nh, opts={}){
  const {maxEdge, maxPixels} = workingRasterLimits(opts.printWmm, opts.printHmm);
  const w = Math.max(1, Math.round(nw || 0));
  const h = Math.max(1, Math.round(nh || 0));
  if(w <= maxEdge && h <= maxEdge && w * h <= maxPixels){
    return {src, w, h, scaled:false};
  }
  return downsampleImageSrc(src, maxPixels, maxEdge);
}

async function loadFile(file, opts={}){
  const ext = file.name.split('.').pop().toLowerCase();
  const isPDF = ext==='pdf' || ext==='ai' || file.type==='application/pdf' || file.type==='application/illustrator';
  if(!['png','jpg','jpeg','webp','pdf','ai'].includes(ext) && !file.type.startsWith('image/')){
    showToast('Format non supporté : ' + file.name); return;
  }
  if(!warnHeavyFile(file)) return;
  const busyId = beginBusy(isPDF ? `Préparation de ${file.name}…` : `Chargement de ${file.name}…`);
  try {
    if(isPDF){
      await rasterizePDF(file, busyId, opts);
      return;
    }
    let src = await readFileAsDataURL(file);
    updateBusy(busyId, `Analyse de ${file.name}…`);
    let img = await loadImageMeta(src);
    const pixels = (img.naturalWidth || 0) * (img.naturalHeight || 0);
    const limits = workingRasterLimits(opts.printWmm, opts.printHmm);
    // Only shrink when source exceeds what a 300 DPI print on this sheet can use.
    if(pixels > limits.maxPixels || Math.max(img.naturalWidth, img.naturalHeight) > limits.maxEdge){
      updateBusy(busyId, `Optimisation de ${file.name}…`);
      const reduced = await prepareWorkingRaster(src, img.naturalWidth, img.naturalHeight, opts);
      if(reduced.scaled){
        src = reduced.src;
        img = {naturalWidth: reduced.w, naturalHeight: reduced.h};
        showToast(
          `${file.name} : ${Math.round(pixels/1000000)} Mpx → ${Math.round((reduced.w*reduced.h)/1000000)} Mpx (sans perte @ 300 DPI planche)`
        );
      }
    }
    // Keep full frame when print size is known (saved planches) — trimming would distort placement.
    const hasPrintSize = Number(opts.printWmm) > 0 && Number(opts.printHmm) > 0;
    const prepared = hasPrintSize
      ? {src, w: img.naturalWidth, h: img.naturalHeight}
      : await trimTransparentImage(src);
    updateBusy(busyId, `Ajout de ${file.name}…`);
    await addToLibrary(
      prepared.src,
      file.name,
      prepared.w || img.naturalWidth,
      prepared.h || img.naturalHeight,
      {printWmm: opts.printWmm, printHmm: opts.printHmm}
    );
  } catch(err){
    console.error('Import error:', err);
    showToast('Erreur import : ' + err.message);
  } finally {
    endBusy(busyId);
  }
}

function vectorSourceForAsset(asset){
  if(!asset) return null;
  return vectorPdfSources.get(asset.id) || null;
}

function rememberVectorPdf(assetId, source){
  if(assetId && source) vectorPdfSources.set(assetId, source);
}

async function pdfPageForSource(source){
  let pdfDoc = vectorPdfDocs.get(source.docId);
  if(!pdfDoc){
    pdfDoc = await window.pdfjsLib.getDocument({data: source.bytes.slice(0)}).promise;
    vectorPdfDocs.set(source.docId, pdfDoc);
  }
  return pdfDoc.getPage(source.pageNumber);
}

function vectorRasterPixels(widthMm, heightMm){
  let w = Math.max(1, Math.round((Math.max(0, Number(widthMm) || 0) / 25.4) * EXPORT_DPI));
  let h = Math.max(1, Math.round((Math.max(0, Number(heightMm) || 0) / 25.4) * EXPORT_DPI));
  if(w * h > VECTOR_RASTER_MAX_PIXELS){
    const s = Math.sqrt(VECTOR_RASTER_MAX_PIXELS / (w * h));
    w = Math.max(1, Math.round(w * s));
    h = Math.max(1, Math.round(h * s));
  }
  return {w, h};
}

function vectorExportDpi(el){
  const physicalW = isQuarterTurn(el.rotation) ? el.h : el.w;
  const physicalH = isQuarterTurn(el.rotation) ? el.w : el.h;
  const full = {
    w: Math.max(1, Math.round((physicalW / 25.4) * EXPORT_DPI)),
    h: Math.max(1, Math.round((physicalH / 25.4) * EXPORT_DPI))
  };
  const target = vectorRasterPixels(physicalW, physicalH);
  if(target.w === full.w && target.h === full.h) return EXPORT_DPI;
  const dpiW = physicalW > 0 ? target.w / (physicalW / 25.4) : 0;
  const dpiH = physicalH > 0 ? target.h / (physicalH / 25.4) : 0;
  return Math.round(Math.min(dpiW, dpiH));
}

async function renderPdfCropCanvas(page, cropPt, widthPx, heightPx){
  const cropW = Math.max(0.01, Number(cropPt?.w) || 0.01);
  const cropH = Math.max(0.01, Number(cropPt?.h) || 0.01);
  const scale = Math.min(widthPx / cropW, heightPx / cropH);
  const viewport = page.getViewport({scale});
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(cropW * scale));
  canvas.height = Math.max(1, Math.round(cropH * scale));
  const ctx = canvas.getContext('2d', {alpha:true});
  ctx.translate(-(Number(cropPt?.x) || 0) * scale, -(Number(cropPt?.y) || 0) * scale);
  await page.render({canvasContext: ctx, viewport, background: 'transparent'}).promise;
  return canvas;
}

const vectorSharpenTokens = new WeakMap();

async function sharpenVectorElement(el){
  if(!el || isTextElement(el) || !window.pdfjsLib) return;
  const asset = imageForElement(el);
  const source = vectorSourceForAsset(asset);
  if(!source) return;
  const physicalW = isQuarterTurn(el.rotation) ? el.h : el.w;
  const physicalH = isQuarterTurn(el.rotation) ? el.w : el.h;
  const target = vectorRasterPixels(physicalW, physicalH);
  if(Math.abs(target.w - (asset.naturalW || 0)) <= 2 && Math.abs(target.h - (asset.naturalH || 0)) <= 2) return;
  const token = (vectorSharpenTokens.get(el) || 0) + 1;
  vectorSharpenTokens.set(el, token);
  try {
    const page = await pdfPageForSource(source);
    const canvas = await renderPdfCropCanvas(page, source.crop, target.w, target.h);
    if(vectorSharpenTokens.get(el) !== token) return;
    const live = imageForElement(el);
    const liveSource = vectorSourceForAsset(live);
    if(!live || !liveSource || liveSource.docId !== source.docId || liveSource.pageNumber !== source.pageNumber) return;
    const src = canvasToWorkingDataURL(canvas);
    const thumbSrc = await createImageThumbnail(src);
    if(vectorSharpenTokens.get(el) !== token) return;
    live.src = src;
    live.naturalW = canvas.width;
    live.naturalH = canvas.height;
    live.thumbSrc = thumbSrc;
    el.naturalW = canvas.width;
    el.naturalH = canvas.height;
    document.querySelectorAll('.elem').forEach(node=>{
      const item = getEl(node.dataset.id);
      if(!item || item.imageId !== live.id) return;
      const img = node.querySelector('img');
      if(img) img.src = src;
    });
    renderThumbList();
    updateElemContext(el);
  } catch(err){
    console.warn('Vector re-render failed', err);
  }
}

async function rasterizePDF(file, busyId=null, opts={}){
  const ownBusyId = busyId || beginBusy(`Rendu de ${file.name}…`);
  if(!window.pdfjsLib){
    showToast('pdf.js non chargé — vérifiez votre connexion internet');
    if(!busyId) endBusy(ownBusyId);
    return;
  }
  showToast('Rendu du PDF en cours…');
  try {
    const arrayBuffer = await file.arrayBuffer();
    const storedBytes = arrayBuffer.slice(0);
    updateBusy(ownBusyId, `Lecture de ${file.name}…`);
    const docId = ++vectorPdfDocSeq;
    const pdfDoc = await window.pdfjsLib.getDocument({data: storedBytes.slice(0)}).promise;
    vectorPdfDocs.set(docId, pdfDoc);
    const numPages = pdfDoc.numPages;
    showToast(`PDF: ${numPages} page${numPages>1?'s':''} détectée${numPages>1?'s':''}. Import de toutes les pages…`);
    if(numPages > 8) showToast(`${numPages} pages à importer : l’opération peut prendre du temps.`);

    for(let pageNum = 1; pageNum <= numPages; pageNum++){
      updateBusy(ownBusyId, `Rendu PDF ${pageNum}/${numPages}…`);
      const page = await pdfDoc.getPage(pageNum);
      const baseViewport = page.getViewport({scale:1});
      const pagePtW = baseViewport.width;
      const pagePtH = baseViewport.height;
      const hasPrintSize = Number(opts.printWmm) > 0 && Number(opts.printHmm) > 0;
      let crop = {x:0, y:0, w:pagePtW, h:pagePtH};
      let printWmm = Number(opts.printWmm);
      let printHmm = Number(opts.printHmm);
      if(!hasPrintSize){
        let detectScale = PDF_IMPORT_DPI / 72;
        const desiredPixels = pagePtW * detectScale * pagePtH * detectScale;
        if(desiredPixels > PDF_IMPORT_MAX_PIXELS){
          detectScale = Math.sqrt(PDF_IMPORT_MAX_PIXELS / (pagePtW * pagePtH));
          showToast(`Page ${pageNum} très grande : rendu optimisé pour préserver le navigateur.`);
        }
        const detectViewport = page.getViewport({scale: detectScale});
        const detectCanvas = document.createElement('canvas');
        detectCanvas.width = Math.max(1, Math.round(detectViewport.width));
        detectCanvas.height = Math.max(1, Math.round(detectViewport.height));
        const detectCtx = detectCanvas.getContext('2d', {alpha:true});
        await page.render({canvasContext: detectCtx, viewport: detectViewport, background: 'transparent'}).promise;
        const prepared = await trimEmptyImportMargins(canvasToWorkingDataURL(detectCanvas));
        const cropX = prepared.cropX || 0;
        const cropY = prepared.cropY || 0;
        const cropW = prepared.w > 0 ? prepared.w : detectCanvas.width;
        const cropH = prepared.h > 0 ? prepared.h : detectCanvas.height;
        crop = {
          x: cropX / detectScale,
          y: cropY / detectScale,
          w: cropW / detectScale,
          h: cropH / detectScale
        };
        printWmm = Math.round(crop.w * 25.4 / 72 * 100) / 100;
        printHmm = Math.round(crop.h * 25.4 / 72 * 100) / 100;
      }
      const previewPx = vectorRasterPixels(printWmm, printHmm);
      const previewCanvas = await renderPdfCropCanvas(page, crop, previewPx.w, previewPx.h);
      const pageName = numPages > 1
        ? file.name.replace(/\.[^.]+$/, '') + `-p${pageNum}.pdf`
        : file.name;
      await addToLibrary(canvasToWorkingDataURL(previewCanvas), pageName, previewCanvas.width, previewCanvas.height, {
        printWmm,
        printHmm,
        vectorPdf: {docId, bytes: storedBytes, pageNumber: pageNum, crop}
      });
    }
  } catch(err){
    console.error('PDF render error:', err);
    showToast('Erreur rendu PDF : ' + err.message);
  } finally {
    if(!busyId) endBusy(ownBusyId);
  }
}

async function addToLibrary(src, name, nw, nh, opts={}){
  const hasPrintSize = Number(opts.printWmm) > 0 && Number(opts.printHmm) > 0;
  let finalSrc = src;
  let finalW = nw;
  let finalH = nh;
  if(hasPrintSize){
    const oriented = await ensureRasterMatchesPrintOrientation(src, nw, nh, opts.printWmm, opts.printHmm);
    finalSrc = oriented.src;
    finalW = oriented.w;
    finalH = oriented.h;
  }
  // Raster imports stay within the sheet budget. Vector files keep the 300 DPI
  // render so the on-screen image matches the downloaded PDF.
  if(!opts.vectorPdf){
    const working = await prepareWorkingRaster(finalSrc, finalW, finalH, opts);
    finalSrc = working.src;
    finalW = working.w;
    finalH = working.h;
  }
  const thumbSrc = await createImageThumbnail(finalSrc);
  const img = createImageAsset(finalSrc, name, finalW, finalH, {
    thumbSrc,
    printWmm: opts.printWmm,
    printHmm: opts.printHmm
  });
  if(opts.vectorPdf) rememberVectorPdf(img.id, opts.vectorPdf);
  renderThumbList();
  const size = placeSizeForImage(finalW, finalH, img.printWmm, img.printHmm);
  // Prefer declared Mes fichiers orientation, but rotate/scale if it cannot fit the sheet.
  // (Previous fallback placed oversized rects that addElem rejected → thumb without composition.)
  const placement = resolveSheetPlacement(size.w, size.h, {preferNoRotate: hasPrintSize});
  const pos = placement.pos;
  if(!pos){
    showToast(`Pas assez de place pour ajouter ${img.name}`);
    return;
  }
  if(placement.scaled){
    showToast(`${img.name} : réduit pour tenir sur la planche`);
  }
  const el = {
    id:nextId++,
    imageId:img.id,
    name:img.name,
    naturalW:img.naturalW,
    naturalH:img.naturalH,
    x:pos.x,
    y:pos.y,
    w:pos.w,
    h:pos.h,
    rotation: placement.lockRotation ? 0 : (pos.rot || 0),
    locked:true,
    lockRotation: placement.lockRotation
  };
  const placed = addElem(el);
  if(!placed){
    showToast(`Impossible d’ajouter ${img.name} sur cette planche`);
    return;
  }
  if(opts.vectorPdf) await sharpenVectorElement(el);
}

// ── THUMB LIST ──
function renderThumbList(){
  const list = document.getElementById('thumb-list');
  const empty = document.getElementById('thumb-empty');
  list.querySelectorAll('.thumb-item').forEach(n=>n.remove());
  const libraryImages = visibleImages();
  if(libraryImages.length === 0){ if(empty) empty.style.display=''; return; }
  if(empty) empty.style.display = 'none';
  libraryImages.forEach(img=>{
    const d = document.createElement('div'); d.className='thumb-item'; d.dataset.id=img.id;
    const dimLabel = imageAssetPrintSizeLabel(img);
    const dimTitle = img.printWmm > 0 && img.printHmm > 0
      ? `${img.printWmm} × ${img.printHmm} mm`
      : `${img.naturalW}×${img.naturalH}px à 300 DPI`;
    d.innerHTML = `<img class="thumb-img" src="${img.thumbSrc || img.src}" alt=""><div class="thumb-info"><div class="thumb-name">${escapeHtml(img.name)}</div><div class="thumb-dim" title="${escapeAttr(dimTitle)}">${dimLabel}</div></div><button class="thumb-del" onclick="removeFromLib(${img.id},event)"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 2l8 8M10 2L2 10" stroke-linecap="round"/></svg></button>`;
    d.addEventListener('click', ()=>{ addElemFromLib(img); });
    list.appendChild(d);
  });
}

function removeFromLib(id, e){
  e.stopPropagation();
  if(isImageAssetUsed(id)) images.forEach(img=>{ if(img.id === id) img.hidden = true; });
  else images = images.filter(i => i.id !== id);
  renderThumbList();
}

function addElemFromLib(img){
  const size = placeSizeForImage(img.naturalW, img.naturalH, img.printWmm, img.printHmm);
  const hasPrintSize = Number(img.printWmm) > 0 && Number(img.printHmm) > 0;
  const placement = resolveSheetPlacement(size.w, size.h, {preferNoRotate: hasPrintSize});
  const pos = placement.pos;
  if(!pos){ showToast(`Pas assez de place pour ajouter ${img.name}`); return; }
  if(placement.scaled){
    showToast(`${img.name} : réduit pour tenir sur la planche`);
  }
  addElem({
    id:nextId++,
    imageId:img.id,
    name:img.name,
    naturalW:img.naturalW,
    naturalH:img.naturalH,
    x:pos.x,
    y:pos.y,
    w:pos.w,
    h:pos.h,
    rotation: placement.lockRotation ? 0 : (pos.rot || 0),
    locked:true,
    lockRotation: placement.lockRotation
  });
}

function addTextElement(){
  const el = {
    id:nextId++,
    type:'text',
    text:'Votre texte',
    name:'Texte',
    fontFamily:DEFAULT_TEXT_FONT,
    fontSizeMm:DEFAULT_TEXT_SIZE_MM,
    fontWeight:400,
    align:'left',
    color:DEFAULT_TEXT_COLOR,
    x:0,
    y:0,
    w:0,
    h:0,
    rotation:0,
    locked:true
  };
  resizeTextToContent(el);
  const pos = getNextImportPosition(el.w, el.h);
  if(!pos){ showToast('Pas assez de place pour ajouter le texte'); return; }
  el.x = pos.x;
  el.y = pos.y;
  el.w = pos.w;
  el.h = pos.h;
  el.rotation = pos.rot;
  ensureTextFontLoaded(el.fontFamily, el.fontSizeMm, getTextWeight(el)).finally(()=>addElem(el));
}

// ── ELEMENTS ──
function addElem(el){
  ensureImageAssetForElement(el, {hidden:false});
  repairElementRotation(el);
  el.rotation = normalizeRotation(el.rotation);
  clampElementToSheet(el);
  // A full sheet must not block a new logo or text. The element is appended
  // last, so it is painted on top of whatever it overlaps.
  pushUndo();
  elements.push(el);
  renderElem(el);
  selectElem(el.id);
  focusElementInView(el.id);
  updateCoverage();
  renderSheetsPanel();
  showEmptyHint(false);
  return true;
}

function focusElementInView(id){
  requestAnimationFrame(()=>{
    const div = document.querySelector(`.elem[data-id="${id}"]`);
    if(div) div.scrollIntoView({block:'center', inline:'center', behavior:'smooth'});
  });
}

function getElemDpi(el){
  if(isTextElement(el)) return Infinity;
  const px = elementPixelDensity(el);
  const dpiW = el.w > 0 ? px.wPx / (el.w / 25.4) : 0;
  const dpiH = el.h > 0 ? px.hPx / (el.h / 25.4) : 0;
  return Math.round(Math.min(dpiW, dpiH));
}

function elemInfoHtml(el){
  if(isTextElement(el)){
    const realSize = getElementDisplayedSize(el);
    const wCm = mm2cm(realSize.w).toFixed(1);
    const hCm = mm2cm(realSize.h).toFixed(1);
    return `<span>Taille réelle ${wCm} × ${hCm} cm</span><span>·</span><span>${escapeHtml(getTextFont(el))}</span><span>·</span><span>Texte vectorisé</span>`;
  }
  const asset = imageForElement(el);
  const wCm = mm2cm(el.w).toFixed(1);
  const hCm = mm2cm(el.h).toFixed(1);
  if(asset?.isVector || asset?.vectorPdfDataUrl || asset?.vectorSvg){
    return `<span>${wCm} cm × ${hCm} cm</span><span>·</span><span>Vectoriel IA</span>`;
  }
  const fromVector = !!vectorSourceForAsset(asset);
  const dpi = fromVector ? vectorExportDpi(el) : getElemDpi(el);
  const cls = dpi >= 300 ? 'dpi-ok' : (dpi >= 200 ? 'dpi-warn' : 'dpi-bad');
  const dpiLabel = fromVector || dpi < 300 ? `${dpi} DPI` : '300+ DPI';
  return `<span>${wCm} cm × ${hCm} cm</span><span>·</span><span>${elementNaturalW(el)}×${elementNaturalH(el)}px</span><span>·</span><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M13 5l-5.8 5.8L4.5 8.1 2 10.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 5h4v4" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="${cls}">${dpiLabel}</span>`;
}

function updateElemContext(el){
  const div = document.querySelector(`.elem[data-id="${el.id}"]`);
  const info = div?.querySelector('.elem-info');
  if(info) info.innerHTML = elemInfoHtml(el);
}

function renderElem(el){
  const existing = document.querySelector(`.elem[data-id="${el.id}"]`);
  if(existing) existing.remove();
  repairElementRotation(el);
  el.rotation = normalizeRotation(el.rotation);
  const div = document.createElement('div');
  div.className = 'elem' + (isTextElement(el) ? ' is-text' : ''); div.dataset.id = el.id;
  div.style.cssText = `left:${mm2s(el.x)}px;top:${mm2s(el.y)}px;width:${mm2s(el.w)}px;height:${mm2s(el.h)}px`;
  const visual = document.createElement('div');
  visual.className = 'elem-visual';
  if(isTextElement(el)){
    const textVisual = document.createElement('div');
    textVisual.className = 'text-visual';
    textVisual.innerHTML = `<span>${escapeHtml(el.text || 'Texte')}</span>`;
    applyTextStyle(textVisual, el);
    visual.appendChild(textVisual);
  } else {
    const img = document.createElement('img'); img.src = elementSrc(el); img.draggable = false;
    applyImageRotationStyle(img, el);
    visual.appendChild(img);
  }
  div.appendChild(visual);
  const handles = document.createElement('div'); handles.className = 'handles';
  ['nw','n','ne','w','e','sw','s','se'].forEach(p=>{
    const h = document.createElement('div'); h.className = `handle ${p}`; h.dataset.handle = p;
    h.addEventListener('mousedown', ev => startResize(ev, el.id, p));
    handles.appendChild(h);
  });
  div.appendChild(handles);
  const actions = document.createElement('div');
  actions.className = 'elem-actions';
  const textAlign = isTextElement(el) ? getTextAlign(el) : 'left';
  const middleTool = isTextElement(el) ? `
    <button class="elem-tool" title="Police" onclick="openFontModal(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 12.5 6.5 3h1L11 12.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.4 9.2h5.2" stroke-linecap="round"/><path d="M11.5 6.5h2.5M12.75 5.25v2.5" stroke-linecap="round"/></svg>
    </button>
    <button class="elem-tool text-bold-tool ${getTextWeight(el) >= 700 ? 'is-active' : ''}" title="Gras" onclick="toggleTextBoldById(${el.id},event)">
      <svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M4.2 2.2h4.4c1.1 0 2 .25 2.6.76.62.5.92 1.2.92 2.08 0 .55-.14 1.02-.43 1.43-.28.4-.69.7-1.22.91.69.17 1.23.5 1.6.98.38.48.57 1.07.57 1.78 0 .99-.32 1.76-.96 2.29-.64.53-1.56.8-2.76.8H4.2V2.2Zm2.45 4.46h1.78c.39 0 .69-.09.91-.27.22-.18.33-.44.33-.78 0-.37-.12-.64-.36-.81-.24-.17-.61-.25-1.1-.25H6.65v2.11Zm0 2.04v2.18h1.95c.49 0 .86-.09 1.11-.28.25-.19.38-.48.38-.87 0-.69-.42-1.03-1.26-1.03H6.65Z"/></svg>
    </button>
    <span class="text-align-tools" role="group" aria-label="Alignement du texte">
      <button class="elem-tool text-align-tool ${textAlign === 'left' ? 'is-active' : ''}" title="Aligner à gauche" onclick="setTextAlignById(${el.id},'left',event)">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2.5 4h11M2.5 8h7M2.5 12h9" stroke-linecap="round"/></svg>
      </button>
      <button class="elem-tool text-align-tool ${textAlign === 'center' ? 'is-active' : ''}" title="Centrer" onclick="setTextAlignById(${el.id},'center',event)">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2.5 4h11M4.5 8h7M3.5 12h9" stroke-linecap="round"/></svg>
      </button>
      <button class="elem-tool text-align-tool ${textAlign === 'right' ? 'is-active' : ''}" title="Aligner à droite" onclick="setTextAlignById(${el.id},'right',event)">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2.5 4h11M6.5 8h7M4.5 12h9" stroke-linecap="round"/></svg>
      </button>
    </span>
    <button type="button" class="elem-tool color-tool" title="Couleur du texte ${escapeAttr(formatDisplayHex(el.color || DEFAULT_TEXT_COLOR))}" onclick="openTextColorPicker(event, ${el.id})">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M8 2.5l4.2 4.2a4.2 4.2 0 1 1-8.4 0L8 2.5z"/><path d="M5.7 10.5h4.6" stroke-linecap="round"/></svg>
      <span class="color-tool-bar" style="background:${escapeAttr(formatDisplayHex(el.color || DEFAULT_TEXT_COLOR))}"></span>
    </button>` : `
    <button class="elem-tool" title="Modifier le logo" onclick="openLogoEditorForElement(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3.5 11.5 11.2 3.8a1.4 1.4 0 0 1 2 2L5.5 13.5l-2.5.5.5-2.5z" stroke-linejoin="round"/><path d="M9.8 5.2l1.5 1.5" stroke-linecap="round"/></svg>
    </button>
    <button class="elem-tool" title="Effacer le fond" onclick="removeBackgroundById(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="2.5" y="3" width="8.5" height="7" rx="1.2"/><path d="M4.5 8l1.7-1.7 1.2 1.2 1.4-1.4L11 8.3"/><path d="M10.2 12.8l3.4-3.4a1.1 1.1 0 0 0-1.6-1.6l-3.4 3.4-.5 2.1 2.1-.5z" stroke-linejoin="round"/></svg>
    </button>`;
  actions.innerHTML = `
    <button class="elem-tool" title="Dupliquer" onclick="duplicateElemOnce(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="5" y="5" width="8" height="8" rx="1"/><path d="M3 11V3h8" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <button class="elem-tool" title="Quantité" onclick="openDupeModalForElem(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 8h10M8 3v10" stroke-linecap="round"/><rect x="2.5" y="2.5" width="11" height="11" rx="2"/></svg>
    </button>
    <button class="elem-tool" title="Rotation 90°" onclick="rotateElementById(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12.5 6A4.5 4.5 0 1 0 14 9.4" stroke-linecap="round"/><path d="M12.5 2v4h-4" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    ${middleTool}
    <button class="elem-tool danger" title="Supprimer" onclick="deleteElemById(${el.id},event)">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 4h10M6 4V2h4v2M5 4v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>`;
  actions.addEventListener('mousedown', ev=>ev.stopPropagation());
  actions.addEventListener('click', ev=>ev.stopPropagation());
  div.appendChild(actions);
  const info = document.createElement('div');
  info.className = 'elem-info';
  info.innerHTML = elemInfoHtml(el);
  div.appendChild(info);
  div.addEventListener('mousedown', ev=>{
    if(ev.target.dataset.handle) return;
    if(ev.detail >= 2 && isTextElement(el)){
      ev.preventDefault();
      ev.stopPropagation();
      selectElem(el.id);
      return;
    }
    const multiKey = ev.shiftKey || ev.metaKey || ev.ctrlKey;
    if(multiKey) selectElem(el.id, {toggle:true});
    else if(!selectedIds.has(el.id)) selectElem(el.id);
    startDrag(ev, el.id);
  });
  div.addEventListener('dblclick', ev=>{
    if(!isTextElement(el) || ev.target.closest('.elem-actions')) return;
    startInlineTextEdit(el.id, ev);
  });
  document.getElementById('canvas').appendChild(div);
  syncSelectionClasses();
}

function applyImageRotationStyle(img, el){
  const rot = normalizeRotation(el.rotation);
  // Beat theme `img{max-width:100%!important}` so quarter-turn pre-layout can
  // be larger than the AABB before CSS rotate.
  img.style.setProperty('max-width', 'none', 'important');
  img.style.setProperty('max-height', 'none', 'important');
  img.style.left = '50%';
  img.style.top = '50%';
  if(isQuarterTurn(rot)){
    // Pre-rotate layout uses the content (unrotated) size.
    img.style.width = mm2s(el.h) + 'px';
    img.style.height = mm2s(el.w) + 'px';
    img.style.objectFit = 'fill';
  } else {
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';
  }
  img.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;
}

function applyTextStyle(node, el){
  const rot = normalizeRotation(el.rotation);
  const align = getTextAlign(el);
  node.style.color = el.color || DEFAULT_TEXT_COLOR;
  node.style.fontFamily = fontFamilyCss(getTextFont(el));
  node.style.fontSize = mm2s(el.fontSizeMm || DEFAULT_TEXT_SIZE_MM) + 'px';
  node.style.fontWeight = getTextWeight(el);
  node.style.textAlign = align;
  node.style.justifyContent = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';
  node.style.width = (isQuarterTurn(rot) ? mm2s(el.h) : mm2s(el.w)) + 'px';
  node.style.height = (isQuarterTurn(rot) ? mm2s(el.w) : mm2s(el.h)) + 'px';
  node.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;
  const span = node.querySelector('span');
  if(span){
    span.style.display = 'block';
    span.style.width = '100%';
    span.style.textAlign = align;
  }
}

function applyInlineTextEditorStyle(node, el){
  const rot = normalizeRotation(el.rotation);
  const align = getTextAlign(el);
  node.style.color = el.color || DEFAULT_TEXT_COLOR;
  node.style.fontFamily = fontFamilyCss(getTextFont(el));
  node.style.fontSize = mm2s(el.fontSizeMm || DEFAULT_TEXT_SIZE_MM) + 'px';
  node.style.fontWeight = getTextWeight(el);
  node.style.textAlign = align;
  node.style.width = (isQuarterTurn(rot) ? mm2s(el.h) : mm2s(el.w)) + 'px';
  node.style.height = (isQuarterTurn(rot) ? mm2s(el.w) : mm2s(el.h)) + 'px';
  node.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;
}

function startInlineTextEdit(id, event=null){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id);
  if(!el || !isTextElement(el)) return;
  selectElem(id);
  const div = document.querySelector(`.elem[data-id="${id}"]`);
  if(!div) return;
  div.querySelector('.text-inline-editor')?.remove();
  div.classList.add('is-text-editing');

  const editor = document.createElement('textarea');
  editor.className = 'text-inline-editor';
  editor.value = el.text || 'Texte';
  applyInlineTextEditorStyle(editor, el);
  div.appendChild(editor);

  let closed = false;
  function finish(cancel=false){
    if(closed) return;
    closed = true;
    document.removeEventListener('mousedown', closeOnOutsideClick, true);
    const nextText = (editor.value || '').trim() || 'Texte';
    editor.remove();
    div.classList.remove('is-text-editing');
    if(!cancel && nextText !== (el.text || 'Texte')){
      pushUndo();
      el.text = nextText;
      resizeTextToContent(el);
      clampElementToSheet(el);
      ensureTextFontLoaded(getTextFont(el), el.fontSizeMm || DEFAULT_TEXT_SIZE_MM, getTextWeight(el)).finally(()=>{
        resizeTextToContent(el);
        clampElementToSheet(el);
        updateElemPos(el);
        updatePropBar();
        updateCoverage();
        renderSheetsPanel();
      });
      return;
    }
    updateElemPos(el);
    updatePropBar();
  }

  function closeOnOutsideClick(ev){
    if(editor.contains(ev.target)) return;
    finish(false);
  }

  editor.addEventListener('mousedown', ev=>ev.stopPropagation());
  editor.addEventListener('click', ev=>ev.stopPropagation());
  editor.addEventListener('keydown', ev=>{
    if(ev.key === 'Escape'){
      ev.preventDefault();
      finish(true);
      return;
    }
    if((ev.metaKey || ev.ctrlKey) && ev.key === 'Enter'){
      ev.preventDefault();
      finish(false);
    }
  });
  editor.addEventListener('blur', ()=>finish(false));
  requestAnimationFrame(()=>{
    document.addEventListener('mousedown', closeOnOutsideClick, true);
    editor.focus();
    editor.select();
  });
}

function setTextColorById(id, value, event){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id);
  if(!el || !isTextElement(el)) return false;
  const parsed = parseColorToHex(value);
  if(!parsed) return false;
  if(el.color !== parsed){
    el.color = parsed;
    updateElemPos(el);
    renderSheetsPanel();
  }
  updatePropBar();
  return true;
}

function clamp01(n){
  if(!Number.isFinite(n)) return 0;
  return Math.min(1, Math.max(0, n));
}

function rgbFromHex(hex){
  const parsed = parseColorToHex(hex) || '#000000';
  return {
    r: parseInt(parsed.slice(1, 3), 16),
    g: parseInt(parsed.slice(3, 5), 16),
    b: parseInt(parsed.slice(5, 7), 16)
  };
}

function hsvToHex(h, s, v){
  const hue = ((h % 360) + 360) % 360;
  const c = v * s;
  const hp = hue / 60;
  const x = c * (1 - Math.abs((hp % 2) - 1));
  let r1 = 0, g1 = 0, b1 = 0;
  if(hp < 1) [r1, g1, b1] = [c, x, 0];
  else if(hp < 2) [r1, g1, b1] = [x, c, 0];
  else if(hp < 3) [r1, g1, b1] = [0, c, x];
  else if(hp < 4) [r1, g1, b1] = [0, x, c];
  else if(hp < 5) [r1, g1, b1] = [x, 0, c];
  else [r1, g1, b1] = [c, 0, x];
  const m = v - c;
  const channel = n => Math.min(255, Math.max(0, Math.round((n + m) * 255))).toString(16).padStart(2, '0');
  return '#' + channel(r1) + channel(g1) + channel(b1);
}

function rgbToHsv(r, g, b){
  const rn = r / 255, gn = g / 255, bn = b / 255;
  const max = Math.max(rn, gn, bn);
  const min = Math.min(rn, gn, bn);
  const d = max - min;
  let h = 0;
  if(d !== 0){
    if(max === rn) h = ((gn - bn) / d) % 6;
    else if(max === gn) h = (bn - rn) / d + 2;
    else h = (rn - gn) / d + 4;
    h *= 60;
    if(h < 0) h += 360;
  }
  return {h, s: max === 0 ? 0 : d / max, v: max};
}

let colorPickerState = null;

function syncTextColorReadout(el){
  if(!el) return;
  const shown = formatDisplayHex(el.color || DEFAULT_TEXT_COLOR);
  const input = document.getElementById('prop-text-color');
  const fill = document.getElementById('prop-text-color-fill');
  if(fill) fill.style.background = shown;
  if(input && document.activeElement !== input) input.value = shown;
  const bar = document.querySelector(`.elem[data-id="${el.id}"] .color-tool-bar`);
  if(bar) bar.style.background = shown;
  const tool = document.querySelector(`.elem[data-id="${el.id}"] .color-tool`);
  if(tool) tool.title = `Couleur du texte ${shown}`;
  if(colorPickerState && !colorPickerState.pop.hidden && colorPickerState.id === el.id){
    paintColorPicker(shown);
  }
}

function commitPropBarColor(commit){
  const input = document.getElementById('prop-text-color');
  const el = getEl(selected);
  if(!input || !el || !isTextElement(el)) return;
  if(!commit && !isReadyColorDraft(input.value)) return;
  const parsed = parseColorToHex(input.value);
  if(!parsed){
    if(commit) input.value = formatDisplayHex(el.color || DEFAULT_TEXT_COLOR);
    return;
  }
  const pastedRgb = /^rgba?\(/i.test(input.value.trim());
  if(pastedRgb || (commit && input.value.trim().toUpperCase() !== formatDisplayHex(parsed))){
    input.value = formatDisplayHex(parsed);
  }
  if(colorPickerState && colorPickerState.id === el.id){
    const rgb = rgbFromHex(parsed);
    const next = rgbToHsv(rgb.r, rgb.g, rgb.b);
    if(next.s < 0.001) next.h = colorPickerState.hsv.h;
    colorPickerState.hsv = next;
  }
  setTextColorById(el.id, parsed);
}

function paintColorPicker(shown){
  const picker = colorPickerState;
  if(!picker) return;
  const sv = picker.pop.querySelector('[data-sv]');
  sv.style.backgroundColor = `hsl(${picker.hsv.h}, 100%, 50%)`;
  const svKnob = picker.pop.querySelector('[data-sv-knob]');
  svKnob.style.left = (picker.hsv.s * 100) + '%';
  svKnob.style.top = ((1 - picker.hsv.v) * 100) + '%';
  const hueKnob = picker.pop.querySelector('[data-hue-knob]');
  hueKnob.style.left = ((picker.hsv.h / 360) * 100) + '%';
  picker.pop.querySelector('[data-preview]').style.background = shown;
  const hexInput = picker.pop.querySelector('[data-hex]');
  if(document.activeElement !== hexInput) hexInput.value = shown;
}

function placeColorPicker(){
  const picker = colorPickerState;
  if(!picker) return;
  const anchor = picker.anchor;
  const pop = picker.pop;
  const margin = 8;
  const rect = anchor && anchor.isConnected ? anchor.getBoundingClientRect() : null;
  const width = pop.offsetWidth || 236;
  const height = pop.offsetHeight || 210;
  let left = rect ? rect.left : margin;
  let top = rect ? rect.bottom + 6 : margin;
  if(top + height > window.innerHeight - margin) top = (rect ? rect.top : margin) - height - 6;
  if(left + width > window.innerWidth - margin) left = window.innerWidth - width - margin;
  pop.style.left = Math.max(margin, left) + 'px';
  pop.style.top = Math.max(margin, top) + 'px';
}

function closeTextColorPicker(){
  if(!colorPickerState || colorPickerState.pop.hidden) return;
  colorPickerState.pop.hidden = true;
  colorPickerState.anchor = null;
}

function bindColorSurface(el, onMove){
  el.addEventListener('pointerdown', event => {
    colorPickerState.dragging = true;
    el.setPointerCapture(event.pointerId);
    event.preventDefault();
    onMove(event);
  });
  el.addEventListener('pointermove', event => {
    if(!el.hasPointerCapture(event.pointerId)) return;
    onMove(event);
  });
  const end = () => { if(colorPickerState) colorPickerState.dragging = false; };
  el.addEventListener('pointerup', end);
  el.addEventListener('pointercancel', end);
}

function ensureColorPicker(){
  if(colorPickerState) return colorPickerState;
  const pop = document.createElement('div');
  pop.id = 'color-hex-pop';
  pop.className = 'color-hex-pop';
  pop.hidden = true;
  pop.setAttribute('role', 'dialog');
  pop.setAttribute('aria-label', 'Sélecteur de couleur');
  pop.innerHTML = `
    <div class="color-hex-pop__sv" data-sv>
      <span class="color-hex-pop__sv-white"></span>
      <span class="color-hex-pop__sv-black"></span>
      <span class="color-hex-pop__knob" data-sv-knob></span>
    </div>
    <div class="color-hex-pop__hue" data-hue>
      <span class="color-hex-pop__knob" data-hue-knob></span>
    </div>
    <div class="color-hex-pop__entry">
      <span class="color-hex-pop__preview" data-preview></span>
      <label class="color-hex-pop__hex">
        <input type="text" data-hex aria-label="HEX" spellcheck="false" autocomplete="off" autocapitalize="characters" maxlength="32">
        <span>HEX</span>
      </label>
    </div>`;
  const host = document.getElementById('sherpa-editor-app') || document.body;
  host.appendChild(pop);
  const state = {pop, hsv:{h:0, s:0, v:0}, id:null, anchor:null, dragging:false};
  colorPickerState = state;
  pop.addEventListener('mousedown', event => event.stopPropagation());
  pop.addEventListener('click', event => event.stopPropagation());
  const hexInput = pop.querySelector('[data-hex]');
  hexInput.addEventListener('input', () => {
    if(!isReadyColorDraft(hexInput.value)) return;
    const parsed = parseColorToHex(hexInput.value);
    if(!parsed) return;
    if(/^rgba?\(/i.test(hexInput.value.trim())) hexInput.value = formatDisplayHex(parsed);
    const rgb = rgbFromHex(parsed);
    const next = rgbToHsv(rgb.r, rgb.g, rgb.b);
    if(next.s < 0.001) next.h = state.hsv.h;
    state.hsv = next;
    setTextColorById(state.id, parsed);
  });
  hexInput.addEventListener('blur', () => {
    if(pop.hidden) return;
    const parsed = parseColorToHex(hexInput.value);
    if(parsed){
      const rgb = rgbFromHex(parsed);
      const next = rgbToHsv(rgb.r, rgb.g, rgb.b);
      if(next.s < 0.001) next.h = state.hsv.h;
      state.hsv = next;
      setTextColorById(state.id, parsed);
    }
    const el = getEl(state.id);
    hexInput.value = formatDisplayHex(el?.color || DEFAULT_TEXT_COLOR);
  });
  hexInput.addEventListener('keydown', event => {
    if(event.key !== 'Enter' && event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    if(event.key === 'Enter'){
      const parsed = parseColorToHex(hexInput.value);
      if(parsed){
        const rgb = rgbFromHex(parsed);
        const next = rgbToHsv(rgb.r, rgb.g, rgb.b);
        if(next.s < 0.001) next.h = state.hsv.h;
        state.hsv = next;
        setTextColorById(state.id, parsed);
      }
    } else {
      const el = getEl(state.id);
      hexInput.value = formatDisplayHex(el?.color || DEFAULT_TEXT_COLOR);
    }
    closeTextColorPicker();
    hexInput.blur();
  });
  bindColorSurface(pop.querySelector('[data-sv]'), event => {
    const rect = event.currentTarget.getBoundingClientRect();
    const s = clamp01((event.clientX - rect.left) / Math.max(1, rect.width));
    const v = clamp01(1 - (event.clientY - rect.top) / Math.max(1, rect.height));
    state.hsv = {h: state.hsv.h, s, v};
    setTextColorById(state.id, hsvToHex(state.hsv.h, s, v));
  });
  bindColorSurface(pop.querySelector('[data-hue]'), event => {
    const rect = event.currentTarget.getBoundingClientRect();
    const h = clamp01((event.clientX - rect.left) / Math.max(1, rect.width)) * 360;
    state.hsv = {h, s: state.hsv.s, v: state.hsv.v};
    setTextColorById(state.id, hsvToHex(h, state.hsv.s, state.hsv.v));
  });
  document.addEventListener('pointerdown', event => {
    if(pop.hidden || state.dragging) return;
    const target = event.target;
    if(!(target instanceof Node)) return;
    if(pop.contains(target)) return;
    if(state.anchor && state.anchor.contains(target)) return;
    closeTextColorPicker();
  }, true);
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape' && !pop.hidden) closeTextColorPicker();
  });
  window.addEventListener('resize', () => { if(!pop.hidden) placeColorPicker(); });
  window.addEventListener('scroll', () => { if(!pop.hidden) placeColorPicker(); }, true);
  return state;
}

function openTextColorPicker(event, id){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id || selected);
  if(!el || !isTextElement(el)) return;
  const picker = ensureColorPicker();
  const anchor = event?.currentTarget instanceof Element ? event.currentTarget : document.getElementById('prop-text-color-swatch');
  if(!picker.pop.hidden && picker.anchor === anchor){
    closeTextColorPicker();
    return;
  }
  picker.id = el.id;
  picker.anchor = anchor;
  const shown = formatDisplayHex(el.color || DEFAULT_TEXT_COLOR);
  const rgb = rgbFromHex(shown);
  const hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
  if(hsv.s < 0.001) hsv.h = picker.hsv.h || 0;
  picker.hsv = hsv;
  picker.pop.hidden = false;
  paintColorPicker(shown);
  placeColorPicker();
  const hexInput = picker.pop.querySelector('[data-hex]');
  requestAnimationFrame(() => {
    hexInput.focus();
    hexInput.select();
  });
}

function mountTextColorHexField(){
  const input = document.getElementById('prop-text-color');
  if(!input || input.dataset.hexField === '1') return;
  input.dataset.hexField = '1';
  input.type = 'text';
  input.classList.add('color-hex-input');
  input.setAttribute('spellcheck', 'false');
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('aria-label', 'Code HEX');
  input.maxLength = 32;
  input.value = formatDisplayHex(input.value || DEFAULT_TEXT_COLOR);
  const field = document.createElement('span');
  field.className = 'color-hex-field';
  const swatch = document.createElement('button');
  swatch.type = 'button';
  swatch.id = 'prop-text-color-swatch';
  swatch.className = 'color-hex-swatch';
  swatch.title = 'Couleur du texte';
  swatch.setAttribute('aria-label', 'Couleur du texte');
  const fill = document.createElement('span');
  fill.id = 'prop-text-color-fill';
  fill.className = 'color-hex-swatch-fill';
  fill.style.background = input.value;
  swatch.appendChild(fill);
  input.parentNode.insertBefore(field, input);
  field.appendChild(swatch);
  field.appendChild(input);
  swatch.addEventListener('click', event => openTextColorPicker(event));
  input.addEventListener('input', () => applyTextPropChange('color'));
  input.addEventListener('blur', () => applyTextPropChange('color-commit'));
}

function toggleTextBoldById(id, event=null){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id);
  if(!el || !isTextElement(el)) return;
  selectElem(id);
  applyTextPropChange('bold');
}

function setTextAlignById(id, align, event=null){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id);
  if(!el || !isTextElement(el)) return;
  const next = getTextAlign({align});
  if(getTextAlign(el) === next) return;
  el.align = next;
  renderElem(el);
  selectElem(id);
  updatePropBar();
  renderSheetsPanel();
}

window.startInlineTextEdit = startInlineTextEdit;
window.toggleTextBoldById = toggleTextBoldById;
window.setTextAlignById = setTextAlignById;

function reRenderAll(){
  document.querySelectorAll('.elem').forEach(e=>e.remove());
  elements.forEach(el => renderElem(el));
  syncSelectionClasses();
}

function syncSelectionClasses(){
  const isMulti = selectedIds.size > 1;
  document.querySelectorAll('.elem').forEach(e => {
    const isSelected = selectedIds.has(parseInt(e.dataset.id));
    e.classList.toggle('selected', isSelected);
    e.classList.toggle('multi-selected', isSelected && isMulti);
  });
}

function getSelectedElements(){
  return elements.filter(el => selectedIds.has(el.id));
}

function clearSelection(){
  selected = null;
  selectedIds.clear();
  syncSelectionClasses();
  updatePropBar();
}

function setSelectedIds(ids){
  selectedIds = new Set(ids);
  selected = selectedIds.values().next().value || null;
  syncSelectionClasses();
  updatePropBar();
}

function selectElem(id, opts={}){
  if(opts.toggle){
    if(selectedIds.has(id)) selectedIds.delete(id);
    else selectedIds.add(id);
  } else if(opts.additive){
    selectedIds.add(id);
  } else {
    selectedIds = new Set([id]);
  }
  selected = selectedIds.has(id) ? id : (selectedIds.values().next().value || null);
  syncSelectionClasses();
  updatePropBar();
  const el = selected != null ? getEl(selected) : null;
  if(el && isTextElement(el)){
    const selectedAtRequest = selected;
    ensureTextFontLoaded(getTextFont(el), el.fontSizeMm || DEFAULT_TEXT_SIZE_MM, getTextWeight(el)).finally(()=>{
      if(selected !== selectedAtRequest) return;
      updateElemContext(el);
      updatePropBar();
    });
  }
}

function canvasPointToMm(ev){
  const canvas = document.getElementById('canvas');
  const rect = canvas.getBoundingClientRect();
  return {
    x: Math.min(Math.max(0, s2mm((ev.clientX - rect.left) / zoomLevel)), sheetW),
    y: Math.min(Math.max(0, s2mm((ev.clientY - rect.top) / zoomLevel)), sheetH)
  };
}

function rectFromPoints(a, b){
  const x = Math.min(a.x, b.x);
  const y = Math.min(a.y, b.y);
  return {x, y, w:Math.abs(b.x - a.x), h:Math.abs(b.y - a.y)};
}

function updateMarqueeBox(box, rect){
  box.style.left = mm2s(rect.x) + 'px';
  box.style.top = mm2s(rect.y) + 'px';
  box.style.width = mm2s(rect.w) + 'px';
  box.style.height = mm2s(rect.h) + 'px';
}

function startMarqueeSelect(e){
  if(e.button !== 0 || isSpaceDown) return;
  e.preventDefault();
  e.stopPropagation();
  const canvas = document.getElementById('canvas');
  const start = canvasPointToMm(e);
  const additive = e.shiftKey || e.metaKey || e.ctrlKey;
  let box = null;
  let dragging = false;
  const startClientX = e.clientX;
  const startClientY = e.clientY;

  function ensureBox(){
    if(box) return box;
    box = document.createElement('div');
    box.className = 'marquee-select';
    canvas.appendChild(box);
    return box;
  }

  function move(ev){
    const pxMove = Math.hypot(ev.clientX - startClientX, ev.clientY - startClientY);
    if(pxMove < 4 && !dragging) return;
    dragging = true;
    const current = canvasPointToMm(ev);
    updateMarqueeBox(ensureBox(), rectFromPoints(start, current));
  }

  function up(ev){
    document.removeEventListener('mousemove', move);
    document.removeEventListener('mouseup', up);
    if(box) box.remove();
    if(!dragging){
      if(!additive) clearSelection();
      return;
    }
    const selectionRect = rectFromPoints(start, canvasPointToMm(ev));
    const found = elements.filter(el => rectsOverlap(selectionRect, cloneRect(el), 0)).map(el => el.id);
    const ids = additive ? [...new Set([...selectedIds, ...found])] : found;
    setSelectedIds(ids);
    if(found.length) showToast(`${found.length} visuel${found.length>1?'s':''} sélectionné${found.length>1?'s':''}`);
  }

  document.addEventListener('mousemove', move);
  document.addEventListener('mouseup', up);
}

function getEl(id){ return elements.find(e => e.id === id); }

function updateElemPos(el){
  repairElementRotation(el);
  const div = document.querySelector(`.elem[data-id="${el.id}"]`);
  if(div){
    div.style.left   = mm2s(el.x) + 'px';
    div.style.top    = mm2s(el.y) + 'px';
    div.style.width  = mm2s(el.w) + 'px';
    div.style.height = mm2s(el.h) + 'px';
    const img = div.querySelector('img');
    if(img){
      const src = elementSrc(el);
      if(src && img.src !== src) img.src = src;
      applyImageRotationStyle(img, el);
    }
    const text = div.querySelector('.text-visual');
    if(text){
      text.innerHTML = `<span>${escapeHtml(el.text || 'Texte')}</span>`;
      applyTextStyle(text, el);
    }
    updateElemContext(el);
  }
}

// ── DRAG ──
function startDrag(e, id){
  e.preventDefault(); e.stopPropagation();
  const el = getEl(id); if(!el) return;
  pushUndo();
  const moving = selectedIds.has(id) ? getSelectedElements() : [el];
  if(!moving.length) return;
  const starts = moving.map(item=>({id:item.id, x:item.x, y:item.y}));
  const startX=e.clientX, startY=e.clientY;
  const scale = zoomLevel;
  function move(ev){
    const dx = s2mm((ev.clientX-startX)/scale);
    const dy = s2mm((ev.clientY-startY)/scale);
    starts.forEach(start=>{
      const item = getEl(start.id);
      if(!item) return;
      item.x = start.x + dx;
      item.y = start.y + dy;
      updateElemPos(item);
    });
    updatePropBar(); updateCoverage();
  }
  function up(){ document.removeEventListener('mousemove',move); document.removeEventListener('mouseup',up); }
  document.addEventListener('mousemove',move); document.addEventListener('mouseup',up);
}

// ── RESIZE ──
function startResize(e, id, handle){
  e.preventDefault(); e.stopPropagation();
  const el = getEl(id); if(!el) return;
  pushUndo();
  const sx=e.clientX, sy=e.clientY, ox=el.x, oy=el.y, ow=el.w, oh=el.h;
  const originalFontSize = el.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  const ratio = displayRatio(el);
  const scale = zoomLevel;
  function move(ev){
    const dx=s2mm((ev.clientX-sx)/scale), dy=s2mm((ev.clientY-sy)/scale);
    let nw=ow, nh=oh, nx=ox, ny=oy;
    if(handle.includes('e'))  nw = Math.max(5, ow+dx);
    if(handle.includes('s'))  nh = Math.max(5, oh+dy);
    if(handle.includes('w')){ nw = Math.max(5, ow-dx); nx = ox+ow-nw; }
    if(handle.includes('n')){ nh = Math.max(5, oh-dy); ny = oy+oh-nh; }
    if(handle==='e'||handle==='w')       nh = Math.round(nw*ratio*10)/10;
    else if(handle==='n'||handle==='s') nw = Math.round(nh/ratio*10)/10;
    else if(handle.includes('s'))       nh = Math.round(nw*ratio*10)/10;
    else if(handle.includes('n')){ nh = Math.round(nw*ratio*10)/10; ny = oy+oh-nh; }
    if(handle.includes('w')){ nx = ox+ow-nw; }
    if(isTextElement(el) && oh > 0){
      const textScale = Math.max(0.05, nh / oh);
      el.fontSizeMm = Math.max(2, Math.round(originalFontSize * textScale * 10) / 10);
    }
    el.w=nw; el.h=nh; el.x=nx; el.y=ny;
    updateElemPos(el); updatePropBar(); updateCoverage();
  }
  function up(){
    document.removeEventListener('mousemove',move);
    document.removeEventListener('mouseup',up);
    if(isTextElement(el)){
      // Keep the font size chosen while dragging, then expand the hit-box
      // so glyphs are never clipped by a too-tight zone.
      resizeTextToContent(el);
      clampElementToSheet(el);
      updateElemPos(el);
      updatePropBar();
      updateCoverage();
    } else if(Math.abs(el.w - ow) > 0.05 || Math.abs(el.h - oh) > 0.05){
      syncElementImageVersion(el);
      updateElemContext(el);
      sharpenVectorElement(el);
    }
  }
  document.addEventListener('mousemove',move); document.addEventListener('mouseup',up);
}

// ── CANVAS CLICK ──
document.getElementById('canvas').addEventListener('mousedown', e=>{
  if(e.target === document.getElementById('canvas') || e.target.closest('.checker') || e.target.closest('.empty-canvas')){
    startMarqueeSelect(e);
  }
});

function onDragOver(e){ e.preventDefault(); }
function onDrop(e){ e.preventDefault(); Array.from(e.dataTransfer.files).forEach(loadFile); }

// ── PROP BAR (values in cm) ──
function updatePropBar(){
  const hint   = document.getElementById('prop-hint');
  const fields = document.getElementById('prop-fields');
  const textProps = document.getElementById('text-props');
  const imageProps = document.getElementById('image-props');
  if(!selected){
    hint.textContent = 'Sélectionnez un visuel pour modifier ses propriétés';
    hint.style.display='';
    fields.style.display='none';
    return;
  }
  const el = getEl(selected);
  if(!el){
    hint.textContent = 'Sélectionnez un visuel pour modifier ses propriétés';
    hint.style.display='';
    fields.style.display='none';
    return;
  }
  hint.style.display = 'none'; fields.style.display = 'flex';
  const multi = selectedIds.size > 1;
  const isText = isTextElement(el);
  const displayedSize = isText ? getElementDisplayedSize(el) : {w:el.w, h:el.h};
  document.getElementById('prop-w').value = multi ? '' : mm2cm(displayedSize.w);
  document.getElementById('prop-h').value = multi ? '' : mm2cm(displayedSize.h);
  ['prop-w','prop-h'].forEach(id=>document.getElementById(id).disabled = multi);
  if(textProps) textProps.style.display = (!multi && isText) ? 'flex' : 'none';
  if(imageProps) imageProps.style.display = (!multi && !isText) ? 'flex' : 'none';
  if(!multi && isText){
    document.getElementById('prop-text').value = el.text || '';
    document.getElementById('prop-font').value = getTextFont(el);
    updateFontPickerButton(getTextFont(el));
    const charSize = getElementDisplayedSize(el);
    const fontW = document.getElementById('prop-font-w');
    const fontH = document.getElementById('prop-font-h');
    if(fontW) fontW.value = mm2cm(charSize.w);
    if(fontH) fontH.value = mm2cm(charSize.h);
    syncTextColorReadout(el);
    const boldBtn = document.getElementById('prop-text-bold');
    if(boldBtn) boldBtn.classList.toggle('active', getTextWeight(el) >= 700);
    const align = getTextAlign(el);
    document.querySelectorAll('[data-text-align]').forEach(btn=>{
      btn.classList.toggle('active', btn.dataset.textAlign === align);
    });
  }
  if(multi) hint.textContent = `${selectedIds.size} visuels sélectionnés`;
  else hint.textContent = 'Sélectionnez un visuel pour modifier ses propriétés';
}

function applyPropChangeSize(axis){
  const el = getEl(selected); if(!el) return;
  const val = Math.max(2, cm2mm(parseFloat(document.getElementById('prop-'+axis).value)||1));
  const ratio = displayRatio(el);
  let textScale = 1;
  const prevW = el.w;
  const prevH = el.h;
  if(isTextElement(el)){
    const displayedSize = getElementDisplayedSize(el);
    const current = axis === 'w' ? displayedSize.w : displayedSize.h;
    textScale = current > 0 ? val / current : 1;
    el.w = Math.max(2, Math.round(el.w * textScale * 10) / 10);
    el.h = Math.max(2, Math.round(el.h * textScale * 10) / 10);
    el.fontSizeMm = Math.max(2, Math.round((el.fontSizeMm || DEFAULT_TEXT_SIZE_MM) * textScale * 10) / 10);
  } else if(axis==='w'){
    el.w = val;
    el.h = Math.round(val*ratio*10)/10;
  } else {
    el.h = val;
    el.w = Math.round((val/ratio)*10)/10;
  }
  clampElementToSheet(el);
  if(!isTextElement(el) && (Math.abs(el.w - prevW) > 0.05 || Math.abs(el.h - prevH) > 0.05)){
    syncElementImageVersion(el);
    sharpenVectorElement(el);
  }
  updateElemPos(el);
  updatePropBar();
  updateCoverage();
}

function applyTextPropChange(prop){
  const el = getEl(selected);
  if(!el || !isTextElement(el)) return;
  if(prop === 'text') el.text = document.getElementById('prop-text').value || 'Texte';
  if(prop === 'font') el.fontFamily = document.getElementById('prop-font').value || DEFAULT_TEXT_FONT;
  if(prop === 'size' || prop === 'size-w' || prop === 'size-h'){
    const axis = prop === 'size-w' ? 'w' : 'h';
    const input = document.getElementById(axis === 'w' ? 'prop-font-w' : 'prop-font-h');
    const displayedSize = getElementDisplayedSize(el);
    const current = axis === 'w' ? displayedSize.w : displayedSize.h;
    const targetCm = parseFloat(input?.value);
    const targetMm = Math.max(2, cm2mm(Number.isFinite(targetCm) ? targetCm : mm2cm(current)));
    const scale = current > 0 ? targetMm / current : 1;
    el.w = Math.max(2, Math.round(el.w * scale * 10) / 10);
    el.h = Math.max(2, Math.round(el.h * scale * 10) / 10);
    el.fontSizeMm = Math.max(2, Math.round((el.fontSizeMm || DEFAULT_TEXT_SIZE_MM) * scale * 10) / 10);
  }
  if(prop === 'color' || prop === 'color-commit'){
    commitPropBarColor(prop === 'color-commit');
    return;
  }
  if(prop === 'bold') el.fontWeight = getTextWeight(el) >= 700 ? 400 : 700;
  if(prop === 'align-left' || prop === 'align-center' || prop === 'align-right'){
    el.align = prop.replace('align-', '');
    renderElem(el);
    selectElem(el.id);
    updatePropBar();
    renderSheetsPanel();
    return;
  }
  const needsResize = prop === 'font' || prop === 'text' || prop === 'size' || prop === 'size-w' || prop === 'size-h' || prop === 'bold';
  if(needsResize) resizeTextToContent(el);
  clampElementToSheet(el);
  ensureTextFontLoaded(el.fontFamily, el.fontSizeMm, getTextWeight(el)).finally(()=>{
    if(needsResize){
      resizeTextToContent(el);
      clampElementToSheet(el);
    }
    updateElemPos(el);
    updatePropBar();
    updateCoverage();
    renderSheetsPanel();
  });
}

// ── TRIM TRANSPARENCY ──
function trimTransparency(){
  const el = getEl(selected); if(!el) return;
  if(isTextElement(el)){ showToast('Cette action concerne uniquement les logos'); return; }
  const busyId = beginBusy('Vider les espaces…');
  trimTransparentImage(elementSrc(el)).then(result=>{
    if(!result.trimmed){ showToast('Aucune zone transparente trouvée'); return; }
    applyImageResultToElement(el, result, 'Espaces transparents supprimés ✓');
  }).catch(err=>{
    console.error('Trim error:', err);
    showToast('Erreur : ' + err.message);
  }).finally(()=>endBusy(busyId));
}

function applyImageResultToElement(el, result, successMessage, opts={}){
  const rotated = isQuarterTurn(el.rotation);
  const oldNw = elementNaturalW(el);
  const oldNh = elementNaturalH(el);
  const oldRatio = rotated ? (el.w / oldNh) : (el.w / oldNw);
  const nextW = result.w || oldNw;
  const nextH = result.h || oldNh;
  if(!opts.preserveDisplaySize){
    el.w = Math.round((rotated ? nextH : nextW)*oldRatio*10)/10;
    el.h = Math.round((rotated ? nextW : nextH)*oldRatio*10)/10;
  }
  syncElementImageVersion(el, {
    src: result.src,
    thumbSrc: result.src,
    w: nextW,
    h: nextH,
    vectorSvg: result.vectorSvg || opts.vectorSvg || null,
    vectorPdfDataUrl: result.vectorPdfDataUrl || opts.vectorPdfDataUrl || null,
    isVector: !!(result.isVector || result.vectorSvg || result.vectorPdfDataUrl || opts.isVector)
  });
  const div = document.querySelector(`.elem[data-id="${el.id}"]`);
  if(div){
    const img = div.querySelector('img');
    img.src = elementSrc(el);
    div.style.width = mm2s(el.w)+'px';
    div.style.height = mm2s(el.h)+'px';
    applyImageRotationStyle(img, el);
  }
  updateElemContext(el);
  updatePropBar();
  updateCoverage();
  showToast(successMessage);
}

function removeBackgroundById(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id); if(!el) return;
  if(isTextElement(el)){ showToast('Cette action concerne uniquement les logos'); return; }
  pushUndo();
  const busyId = beginBusy('Suppression du fond…');
  showToast('Suppression du fond…');
  removeSolidBackgroundImage(elementSrc(el)).then(result=>{
    if(!result.changed){ showToast('Aucun fond uni détecté'); return; }
    applyImageResultToElement(el, result, 'Fond supprimé ✓');
  }).catch(err=>{
    console.error('Background removal error:', err);
    showToast('Erreur : ' + err.message);
  }).finally(()=>endBusy(busyId));
}

function removeBackgroundSelected(){
  if(!selected){ showToast('Aucun visuel sélectionné'); return; }
  if(isTextElement(getEl(selected))){ showToast('Cette action concerne uniquement les logos'); return; }
  removeBackgroundById(selected);
}

/** Logo editor caps imports at 4096px — downsample here so we never ship a 30+ Mpx File. */
async function srcToEditableFile(src, name='logo.png'){
  const base = String(name || 'logo').replace(/\.[^.]+$/, '') || 'logo';
  const image = await loadImageMeta(src);
  const nw = Math.max(1, image.naturalWidth || 1);
  const nh = Math.max(1, image.naturalHeight || 1);
  // Same print-safe cap as import (sheet @ 300 DPI) — not a fixed 4096 that could hurt large prints.
  const {maxEdge} = workingRasterLimits();
  const scale = Math.min(1, maxEdge / Math.max(nw, nh));
  const w = Math.max(1, Math.round(nw * scale));
  const h = Math.max(1, Math.round(nh * scale));

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d', {alpha:true});
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  // Prefer createImageBitmap resize (avoids drawing the full decode at native size).
  let drew = false;
  if(typeof createImageBitmap === 'function'){
    try{
      const bmp = scale < 0.999
        ? await createImageBitmap(image, {resizeWidth:w, resizeHeight:h, resizeQuality:'high'})
        : await createImageBitmap(image);
      ctx.drawImage(bmp, 0, 0, w, h);
      bmp.close?.();
      drew = true;
    }catch(_err){ drew = false; }
  }
  if(!drew) ctx.drawImage(image, 0, 0, w, h);

  const blob = await new Promise((resolve, reject)=>{
    canvas.toBlob(
      (b)=> b ? resolve(b) : reject(new Error('Export image impossible')),
      'image/png'
    );
  });
  return new File([blob], `${base}.png`, {type:'image/png'});
}

function openLogoEditorSelected(){
  if(!selected){ showToast('Aucun visuel sélectionné'); return; }
  openLogoEditorForElement(selected);
}

async function openLogoEditorForElement(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id);
  if(!el){ showToast('Aucun visuel sélectionné'); return; }
  if(isTextElement(el)){ showToast('Cette action concerne uniquement les logos'); return; }
  if(typeof window.LogoEditor?.open !== 'function'){
    showToast('Éditeur de logo indisponible');
    return;
  }

  const src = elementSrc(el);
  if(!src){ showToast('Logo introuvable'); return; }

  const busyId = beginBusy('Ouverture de l’éditeur de logo…');
  try{
    updateBusy(busyId, 'Préparation du logo…');
    // Downsample before open — full-res data URLs (20–40 Mo) made fetch()+File catastrophically slow.
    const file = await srcToEditableFile(src, elementName(el) || 'logo.png');
    updateBusy(busyId, 'Ouverture de l’éditeur…');
    const targetId = el.id;
    await window.LogoEditor.open({
      template: '#logo-editor-template-sherpa',
      mount: '#logo-editor-mount-sherpa',
      file,
      mode: 'apply',
      printWidthCm: mm2cm(el.w),
      printHeightCm: mm2cm(el.h),
      onApply: async (result) => {
        const current = getEl(targetId);
        if(!current || isTextElement(current)){
          throw new Error('Le logo n’est plus sur la planche');
        }
        pushUndo();
        const printWmm = Number(result.printWidthCm) > 0 ? Math.round(result.printWidthCm * 10 * 10) / 10 : 0;
        const printHmm = Number(result.printHeightCm) > 0 ? Math.round(result.printHeightCm * 10 * 10) / 10 : 0;
        const preserveDisplaySize = printWmm > 0 && printHmm > 0;
        if(preserveDisplaySize){
          const rotated = isQuarterTurn(current.rotation);
          current.w = rotated ? printHmm : printWmm;
          current.h = rotated ? printWmm : printHmm;
        }
        applyImageResultToElement(current, {
          src: result.src,
          w: result.w,
          h: result.h,
          trimmed: true,
          vectorSvg: result.vectorSvg || null,
          vectorPdfDataUrl: result.vectorPdfDataUrl || null,
          isVector: !!result.isVector
        }, result.isVector ? 'Logo vectorisé appliqué ✓' : 'Logo modifié ✓', {preserveDisplaySize});
      }
    });
  }catch(error){
    console.error('[Sherpa] logo editor open error:', error);
    showToast(error?.message || 'Impossible d’ouvrir l’éditeur de logo');
  }finally{
    endBusy(busyId);
  }
}

// ── DUPLICATE MODAL ──
function openDupeModal(){
  if(!selected){ showToast('Aucun visuel sélectionné'); return; }
  document.getElementById('dupe-qty').value = 1;
  document.getElementById('dupe-overlay').classList.add('open');
}

function openDupeModalForElem(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  if(!getEl(id)) return;
  selectElem(id);
  openDupeModal();
}

function closeDupeModal(e){
  if(e && e.target !== document.getElementById('dupe-overlay')) return;
  document.getElementById('dupe-overlay').classList.remove('open');
}
function changeDupeQty(delta){
  const inp = document.getElementById('dupe-qty');
  inp.value = Math.max(1, parseInt(inp.value)+delta);
}
function applyDupe(){
  const source = getSelectedElements();
  if(!source.length) return;
  const qty = Math.max(1, parseInt(document.getElementById('dupe-qty').value)||1);
  pushUndo();
  let created = 0;
  for(let i=0; i<qty; i++){
    for(const el of source){
      const newEl = cloneElementCopy(el);
      elements.push(newEl); renderElem(newEl);
      created++;
    }
  }
  updateCoverage(); updateThumbCount(); renderSheetsPanel();
  if(created) focusElementInView(elements[elements.length-1].id);
  closeDupeModal();
  showToast(`${created} copie${created>1?'s':''} créée${created>1?'s':''} ✓`);
}

function duplicateElemOnce(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  const source = selectedIds.has(id) ? getSelectedElements() : [getEl(id)].filter(Boolean);
  if(!source.length) return;
  pushUndo();
  const newIds = [];
  source.forEach(el=>{
    const newEl = cloneElementCopy(el);
    elements.push(newEl);
    renderElem(newEl);
    newIds.push(newEl.id);
  });
  selectedIds = new Set(newIds);
  selected = newIds[newIds.length-1];
  syncSelectionClasses();
  focusElementInView(selected);
  updateCoverage(); renderSheetsPanel();
  showToast(`${newIds.length} copie${newIds.length>1?'s':''} créée${newIds.length>1?'s':''} ✓`);
}

function duplicateSelectedOnce(){
  if(!selected){ showToast('Aucun visuel sélectionné'); return; }
  duplicateElemOnce(selected);
}

function rotateElementById(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  const source = selectedIds.has(id) ? getSelectedElements() : [getEl(id)].filter(Boolean);
  if(!source.length) return;
  pushUndo();
  source.forEach(el=>{
    const next = {
      ...el,
      w: el.h,
      h: el.w,
      rotation: normalizeRotation((el.rotation || 0) + 90)
    };
    clampElementToSheet(next);
    el.w = next.w;
    el.h = next.h;
    el.x = next.x;
    el.y = next.y;
    el.rotation = next.rotation;
    // Freeze orientation after an explicit rotate so repairElementRotation
    // cannot undo the quarter-turn on the next updateElemPos/render.
    el.lockRotation = true;
    updateElemPos(el);
  });
  updatePropBar();
  updateCoverage();
  renderSheetsPanel();
  showToast('Rotation appliquée ✓');
}

function rotateSelected(){
  if(!selected){ showToast('Aucun visuel sélectionné'); return; }
  rotateElementById(selected);
}

// ── COPY / PASTE ──
function copySelected(){
  const source = getSelectedElements();
  if(!source.length) return;
  clipboard = source.map(el=>({...el}));
  showToast(`${source.length} visuel${source.length>1?'s':''} copié${source.length>1?'s':''} ✓`);
}
function pasteClipboard(){
  if(!clipboard) return;
  const source = Array.isArray(clipboard) ? clipboard : [clipboard];
  if(!source.length) return;
  pushUndo();
  const newIds = [];
  source.forEach(item=>{
    const newEl = cloneElementCopy(item);
    elements.push(newEl); renderElem(newEl); newIds.push(newEl.id);
  });
  selectedIds = new Set(newIds);
  selected = newIds[newIds.length-1];
  syncSelectionClasses();
  focusElementInView(selected);
  updateCoverage(); renderSheetsPanel(); showToast(`${newIds.length} visuel${newIds.length>1?'s':''} collé${newIds.length>1?'s':''} ✓`);
}

// ── DELETE ──
function deleteElemById(id, event){
  event?.preventDefault();
  event?.stopPropagation();
  const el = getEl(id); if(!el) return;
  pushUndo();
  elements = elements.filter(e => e.id !== id);
  document.querySelector(`.elem[data-id="${id}"]`)?.remove();
  selectedIds.delete(id);
  if(selected === id) selected = selectedIds.values().next().value || null;
  syncSelectionClasses();
  updatePropBar(); updateCoverage(); renderSheetsPanel();
  showEmptyHint(elements.length === 0);
}

function deleteSelected(){
  const ids = [...selectedIds];
  if(!ids.length) return;
  pushUndo();
  elements = elements.filter(e => !selectedIds.has(e.id));
  ids.forEach(id=>document.querySelector(`.elem[data-id="${id}"]`)?.remove());
  selectedIds.clear();
  selected = null;
  updatePropBar(); updateCoverage(); renderSheetsPanel();
  showEmptyHint(elements.length === 0);
}

// ── CLEAR ──
function clearAll(){
  if(!elements.length) return;
  if(!confirm('Vider la planche active ?')) return;
  pushUndo(); elements = [];
  document.querySelectorAll('.elem').forEach(e=>e.remove());
  selected = null; selectedIds.clear(); updatePropBar(); updateCoverage(); renderSheetsPanel(); showEmptyHint(true);
}

function updateThumbCount(){} // placeholder

// ── TIDY ──
function tidyCanvas(){
  if(!elements.length) return;
  pushUndo();
  const layout = layoutElementsLikeTidy(elements);
  elements.forEach(updateElemPos);
  updateCoverage(); renderSheetsPanel();
  if(layout.unplaced.length) showToast(`${layout.unplaced.length} visuel${layout.unplaced.length>1?'s':''} non placé${layout.unplaced.length>1?'s':''} : pas assez de place`);
  else showToast('Planche rangée ✓');
}

// ── COVERAGE ──
function isElementOutOfSheet(el, w=sheetW, h=sheetH){
  if(!el) return false;
  const eps = 0.05; // mm tolerance
  return el.x < -eps || el.y < -eps || (el.x + el.w) > w + eps || (el.y + el.h) > h + eps;
}

function getOutOfSheetElements(list=elements, w=sheetW, h=sheetH){
  return (list || []).filter(el => isElementOutOfSheet(el, w, h));
}

function updateOverflowAlert(list=elements, w=sheetW, h=sheetH){
  const out = getOutOfSheetElements(list, w, h);
  const alert = document.getElementById('overflow-alert');
  const text = document.getElementById('overflow-alert-text');
  const outIds = new Set(out.map(el => el.id));
  document.querySelectorAll('.elem.is-out-of-sheet').forEach(node=>{
    const id = parseInt(node.dataset.id, 10);
    if(!outIds.has(id)) node.classList.remove('is-out-of-sheet');
  });
  out.forEach(el=>{
    document.querySelector(`.elem[data-id="${el.id}"]`)?.classList.add('is-out-of-sheet');
  });
  if(!alert) return out;
  if(!out.length){
    alert.hidden = true;
    return out;
  }
  const n = out.length;
  if(text){
    text.textContent = n === 1
      ? '1 élément sort de la planche. La partie hors zone ne sera pas imprimée.'
      : `${n} éléments sortent de la planche. La partie hors zone ne sera pas imprimée.`;
  }
  alert.hidden = false;
  return out;
}

function warnIfOutOfSheet(list=elements, w=sheetW, h=sheetH){
  const out = getOutOfSheetElements(list, w, h);
  if(!out.length) return false;
  const n = out.length;
  showToast(n === 1
    ? 'Attention : 1 élément hors planche ne sera pas entièrement imprimé'
    : `Attention : ${n} éléments hors planche ne seront pas entièrement imprimés`);
  return true;
}

function updateCoverage(opts={}){
  const total = sheetW * sheetH;
  const used  = elements.reduce((s,el)=>s+el.w*el.h, 0);
  const pct   = Math.min(100, Math.round(used/total*100));
  document.getElementById('cov-fill').style.width = pct + '%';
  document.getElementById('cov-pct').textContent  = pct + '%';
  updateOverflowAlert();
  if(!opts.skipSave) saveActiveSheet();
}

function showEmptyHint(show){
  document.getElementById('empty-hint').style.display = show ? '' : 'none';
}

// ── UNDO/REDO ──
function pushUndo(){
  undoStack.push(JSON.stringify(cloneElements(elements)));
  if(undoStack.length > UNDO_LIMIT) undoStack.shift();
  redoStack = [];
  updateUndoBtns();
}
function undo(){
  if(!undoStack.length) return;
  redoStack.push(JSON.stringify(cloneElements(elements)));
  if(redoStack.length > UNDO_LIMIT) redoStack.shift();
  elements = JSON.parse(undoStack.pop());
  selected=null; selectedIds.clear(); reRenderAll(); updatePropBar(); updateCoverage(); updateUndoBtns(); renderSheetsPanel();
  showEmptyHint(elements.length === 0);
}
function redo(){
  if(!redoStack.length) return;
  undoStack.push(JSON.stringify(cloneElements(elements)));
  if(undoStack.length > UNDO_LIMIT) undoStack.shift();
  elements = JSON.parse(redoStack.pop());
  selected=null; selectedIds.clear(); reRenderAll(); updatePropBar(); updateCoverage(); updateUndoBtns(); renderSheetsPanel();
  showEmptyHint(elements.length === 0);
}
function updateUndoBtns(){
  document.getElementById('btn-undo').disabled = undoStack.length === 0;
  document.getElementById('btn-redo').disabled = redoStack.length === 0;
}

// ── AUTO BUILD MODAL ──
function openAutoModal(){
  if(!visibleImages().length){ showToast('Importez des visuels d\'abord'); return; }
  syncSettingsInputs();
  renderAutoGrid();
  updateAutoPreview();
  document.getElementById('auto-overlay').classList.add('open');
}
function closeAutoModal(e){
  if(e && e.target !== document.getElementById('auto-overlay')) return;
  document.getElementById('auto-overlay').classList.remove('open');
}

function renderAutoGrid(){
  const grid = document.getElementById('auto-grid'); grid.innerHTML = '';
  const libraryImages = visibleImages();
  if(!libraryImages.length){
    grid.innerHTML = '<div style="font-size:13px;color:var(--text3);padding:12px">Aucun visuel disponible.</div>';
    return;
  }
  libraryImages.forEach(img=>{
    if(autoLocks[img.id] === undefined) autoLocks[img.id] = true;
    const defW = Math.round(sheetW/3*10)/10;
    const defH = Math.round(defW*(img.naturalH/img.naturalW)*10)/10;
    const card = document.createElement('div'); card.className='auto-card';
    card.innerHTML = `
      <div class="auto-card-img"><img src="${img.thumbSrc || img.src}" alt="${escapeAttr(img.name)}"></div>
      <div class="auto-card-top">
        <div class="auto-card-name" title="${escapeAttr(img.name)}">${escapeHtml(img.name)}</div>
        <button class="auto-remove" onclick="removeAutoImage(${img.id},event)" title="Retirer ce logo">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 4h10M6 4V2h4v2M5 4v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
      <div class="auto-card-dims">
        <label>L</label>
        <input type="number" id="aw-${img.id}" value="${Math.round(defW/10*100)/100}" min="0.5" max="${mm2cm(sheetW)}" step="0.1" onchange="syncAutoSize(${img.id},'w')">
        <label>H</label>
        <input type="number" id="ah-${img.id}" value="${Math.round(defH/10*100)/100}" min="0.5" max="${mm2cm(sheetH)}" step="0.1" onchange="syncAutoSize(${img.id},'h')">
        <label style="font-size:10px;color:var(--text3)">cm</label>
        <button class="auto-card-lock ${autoLocks[img.id]?'on':''}" id="alock-${img.id}" onclick="toggleAutoLock(${img.id})">
          <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="7" width="8" height="7" rx="1"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="qty-row">
        <label>Qté</label>
        <div class="qty-ctrl">
          <button onclick="changeQty(${img.id},-1)">−</button>
          <input type="number" id="qty-${img.id}" value="1" min="1" max="999" onchange="updateAutoPreview()">
          <button onclick="changeQty(${img.id},1)">+</button>
        </div>
      </div>`;
    grid.appendChild(card);
  });
}

function removeAutoImage(id, event){
  event?.stopPropagation();
  const img = images.find(i=>i.id===id);
  if(isImageAssetUsed(id)) images.forEach(item=>{ if(item.id === id) item.hidden = true; });
  else images = images.filter(i => i.id !== id);
  delete autoLocks[id];
  renderThumbList();
  renderAutoGrid();
  updateAutoPreview();
  showToast(img ? `${img.name} retiré de la création automatique` : 'Logo retiré');
}

function toggleAutoLock(id){
  autoLocks[id] = !autoLocks[id];
  const btn = document.getElementById('alock-'+id);
  if(btn) btn.classList.toggle('on', autoLocks[id]);
}

function syncAutoSize(id, axis){
  const img = images.find(i=>i.id===id); if(!img) return;
  if(!autoLocks[id]){ updateAutoPreview(); return; }
  const ratio = img.naturalH / img.naturalW;
  if(axis==='w'){
    const w = parseFloat(document.getElementById('aw-'+id).value)||1;
    document.getElementById('ah-'+id).value = Math.round(w*ratio*100)/100;
  } else {
    const h = parseFloat(document.getElementById('ah-'+id).value)||1;
    document.getElementById('aw-'+id).value = Math.round(h/ratio*100)/100;
  }
  updateAutoPreview();
}

function changeQty(id, delta){
  const inp = document.getElementById('qty-'+id); if(!inp) return;
  inp.value = Math.max(1, parseInt(inp.value)+delta);
  updateAutoPreview();
}

function getAutoItems(){
  return visibleImages().map(img=>{
    const wCm = parseFloat(document.getElementById('aw-'+img.id)?.value || mm2cm(sheetW/3));
    const hCm = parseFloat(document.getElementById('ah-'+img.id)?.value || mm2cm(sheetH/3));
    const qty  = parseInt(document.getElementById('qty-'+img.id)?.value || 1);
    return {img, w:cm2mm(wCm), h:cm2mm(hCm), qty};
  });
}

function updateAutoPreview(){
  const items    = getAutoItems();
  const marginC  = parseFloat(document.getElementById('margin-canvas').value)||0;
  const marginIValue = parseFloat(document.getElementById('margin-image').value);
  const marginI  = Number.isFinite(marginIValue) ? marginIValue : getLayoutGap();
  const layout   = nestItems(items, marginC, marginI);
  const pBox     = document.getElementById('auto-preview-canvas').parentElement;
  const boxW     = pBox.clientWidth || 200;
  const scale    = boxW / sheetW;
  const previewC = document.getElementById('auto-preview-canvas');
  previewC.width  = Math.round(sheetW * scale * 2);
  previewC.height = Math.round(sheetH * scale * 2);
  const ctx = previewC.getContext('2d'); ctx.scale(scale*2, scale*2);
  const [checkerA, checkerB] = getCheckerColors();
  // checker bg
  for(let x=0; x<sheetW; x+=10) for(let y=0; y<sheetH; y+=10){
    ctx.fillStyle = ((Math.floor(x/10)+Math.floor(y/10))%2===0)?checkerA:checkerB;
    ctx.fillRect(x,y,10,10);
  }
  layout.placed.forEach(p=>{
    ctx.fillStyle='rgba(216,52,127,.18)'; ctx.fillRect(p.x,p.y,p.w,p.h);
    ctx.strokeStyle='#d8347f'; ctx.lineWidth=0.6; ctx.strokeRect(p.x,p.y,p.w,p.h);
  });
  const total = items.reduce((s,i)=>s+i.qty,0);
  document.getElementById('stat-count').textContent = total;
  const fmtName = formatName(sheetW, sheetH);
  document.getElementById('stat-format').textContent = fmtName;
  const cov = layout.placed.length > 0 ? Math.round(layout.placed.reduce((s,p)=>s+p.w*p.h,0)/(sheetW*sheetH)*100) : 0;
  document.getElementById('stat-cov').textContent = cov + '%';
}

// ── NESTING ──
function nestItems(items, marginC, marginI){
  const placed = [];
  const unplaced = [];
  let curX=marginC, curY=marginC, rowH=0;
  const flat = [];
  items.forEach(it=>{ for(let i=0;i<it.qty;i++) flat.push({w:it.w,h:it.h,imageId:it.img.id}); });
  flat.sort((a,b)=>b.h-a.h);
  flat.forEach(item=>{
    const orientations = Math.abs(item.w-item.h) > 0.01 ? [{w:item.w,h:item.h,rot:0},{w:item.h,h:item.w,rot:90}] : [{w:item.w,h:item.h,rot:0}];
    let done = false;
    for(const orient of orientations){
      if(curX+orient.w > sheetW-marginC){ curX=marginC; curY+=rowH+marginI; rowH=0; }
      if(curY+orient.h > sheetH-marginC) continue;
      placed.push({x:curX,y:curY,w:orient.w,h:orient.h,imageId:item.imageId,rotation:orient.rot});
      if(orient.h>rowH) rowH=orient.h;
      curX+=orient.w+marginI;
      done = true;
      break;
    }
    if(!done) unplaced.push(item);
  });
  return {placed, unplaced};
}

function applyAutoLayout(){
  const items   = getAutoItems();
  const marginC = parseFloat(document.getElementById('margin-canvas').value)||0;
  const marginIValue = parseFloat(document.getElementById('margin-image').value);
  const marginI = Number.isFinite(marginIValue) ? marginIValue : getLayoutGap();
  const layout  = nestItems(items, marginC, marginI);
  pushUndo();
  elements = []; document.querySelectorAll('.elem').forEach(e=>e.remove());
  layout.placed.forEach(p=>{
    const img = findImageById(p.imageId) || visibleImages()[0];
    const el  = {id:nextId++,imageId:img?.id,name:img?.name||'visuel',naturalW:img?.naturalW||100,naturalH:img?.naturalH||100,x:p.x,y:p.y,w:p.w,h:p.h,rotation:p.rotation||0,locked:true};
    elements.push(el); renderElem(el);
  });
  closeAutoModal(); updateCoverage(); renderSheetsPanel(); showEmptyHint(elements.length===0);
  if(layout.unplaced?.length) showToast(`${layout.placed.length} placé${layout.placed.length>1?'s':''}, ${layout.unplaced.length} impossible${layout.unplaced.length>1?'s':''} à placer`);
  else showToast(`${layout.placed.length} visuels placés ✓`);
}

// ── EXPORT PDF 300 DPI — fond transparent ──
async function renderSheetCanvas(sheet){
  await Promise.all((sheet.elements || []).map(el => sharpenVectorElement(el)));
  const expW = Math.round(mm2e(sheet.w)), expH = Math.round(mm2e(sheet.h));
  const offscreen = document.createElement('canvas');
  offscreen.width = expW;
  offscreen.height = expH;
  const ctx = offscreen.getContext('2d');
  await Promise.all(sheet.elements.map(el=>{
    if(isTextElement(el)){
      return ensureTextFontLoaded(getTextFont(el), el.fontSizeMm, getTextWeight(el)).then(()=>{
        ctx.save();
        ctx.scale(MM2EXPORT, MM2EXPORT);
        drawCanvasTextElement(ctx, el);
        ctx.restore();
      });
    }
    return new Promise(res=>{
    const img = new Image(); img.crossOrigin='anonymous';
    const done = ()=>{ clearTimeout(timer); res(); };
    const timer = setTimeout(done, 12000);
    img.onload = ()=>{
      drawImageWithRotation(ctx, img, Math.round(mm2e(el.x)), Math.round(mm2e(el.y)), Math.round(mm2e(el.w)), Math.round(mm2e(el.h)), el.rotation || 0);
      done();
    };
    img.onerror = done;
    img.src = elementSrc(el);
  });
  }));
  return offscreen;
}

function loadImageElement(src){
  return new Promise((resolve, reject)=>{
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = ()=>resolve(img);
    img.onerror = ()=>reject(new Error('Impossible de charger un logo pour l’export'));
    img.src = src;
  });
}

function exportSourceSize(el){
  const sourceW = Math.max(1, elementNaturalW(el));
  const sourceH = Math.max(1, elementNaturalH(el));
  const physicalW = isQuarterTurn(el.rotation) ? el.h : el.w;
  const physicalH = isQuarterTurn(el.rotation) ? el.w : el.h;
  if(vectorSourceForAsset(imageForElement(el))){
    const pixels = vectorRasterPixels(physicalW, physicalH);
    return {w: pixels.w, h: pixels.h, scale:1, downsample:true, vector:true};
  }
  const targetW = Math.max(1, Math.round((physicalW / 25.4) * EXPORT_MAX_DPI));
  const targetH = Math.max(1, Math.round((physicalH / 25.4) * EXPORT_MAX_DPI));
  let scale = Math.min(1, targetW / sourceW, targetH / sourceH);
  const sourcePixels = sourceW * sourceH;
  if(sourcePixels * scale * scale > EXPORT_MAX_IMAGE_PIXELS){
    scale = Math.min(scale, Math.sqrt(EXPORT_MAX_IMAGE_PIXELS / sourcePixels));
  }
  const w = Math.max(1, Math.round(sourceW * scale));
  const h = Math.max(1, Math.round(sourceH * scale));
  return {w, h, scale, downsample:scale < 0.999};
}

function sourceCacheKey(src){
  let hash = 0;
  const str = String(src || '');
  for(let i=0; i<str.length; i+=Math.max(1, Math.floor(str.length / 2000))){
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return `${str.length}:${hash}`;
}

async function renderSourceCanvas(el, size=exportSourceSize(el)){
  const vectorSource = vectorSourceForAsset(imageForElement(el));
  if(vectorSource && window.pdfjsLib){
    const page = await pdfPageForSource(vectorSource);
    return renderPdfCropCanvas(page, vectorSource.crop, size.w, size.h);
  }
  const img = await loadImageElement(elementSrc(el));
  const canvas = document.createElement('canvas');
  canvas.width = size.w;
  canvas.height = size.h;
  const ctx = canvas.getContext('2d', {alpha:true});
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, 0, 0, size.w, size.h);
  return canvas;
}

function drawImageWithRotation(ctx, img, x, y, w, h, rotation=0){
  const rot = normalizeRotation(rotation);
  if(!rot){
    ctx.drawImage(img, x, y, w, h);
    return;
  }
  ctx.save();
  ctx.translate(x + w/2, y + h/2);
  ctx.rotate(rot * Math.PI / 180);
  if(rot % 180 === 90){
    ctx.drawImage(img, -h/2, -w/2, h, w);
  } else {
    ctx.drawImage(img, -w/2, -h/2, w, h);
  }
  ctx.restore();
}

function drawCanvasTextElement(ctx, el){
  const rot = normalizeRotation(el.rotation);
  const drawW = isQuarterTurn(rot) ? el.h : el.w;
  const drawH = isQuarterTurn(rot) ? el.w : el.h;
  const fontSize = el.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  const align = getTextAlign(el);
  const lines = String(el.text || 'Texte').split(/\r?\n/);
  const lineHeight = fontSize * 1.18;
  const totalH = lineHeight * lines.length;
  ctx.save();
  ctx.translate(el.x + el.w / 2, el.y + el.h / 2);
  ctx.rotate(rot * Math.PI / 180);
  ctx.font = `${getTextWeight(el)} ${fontSize}px ${fontFamilyCss(getTextFont(el))}`;
  ctx.fillStyle = el.color || DEFAULT_TEXT_COLOR;
  ctx.textAlign = align;
  ctx.textBaseline = 'middle';
  const x = align === 'center' ? 0 : align === 'right' ? drawW / 2 : -drawW / 2;
  let y = -totalH / 2 + lineHeight / 2;
  lines.forEach(line=>{
    ctx.fillText(line || ' ', x, y, drawW);
    y += lineHeight;
  });
  ctx.restore();
}

function canvasToPngBytes(canvas){
  return new Promise((resolve, reject)=>{
    canvas.toBlob(blob=>{
      if(!blob){ reject(new Error('Impossible de préparer l’image de la planche')); return; }
      blob.arrayBuffer().then(resolve, reject);
    }, 'image/png');
  });
}

function dataUrlToBytes(src){
  const match = String(src || '').match(/^data:([^;,]+)(;base64)?,(.*)$/);
  if(!match) return null;
  const mime = match[1].toLowerCase();
  const isBase64 = !!match[2];
  const payload = match[3];
  if(isBase64){
    const binary = atob(payload);
    const bytes = new Uint8Array(binary.length);
    for(let i=0; i<binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return {mime, bytes};
  }
  const text = decodeURIComponent(payload);
  const bytes = new TextEncoder().encode(text);
  return {mime, bytes};
}

function getPdfFontkit(){
  return window.fontkit || window.Fontkit || window.PDFFontkit || null;
}

function googleFontCssUrl(family, text, weight=400){
  let url = `https://fonts.googleapis.com/css2?family=${googleFontParam(family, String(weight))}&display=swap`;
  if(text) url += `&text=${encodeURIComponent(text)}`;
  return url;
}

async function fetchGoogleFontBytes(family, text, weight=400){
  const cssRes = await fetch(googleFontCssUrl(family, text, weight), {mode:'cors'});
  if(!cssRes.ok) throw new Error(`Police Google indisponible : ${family}`);
  const css = await cssRes.text();
  const match = css.match(/url\((['"]?)(https?:\/\/[^)'"]+)\1\)/);
  if(!match) throw new Error(`Fichier de police introuvable : ${family}`);
  const fontRes = await fetch(match[2], {mode:'cors'});
  if(!fontRes.ok) throw new Error(`Chargement de police impossible : ${family}`);
  return fontRes.arrayBuffer();
}

async function getPdfOutlineFont(el, fontCache){
  const selectedFamily = getTextFont(el);
  const uploaded = UPLOADED_FONTS.get(selectedFamily);
  if(uploaded){
    const key = `uploaded:${selectedFamily}`;
    if(fontCache.has(key)) return fontCache.get(key);
    const fontPromise = (async()=>{
      const kit = getPdfFontkit();
      if(!kit?.create) throw new Error('Vectorisation de police indisponible');
      return kit.create(uploaded.bytes.slice());
    })();
    fontCache.set(key, fontPromise);
    return fontPromise;
  }
  const localFont = GOOGLE_TEXT_FONTS.find(item=>item.family === selectedFamily && item.local);
  if(localFont){
    const key = `local:${selectedFamily}`;
    if(fontCache.has(key)) return fontCache.get(key);
    const fontPromise = (async()=>{
      const kit = getPdfFontkit();
      if(!kit?.create) throw new Error('Vectorisation de police indisponible');
      const url = window.EDITEUR_SHERPA_LOCAL_FONTS?.[selectedFamily];
      if(!url) throw new Error(`Police locale introuvable : ${selectedFamily}`);
      const res = await fetch(url);
      if(!res.ok) throw new Error(`Chargement de police impossible : ${selectedFamily}`);
      return kit.create(new Uint8Array(await res.arrayBuffer()));
    })();
    fontCache.set(key, fontPromise);
    return fontPromise;
  }
  const fontDef = GOOGLE_TEXT_FONTS.find(item=>item.family === selectedFamily);
  if(fontDef?.system) throw new Error(`Police système non vectorisée : ${selectedFamily}`);
  const family = fontDef?.google === false ? (fontDef.exportFamily || DEFAULT_TEXT_FONT) : selectedFamily;
  const weight = fontDef?.google === false && fontDef.exportWeight ? fontDef.exportWeight : getTextWeight(el);
  const key = `${selectedFamily}:${family}:${weight}:${el.text || ''}`;
  if(fontCache.has(key)) return fontCache.get(key);
  const fontPromise = (async()=>{
    const kit = getPdfFontkit();
    if(!kit?.create) throw new Error('Vectorisation de police indisponible');
    const bytes = await fetchGoogleFontBytes(family, el.text || 'Texte', weight);
    return kit.create(new Uint8Array(bytes));
  })();
  fontCache.set(key, fontPromise);
  return fontPromise;
}

function pdfColor(hex, rgbFn){
  const clean = String(hex || DEFAULT_TEXT_COLOR).replace('#','');
  const value = /^[0-9a-fA-F]{6}$/.test(clean) ? clean : DEFAULT_TEXT_COLOR.slice(1);
  const r = parseInt(value.slice(0,2), 16) / 255;
  const g = parseInt(value.slice(2,4), 16) / 255;
  const b = parseInt(value.slice(4,6), 16) / 255;
  return rgbFn(r, g, b);
}

function pdfPathNumber(value){
  return Number.isFinite(value) ? String(Math.round(value * 1000) / 1000) : '0';
}

function transformPdfTextPoint(xMm, yMm, cx, cy, ptPerMm, cos, sin){
  return {
    x: cx + (xMm * cos - yMm * sin) * ptPerMm,
    y: cy + (xMm * sin + yMm * cos) * ptPerMm
  };
}

function getPdfOperators(){
  const lib = typeof PDFLib !== 'undefined' ? PDFLib : window.PDFLib;
  if(!lib) return null;
  const keys = ['pushGraphicsState','popGraphicsState','setFillingColor','moveTo','lineTo','appendBezierCurve','closePath','fill'];
  return keys.every(key => typeof lib[key] === 'function') ? lib : null;
}

function glyphCommandsToPdfOperators(commands, transform, pdfOps){
  if(!Array.isArray(commands) || !pdfOps) return [];
  const ops = [];
  let current = {x:0, y:0};
  let start = {x:0, y:0};
  commands.forEach(cmd=>{
    const name = cmd.command || cmd.type || '';
    const args = cmd.args || [];
    if(name === 'moveTo' || name === 'M'){
      current = {x:args[0] || 0, y:args[1] || 0};
      start = {...current};
      const p = transform(current.x, current.y);
      ops.push(pdfOps.moveTo(p.x, p.y));
    } else if(name === 'lineTo' || name === 'L'){
      current = {x:args[0] || 0, y:args[1] || 0};
      const p = transform(current.x, current.y);
      ops.push(pdfOps.lineTo(p.x, p.y));
    } else if(name === 'quadraticCurveTo' || name === 'Q'){
      const q1 = {x:args[0] || 0, y:args[1] || 0};
      const q2 = {x:args[2] || 0, y:args[3] || 0};
      const c1 = {x:current.x + (2/3) * (q1.x - current.x), y:current.y + (2/3) * (q1.y - current.y)};
      const c2 = {x:q2.x + (2/3) * (q1.x - q2.x), y:q2.y + (2/3) * (q1.y - q2.y)};
      const p1 = transform(c1.x, c1.y);
      const p2 = transform(c2.x, c2.y);
      const p3 = transform(q2.x, q2.y);
      ops.push(pdfOps.appendBezierCurve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y));
      current = q2;
    } else if(name === 'bezierCurveTo' || name === 'curveTo' || name === 'C'){
      const p1 = transform(args[0] || 0, args[1] || 0);
      const p2 = transform(args[2] || 0, args[3] || 0);
      const p3 = transform(args[4] || 0, args[5] || 0);
      ops.push(pdfOps.appendBezierCurve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y));
      current = {x:args[4] || 0, y:args[5] || 0};
    } else if(name === 'closePath' || name === 'Z'){
      ops.push(pdfOps.closePath());
      current = {...start};
    }
  });
  return ops;
}

function textUsesInstalledFace(el){
  const selectedFamily = getTextFont(el);
  if(UPLOADED_FONTS.has(selectedFamily)) return false;
  const fontDef = GOOGLE_TEXT_FONTS.find(item=>item.family === selectedFamily);
  return !!(fontDef && fontDef.system);
}

// Paint an installed face (Impact) with the same canvas font the sheet uses.
// Glyph outlines are not available without redistributing the system file, and
// a substitute face (Anton) has different advances and a different "1".
async function renderInstalledFacePng(el){
  const rot = normalizeRotation(el.rotation);
  const drawW = isQuarterTurn(rot) ? el.h : el.w;
  const drawH = isQuarterTurn(rot) ? el.w : el.h;
  const fontSizeMm = el.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  const weight = getTextWeight(el);
  await ensureTextFontLoaded(getTextFont(el), fontSizeMm, weight);
  if(document.fonts?.ready) await document.fonts.ready;
  const maxSide = 8192;
  let pxPerMm = EXPORT_DPI / 25.4;
  const longest = Math.max(el.w || 0, el.h || 0) * pxPerMm;
  if(longest > maxSide) pxPerMm *= maxSide / longest;
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.ceil((el.w || 0) * pxPerMm));
  canvas.height = Math.max(1, Math.ceil((el.h || 0) * pxPerMm));
  const ctx = canvas.getContext('2d');
  const fontPx = fontSizeMm * pxPerMm;
  ctx.font = `${weight} ${fontPx}px ${fontFamilyCss(getTextFont(el))}`;
  ctx.fillStyle = el.color || DEFAULT_TEXT_COLOR;
  const align = getTextAlign(el);
  ctx.textAlign = align;
  ctx.textBaseline = 'alphabetic';
  const lines = String(el.text || 'Texte').split(/\r?\n/);
  const sample = lines.find(line=>String(line).trim()) || 'Hg';
  const metrics = ctx.measureText(sample);
  const ascent = Number(metrics.fontBoundingBoxAscent);
  const descent = Number(metrics.fontBoundingBoxDescent);
  // Same em-box centering as CSS line-height 1.15 + align-items:center.
  const emCenterPx = (ascent > 0 || descent > 0) ? (ascent - descent) / 2 : fontPx * 0.35;
  const lineHeightPx = fontPx * 1.15;
  const blockH = lineHeightPx * lines.length;
  const anchorX = align === 'center' ? 0 : align === 'right' ? (drawW * pxPerMm) / 2 : -(drawW * pxPerMm) / 2;
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate(rot * Math.PI / 180);
  let lineCenterY = -blockH / 2 + lineHeightPx / 2;
  lines.forEach(line=>{
    if(!line){
      lineCenterY += lineHeightPx;
      return;
    }
    ctx.fillText(line, anchorX, lineCenterY + emCenterPx);
    lineCenterY += lineHeightPx;
  });
  return canvasToPngBytes(canvas);
}

async function drawPdfInstalledFace(page, pdfDoc, el, ptH, ptPerMm){
  const pngBytes = await renderInstalledFacePng(el);
  const image = await pdfDoc.embedPng(pngBytes);
  // Rotation is already in the pixels, clockwise, around the element center.
  page.drawImage(image, {
    x: el.x * ptPerMm,
    y: ptH - ((el.y + el.h) * ptPerMm),
    width: el.w * ptPerMm,
    height: el.h * ptPerMm
  });
}

async function drawPdfTextElement(page, pdfDoc, el, fontCache, ptH, ptPerMm, degreesFn, rgbFn){
  if(textUsesInstalledFace(el)){
    await drawPdfInstalledFace(page, pdfDoc, el, ptH, ptPerMm);
    return;
  }
  const font = await getPdfOutlineFont(el, fontCache);
  const pdfOps = getPdfOperators();
  const stream = page.getContentStream?.();
  if(!pdfOps || !stream?.push) throw new Error('Dessin vectoriel PDF indisponible');
  const rot = normalizeRotation(el.rotation);
  const drawW = isQuarterTurn(rot) ? el.h : el.w;
  const fontSizeMm = el.fontSizeMm || DEFAULT_TEXT_SIZE_MM;
  // Same line box as .text-visual (line-height: 1.15), centered on the element.
  const lineHeightMm = fontSizeMm * 1.15;
  const lines = String(el.text || 'Texte').split(/\r?\n/);
  const blockH = lineHeightMm * lines.length;
  const cx = (el.x + el.w / 2) * ptPerMm;
  const cy = ptH - ((el.y + el.h / 2) * ptPerMm);
  // Editor rotation is clockwise on a Y-down canvas. Glyph outlines are Y-up,
  // so the same turn is the opposite angle. 0° and 180° stay identical.
  const angle = -rot * Math.PI / 180;
  const unitsPerEm = font.unitsPerEm || 1000;
  const ascent = Number(font.ascent);
  const descent = Number(font.descent);
  const emCenterAboveBaseline = (Number.isFinite(ascent) && Number.isFinite(descent))
    ? (ascent + descent) / 2 / unitsPerEm
    : 0.35;
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const color = pdfColor(el.color, rgbFn);
  const scaleMm = fontSizeMm / unitsPerEm;
  const ops = [pdfOps.pushGraphicsState(), pdfOps.setFillingColor(color)];
  let hasGlyphPath = false;
  const align = getTextAlign(el);
  lines.forEach((line, index)=>{
    const run = font.layout(line || ' ');
    let lineAdvance = 0;
    (run.positions || []).forEach((pos, glyphIndex)=>{
      lineAdvance += pos.xAdvance || run.glyphs?.[glyphIndex]?.advanceWidth || 0;
    });
    const lineWidthMm = lineAdvance * scaleMm;
    let startXMm = -drawW / 2;
    if(align === 'center') startXMm = -lineWidthMm / 2;
    else if(align === 'right') startXMm = drawW / 2 - lineWidthMm;
    let cursorX = 0;
    const lineCenterY = blockH / 2 - lineHeightMm / 2 - index * lineHeightMm;
    const baselineY = lineCenterY - emCenterAboveBaseline * fontSizeMm;
    run.glyphs.forEach((glyph, glyphIndex)=>{
      const pos = run.positions[glyphIndex] || {};
      const glyphX = startXMm + (cursorX + (pos.xOffset || 0)) * scaleMm;
      const glyphY = baselineY + (pos.yOffset || 0) * scaleMm;
      const transform = (x, y) => transformPdfTextPoint(glyphX + x * scaleMm, glyphY + y * scaleMm, cx, cy, ptPerMm, cos, sin);
      const glyphOps = glyphCommandsToPdfOperators(glyph.path?.commands, transform, pdfOps);
      if(glyphOps.length){
        hasGlyphPath = true;
        ops.push(...glyphOps);
      }
      cursorX += pos.xAdvance || glyph.advanceWidth || 0;
    });
  });
  if(hasGlyphPath){
    ops.push(pdfOps.fill(), pdfOps.popGraphicsState());
    stream.push(...ops);
  }
}

async function embedElementImage(pdfDoc, el, cache){
  const size = exportSourceSize(el);
  if(size.vector){
    const key = `vector:${el.imageId}:${size.w}x${size.h}`;
    if(cache.has(key)) return cache.get(key);
    const embedded = (async()=>{
      const sourceCanvas = await renderSourceCanvas(el, size);
      const pngBytes = await canvasToPngBytes(sourceCanvas);
      return pdfDoc.embedPng(pngBytes);
    })();
    cache.set(key, embedded);
    return embedded;
  }
  const src = elementSrc(el);
  const baseKey = sourceCacheKey(src);
  const data = size.downsample ? null : dataUrlToBytes(src);
  const canEmbedSource = !size.downsample && (data?.mime === 'image/png' || data?.mime === 'image/jpeg' || data?.mime === 'image/jpg');
  const key = canEmbedSource ? `source:${baseKey}` : `raster:${baseKey}:${size.w}x${size.h}`;
  if(cache.has(key)) return cache.get(key);

  const embedded = (async()=>{
    if(canEmbedSource){
      return data.mime === 'image/png' ? pdfDoc.embedPng(data.bytes) : pdfDoc.embedJpg(data.bytes);
    }
    const sourceCanvas = await renderSourceCanvas(el, size);
    const pngBytes = await canvasToPngBytes(sourceCanvas);
    return pdfDoc.embedPng(pngBytes);
  })();
  cache.set(key, embedded);
  return embedded;
}

// CSS rotate(θdeg) is clockwise around the AABB center (Y-down).
// pdf-lib rotate is counterclockwise around the unrotated bottom-left (Y-up).
// Use −θ and place that origin so the visual box stays el.x/y/w/h.
function pdfCssAngle(rot){
  return (360 - normalizeRotation(rot)) % 360;
}

function pdfElementDrawSpec(el, ptH, ptPerMm){
  const rot = normalizeRotation(el.rotation);
  const aabbW = el.w * ptPerMm;
  const aabbH = el.h * ptPerMm;
  const left = el.x * ptPerMm;
  const bottom = ptH - ((el.y + el.h) * ptPerMm);
  const physicalW = (isQuarterTurn(rot) ? el.h : el.w) * ptPerMm;
  const physicalH = (isQuarterTurn(rot) ? el.w : el.h) * ptPerMm;
  const cx = left + aabbW / 2;
  const cy = bottom + aabbH / 2;
  const angle = pdfCssAngle(rot);
  const rad = angle * Math.PI / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return {
    x: cx - (physicalW / 2) * cos + (physicalH / 2) * sin,
    y: cy - (physicalW / 2) * sin - (physicalH / 2) * cos,
    width: physicalW,
    height: physicalH,
    angle
  };
}

function applyPdfElementDrawSpec(drawFn, spec, degreesFn){
  const opts = {x: spec.x, y: spec.y, width: spec.width, height: spec.height};
  if(spec.angle){
    if(!degreesFn) throw new Error('Rotation PDF indisponible');
    opts.rotate = degreesFn(spec.angle);
  }
  drawFn(opts);
}

function drawPdfElementImage(page, image, el, ptH, ptPerMm, degreesFn){
  applyPdfElementDrawSpec(opts => page.drawImage(image, opts), pdfElementDrawSpec(el, ptH, ptPerMm), degreesFn);
}

// PDF /Rotate N = viewer turns the page N° clockwise. embedPdf ignores it, so
// bake the same turn into the Form and advertise the displayed width/height.
function vectorPageDisplayMatrix(mediaW, mediaH, rotate){
  const rot = normalizeRotation(rotate);
  if(rot === 90) return [0, -1, 1, 0, 0, mediaW];
  if(rot === 180) return [-1, 0, 0, -1, mediaW, mediaH];
  if(rot === 270) return [0, 1, -1, 0, mediaH, 0];
  return [1, 0, 0, 1, 0, 0];
}

async function embedElementVectorPage(pdfDoc, el, cache){
  const asset = imageForElement(el);
  const dataUrl = asset?.vectorPdfDataUrl;
  if(!dataUrl) return null;
  const key = `vectorpdf:${asset.id}:${sourceCacheKey(dataUrl)}`;
  if(cache.has(key)) return cache.get(key);
  const data = dataUrlToBytes(dataUrl);
  if(!data?.bytes?.length) return null;
  const embedded = (async()=>{
    try{
      const lib = typeof PDFLib !== 'undefined' ? PDFLib : window.PDFLib;
      if(!lib?.PDFDocument?.load){
        const pages = await pdfDoc.embedPdf(data.bytes, [0]);
        return pages[0] || null;
      }
      const srcDoc = await lib.PDFDocument.load(data.bytes);
      const srcPage = srcDoc.getPages()[0];
      if(!srcPage) return null;
      const media = srcPage.getSize();
      const pageRot = normalizeRotation(srcPage.getRotation?.().angle ?? 0);
      if(!pageRot){
        const pages = await pdfDoc.embedPdf(data.bytes, [0]);
        return pages[0] || null;
      }
      const displayW = isQuarterTurn(pageRot) ? media.height : media.width;
      const displayH = isQuarterTurn(pageRot) ? media.width : media.height;
      return pdfDoc.embedPage(
        srcPage,
        {left:0, bottom:0, right:displayW, top:displayH},
        vectorPageDisplayMatrix(media.width, media.height, pageRot)
      );
    }catch(error){
      console.warn('Vector PDF embed failed, falling back to raster:', error);
      return null;
    }
  })();
  cache.set(key, embedded);
  return embedded;
}

function drawPdfElementVectorPage(page, embeddedPage, el, ptH, ptPerMm, degreesFn){
  if(!embeddedPage || typeof page.drawPage !== 'function') return false;
  applyPdfElementDrawSpec(opts => page.drawPage(embeddedPage, opts), pdfElementDrawSpec(el, ptH, ptPerMm), degreesFn);
  return true;
}

function downloadBlob(blob, fileName){
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  // If `download` is ignored (iframe / Safari), open a tab instead of replacing the editor.
  a.target = '_blank';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  setTimeout(()=>{
    URL.revokeObjectURL(url);
    a.remove();
  }, 1500);
}

function sanitizeFileName(name){
  return String(name || 'planche')
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/[^a-zA-Z0-9._-]+/g,'-')
    .replace(/^-+|-+$/g,'')
    .toLowerCase() || 'planche';
}

function formatExportName(w, h){
  const fmt = getFormatBySize(w, h);
  return fmt ? fmt.exportLabel : `${w}x${h}mm`;
}

function sheetExportFileName(sheet, ext='pdf'){
  const safeExt = String(ext || 'pdf').replace(/^\./, '') || 'pdf';
  return `${sanitizeFileName(sheet.name)}-${formatExportName(sheet.w,sheet.h)}-300dpi.${safeExt}`;
}

function canvasToBlob(canvas, type='image/png'){
  return new Promise((resolve, reject)=>{
    canvas.toBlob((blob)=>{
      if(!blob) reject(new Error('Export image impossible'));
      else resolve(blob);
    }, type);
  });
}

async function buildSheetLibraryPng(sheet, busyId=null, label=''){
  // Same visual pipeline as the editor canvas (Y-down + CSS-equivalent rotations).
  // Avoids PDF page/Rotate and server PDF previews that come back sideways.
  if(busyId) updateBusy(busyId, `${label}Rendu de la planche…`);
  const canvas = await renderSheetCanvas(sheet);
  if(busyId) updateBusy(busyId, `${label}Préparation PNG…`);
  const blob = await canvasToBlob(canvas, 'image/png');
  return {
    blob,
    fileName: sheetExportFileName(sheet, 'png'),
    widthMm: sheet.w,
    heightMm: sheet.h,
    widthPx: canvas.width,
    heightPx: canvas.height
  };
}

async function buildSheetPDFBlob(sheet, busyId=null, label='', opts={}){
  if(typeof PDFLib === 'undefined') throw new Error('Export PDF indisponible');
  const {PDFDocument, degrees, rgb} = PDFLib;
  const pdfDegrees = degrees || PDFLib.degrees;
  const pdfRgb = rgb || PDFLib.rgb;
  // Mes fichiers: flatten vector embeds — their page /Rotate often reappears sideways on re-import.
  const flattenVectors = opts.flattenVectors === true;
  if(busyId) updateBusy(busyId, `${label}Préparation PDF…`);
  const pdfDoc = await PDFDocument.create();
  pdfDoc.setTitle(`Amalgame - ${sheet.name}`);
  pdfDoc.setSubject(`${sheet.name} exportée à 300 DPI`);
  pdfDoc.setKeywords([sheet.name, formatName(sheet.w, sheet.h)]);
  const ptW = sheet.w*(72/25.4), ptH = sheet.h*(72/25.4);
  const ptPerMm = 72 / 25.4;
  const page = pdfDoc.addPage([ptW, ptH]);
  if(typeof page.setRotation === 'function'){
    try{ page.setRotation(pdfDegrees(0)); }catch(_){}
  }
  const imageCache = new Map();
  const fontCache = new Map();
  if(busyId) updateBusy(busyId, `${label}Placement des éléments…`);
  for(const el of sheet.elements){
    if(isTextElement(el)){
      await drawPdfTextElement(page, pdfDoc, el, fontCache, ptH, ptPerMm, pdfDegrees, pdfRgb);
      continue;
    }
    if(!flattenVectors){
      const vectorPage = await embedElementVectorPage(pdfDoc, el, imageCache);
      if(vectorPage && drawPdfElementVectorPage(page, vectorPage, el, ptH, ptPerMm, pdfDegrees)){
        continue;
      }
    }
    const image = await embedElementImage(pdfDoc, el, imageCache);
    drawPdfElementImage(page, image, el, ptH, ptPerMm, pdfDegrees);
  }
  if(busyId) updateBusy(busyId, `${label}Finalisation PDF…`);
  const pdfBytes = await pdfDoc.save();
  return new Blob([pdfBytes], {type:'application/pdf'});
}

async function downloadSheetPDF(sheet, busyId=null, label=''){
  const blob = await buildSheetPDFBlob(sheet, busyId, label);
  if(busyId) updateBusy(busyId, `${label}Téléchargement PDF…`);
  downloadBlob(blob, sheetExportFileName(sheet));
  return blob;
}

async function downloadActiveSheetPDF(){
  saveActiveSheet();
  const sheet = sheets.find(s => s.id === activeSheetId) || sheets[0];
  if(!sheet){ showToast('Planche introuvable'); return; }
  if(!sheet.elements.length){ showToast('Ajoutez des éléments avant de télécharger'); return; }
  warnIfOutOfSheet(sheet.elements, sheet.w, sheet.h);

  const downloadBtn = document.getElementById('sherpa-download-btn');
  if(downloadBtn) downloadBtn.disabled = true;
  try{
    if(!(await confirmDownloadCredit('le PDF'))) return;
    const busyId = beginBusy(`Génération PDF ${sheet.name}…`);
    showToast(`Génération PDF ${sheet.name}…`);
    try{
      const blob = await buildSheetPDFBlob(sheet, busyId);
      if(!(await consumeDownloadCredit())) return;
      downloadBlob(blob, sheetExportFileName(sheet));
      showToast(`${sheet.name} téléchargée en PDF ✓`);
    }catch(err){
      console.error(err);
      showToast('Erreur export : ' + (err?.message || err));
    }finally{
      endBusy(busyId);
    }
  }finally{
    if(downloadBtn) downloadBtn.disabled = false;
  }
}
window.downloadActiveSheetPDF = downloadActiveSheetPDF;

async function saveActiveSheetToLibrary(){
  const sheet = sheets.find(s => s.id === activeSheetId) || sheets[0];
  if(!sheet){ showToast('Planche introuvable'); return; }
  const saveBtn = document.getElementById('sherpa-save-btn');
  if(saveBtn) saveBtn.disabled = true;
  try{
    await saveSheetToLibrary(sheet.id);
  }finally{
    if(saveBtn) saveBtn.disabled = false;
  }
}
window.saveActiveSheetToLibrary = saveActiveSheetToLibrary;

async function exportSheetPDF(sheetId, event){
  event?.preventDefault();
  event?.stopPropagation();
  saveActiveSheet();
  renderSheetsPanel();
  const sheet = sheets.find(s => s.id === sheetId);
  if(!sheet){ showToast('Planche introuvable'); return; }
  if(!sheet.elements.length){ showToast('Cette planche est vide'); return; }
  warnIfOutOfSheet(sheet.elements, sheet.w, sheet.h);
  if(!(await confirmDownloadCredit(`le PDF ${sheet.name}`))) return;
  const busyId = beginBusy(`Génération PDF ${sheet.name}…`);
  showToast(`Génération PDF ${sheet.name}…`);
  try {
    const blob = await buildSheetPDFBlob(sheet, busyId);
    if(!(await consumeDownloadCredit())) return;
    downloadBlob(blob, sheetExportFileName(sheet));
    showToast(`${sheet.name} téléchargée en PDF ✓`);
  } catch(err){
    console.error(err);
    showToast('Erreur export : '+err.message);
  } finally {
    endBusy(busyId);
  }
}

async function saveSheetToLibrary(sheetId, event){
  event?.preventDefault();
  event?.stopPropagation();
  saveActiveSheet();
  renderSheetsPanel();
  const sheet = sheets.find(s => s.id === sheetId);
  if(!sheet){ showToast('Planche introuvable'); return; }
  if(!sheet.elements.length){ showToast('Cette planche est vide'); return; }
  if(!libraryConfig.isLoggedIn || !libraryConfig.customerId){
    showToast('Connectez-vous pour sauvegarder dans Mes fichiers');
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    const loginUrl = libraryConfig.loginUrl || '/account/login';
    const separator = loginUrl.includes('?') ? '&' : '?';
    window.setTimeout(()=>{
      window.location.assign(`${loginUrl}${separator}return_url=${returnUrl}`);
    }, 400);
    return;
  }

  warnIfOutOfSheet(sheet.elements, sheet.w, sheet.h);
  const busyId = beginBusy(`Sauvegarde de ${sheet.name}…`);
  showToast(`Sauvegarde de ${sheet.name} dans Mes fichiers…`);
  try{
    const exported = await buildSheetLibraryPng(sheet, busyId, 'Sauvegarde · ');
    updateBusy(busyId, `Envoi de ${sheet.name}…`);
    const file = new File([exported.blob], exported.fileName, {type: 'image/png'});
    await libraryUploadFile(file, {
      widthMm: exported.widthMm,
      heightMm: exported.heightMm
    });
    libraryState.loaded = false;
    showToast(`${sheet.name} sauvegardée dans Mes fichiers ✓`);
  }catch(err){
    console.error('[Sherpa] save sheet to library:', err);
    showToast(err?.message || 'Impossible de sauvegarder la planche');
  }finally{
    endBusy(busyId);
  }
}

async function exportPDF(){
  saveActiveSheet();
  const sheetsToExport = sheets.filter(s => s.elements.length > 0);
  if(!sheetsToExport.length){ showToast('Aucune planche à exporter'); return; }
  const overflowCount = sheetsToExport.reduce((n, sheet) => n + getOutOfSheetElements(sheet.elements, sheet.w, sheet.h).length, 0);
  if(overflowCount){
    showToast(overflowCount === 1
      ? 'Attention : 1 élément hors planche ne sera pas entièrement imprimé'
      : `Attention : ${overflowCount} éléments hors planche ne seront pas entièrement imprimés`);
  }
  const busyId = beginBusy(`Génération de ${sheetsToExport.length} PDF…`);
  showToast(`Génération de ${sheetsToExport.length} PDF…`);
  try {
    if(typeof PDFLib === 'undefined'){
      let exported = 0;
      for(const sheet of sheetsToExport){
        if(!(await confirmDownloadCredit(`le fichier ${sheet.name}`))) break;
        updateBusy(busyId, `Rendu ${sheet.name}…`);
        const canvas = await renderSheetCanvas(sheet);
        const blob = await canvasToBlob(canvas, 'image/png');
        if(!(await consumeDownloadCredit())) break;
        downloadBlob(blob, `${sanitizeFileName(sheet.name)}-${formatExportName(sheet.w,sheet.h)}-300dpi.png`);
        exported += 1;
      }
      showToast(exported ? `${exported} export PNG transparent 300 DPI lancé${exported>1?'s':''} ✓` : 'Export annulé');
      return;
    }

    let exported = 0;
    for(let i=0; i<sheetsToExport.length; i++){
      const sheet = sheetsToExport[i];
      if(!(await confirmDownloadCredit(`le PDF ${sheet.name}`))) break;
      showToast(`Préparation PDF ${i+1}/${sheetsToExport.length}…`);
      const blob = await buildSheetPDFBlob(sheet, busyId, `${i+1}/${sheetsToExport.length} · `);
      if(!(await consumeDownloadCredit())) break;
      downloadBlob(blob, sheetExportFileName(sheet));
      exported += 1;
      await new Promise(res=>setTimeout(res, 250));
    }
    showToast(exported ? `${exported} PDF séparé${exported>1?'s':''} exporté${exported>1?'s':''} ✓` : 'Export annulé');
  } catch(err){
    console.error(err); showToast('Erreur export : '+err.message);
  } finally {
    endBusy(busyId);
  }
}

// ── TOAST ──
function showToast(msg){
  const t = document.getElementById('toast'); t.textContent=msg; t.classList.add('show');
  setTimeout(()=>t.classList.remove('show'), 2800);
}

function beginBusy(message){
  const id = nextBusyId++;
  busyOperations.set(id, message);
  renderBusy();
  return id;
}

function updateBusy(id, message){
  if(!busyOperations.has(id)) return;
  busyOperations.set(id, message);
  renderBusy();
}

function endBusy(id){
  busyOperations.delete(id);
  renderBusy();
}

function renderBusy(){
  const indicator = document.getElementById('busy-indicator');
  const label = document.getElementById('busy-label');
  const upload = document.getElementById('upload-btn');
  if(!indicator || !label) return;
  const messages = [...busyOperations.values()];
  const active = messages.length > 0;
  label.textContent = active
    ? (messages.length > 1 ? `${messages[0]} (+${messages.length - 1})` : messages[0])
    : 'Chargement…';
  indicator.classList.toggle('show', active);
  upload?.classList.toggle('loading', active);
}

// ── KEYBOARD ──
document.addEventListener('keydown', e=>{
  if(e.key === 'Escape' && document.getElementById('library-overlay')?.classList.contains('open')){
    e.preventDefault();
    closeLibraryModal();
    return;
  }
  if(e.key === 'Escape' && document.getElementById('font-overlay')?.classList.contains('open')){
    e.preventDefault();
    closeFontModal();
    return;
  }
  if(e.key === 'Escape' && document.getElementById('credit-overlay')?.classList.contains('open')){
    e.preventDefault();
    closeCreditModal(false);
    return;
  }
  if(e.target.tagName==='INPUT'||e.target.tagName==='SELECT'||e.target.tagName==='TEXTAREA'||e.target.isContentEditable) return;
  const ctrl = e.metaKey||e.ctrlKey;
  if(ctrl && e.key==='z'){          e.preventDefault(); undo(); return; }
  if(ctrl && (e.key==='y'||e.key==='Z')){ e.preventDefault(); redo(); return; }
  if(ctrl && e.key==='c'){          e.preventDefault(); copySelected(); return; }
  if(ctrl && e.key==='v'){          e.preventDefault(); pasteClipboard(); return; }
  if(ctrl && e.key==='d'){          e.preventDefault(); duplicateSelectedOnce(); return; }
  if(e.key==='Delete'||e.key==='Backspace'){ if(selectedIds.size){ e.preventDefault(); deleteSelected(); } return; }
  if(selected && ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)){
    e.preventDefault();
    const moving = getSelectedElements();
    if(!moving.length) return;
    const step = e.shiftKey ? 10 : 1;
    let dx = 0, dy = 0;
    if(e.key==='ArrowLeft')  dx = -step;
    if(e.key==='ArrowRight') dx = step;
    if(e.key==='ArrowUp')    dy = -step;
    if(e.key==='ArrowDown')  dy = step;
    const bounds = moving.reduce((b,item)=>({
      minX:Math.min(b.minX,item.x),
      minY:Math.min(b.minY,item.y),
      maxX:Math.max(b.maxX,item.x+item.w),
      maxY:Math.max(b.maxY,item.y+item.h)
    }), {minX:Infinity,minY:Infinity,maxX:-Infinity,maxY:-Infinity});
    dx = Math.min(Math.max(dx, -bounds.minX), sheetW - bounds.maxX);
    dy = Math.min(Math.max(dy, -bounds.minY), sheetH - bounds.maxY);
    moving.forEach(el=>{
      el.x += dx;
      el.y += dy;
      updateElemPos(el);
    });
    updatePropBar(); updateCoverage();
  }
  // zoom keyboard
  if(ctrl && (e.key==='+'||e.key==='=')){ e.preventDefault(); setZoom(zoomLevel+0.1); }
  if(ctrl && e.key==='-'){              e.preventDefault(); setZoom(zoomLevel-0.1); }
  if(ctrl && e.key==='0'){              e.preventDefault(); resetZoom(); }
});

// ── ACCOUNT FILE LIBRARY (Mes fichiers / Fast Order) ──
const libraryConfig = {
  customerId: EDITOR_ROOT?.dataset.customerId || '',
  isLoggedIn: EDITOR_ROOT?.dataset.customerLoggedIn === 'true',
  listUrl: EDITOR_ROOT?.dataset.libraryListUrl || '/apps/easy-order/file-storage/list',
  uploadUrl: EDITOR_ROOT?.dataset.libraryUploadUrl || '/apps/easy-order/file-storage/upload',
  deleteUrl: EDITOR_ROOT?.dataset.libraryDeleteUrl || '/apps/easy-order/file-storage/delete',
  loginUrl: EDITOR_ROOT?.dataset.loginUrl || '/account/login'
};

const libraryState = {
  files: [],
  loaded: false,
  loading: false,
  uploading: false,
  deletingKeys: new Set()
};

const libraryRefs = {
  overlay: document.getElementById('library-overlay'),
  grid: document.getElementById('library-grid'),
  search: document.getElementById('library-search'),
  status: document.getElementById('library-status'),
  loading: document.getElementById('library-loading'),
  error: document.getElementById('library-error'),
  empty: document.getElementById('library-empty'),
  noResults: document.getElementById('library-no-results'),
  uploadTrigger: document.getElementById('library-upload-trigger'),
  uploadInput: document.getElementById('library-upload-input'),
  retry: document.getElementById('library-retry')
};

function librarySetVisible(el, visible){
  if(!el) return;
  el.classList.toggle('visuallyhidden', !visible);
}

function librarySetStatus(message = '', type = ''){
  if(!libraryRefs.status) return;
  libraryRefs.status.textContent = message;
  libraryRefs.status.classList.toggle('is-error', type === 'error');
  libraryRefs.status.classList.toggle('is-success', type === 'success');
  libraryRefs.status.classList.toggle('is-loading', type === 'loading');
}

function normalizeLibrarySearch(value){
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function libraryFilename(file){
  const original = file?.metadata?.original_filename;
  if(original) return String(original);
  return String(file?.filename || file?.key || 'Fichier').replace(/^\d+_[a-f0-9-]{16,}_/i, '');
}

function libraryExtension(filename, contentType){
  const match = String(filename || '').match(/\.([a-z0-9]+)$/i);
  if(match) return match[1].toUpperCase();
  if(contentType === 'application/pdf') return 'PDF';
  if(contentType === 'image/png') return 'PNG';
  return 'FILE';
}

function libraryFormatBytes(value){
  const bytes = Number(value);
  if(!Number.isFinite(bytes) || bytes < 0) return '';
  if(bytes < 1024) return `${bytes} o`;
  if(bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  const mb = bytes / (1024 * 1024);
  return `${mb.toFixed(mb >= 10 ? 0 : 1).replace('.', ',')} Mo`;
}

function libraryFormatDate(value){
  if(!value) return '';
  const date = new Date(value);
  if(Number.isNaN(date.getTime())) return '';
  try{
    return new Intl.DateTimeFormat('fr', {day:'2-digit', month:'2-digit', year:'2-digit'}).format(date);
  }catch(_){
    return date.toLocaleDateString('fr');
  }
}

function libraryIsSafeImageUrl(url){
  try{
    const parsed = new URL(String(url || ''), window.location.origin);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  }catch(_){
    return false;
  }
}

function libraryThumbnailUrl(file){
  const url = file?.thumbnail?.download_url || file?.thumbnail?.url || file?.thumbnail_url || '';
  return libraryIsSafeImageUrl(url) ? String(url) : '';
}

function libraryIsRasterPreviewFile(file, name=''){
  const contentType = String(file?.content_type || '').toLowerCase();
  if(contentType.includes('png') || contentType.includes('jpeg') || contentType.includes('jpg') || contentType.includes('webp') || contentType.includes('gif')){
    return true;
  }
  return /\.(png|jpe?g|webp|gif)$/i.test(String(name || ''));
}

// Server thumbnails are often baked into a square and look stretched.
function libraryPreviewUrl(file, name=''){
  if(libraryIsRasterPreviewFile(file, name)){
    const original = file?.download_url || file?.url || file?.file_url || file?.original_url || '';
    if(libraryIsSafeImageUrl(original)) return String(original);
  }
  return libraryThumbnailUrl(file);
}

function fitLibraryPreviewImage(image, preview){
  if(!image || !preview) return;
  const naturalWidth = Number(image.naturalWidth) || 0;
  const naturalHeight = Number(image.naturalHeight) || 0;
  if(naturalWidth <= 0 || naturalHeight <= 0) return;
  const maxWidth = Math.max(24, preview.clientWidth - 20);
  const maxHeight = Math.max(24, preview.clientHeight - 20);
  const scale = Math.min(maxWidth / naturalWidth, maxHeight / naturalHeight);
  const width = Math.max(1, Math.round(naturalWidth * scale));
  const height = Math.max(1, Math.round(naturalHeight * scale));
  image.width = width;
  image.height = height;
  image.style.width = width + 'px';
  image.style.height = height + 'px';
  image.style.maxWidth = 'none';
  image.style.maxHeight = 'none';
}

async function libraryParseJson(response){
  const text = await response.text();
  if(!text) return {};
  try{ return JSON.parse(text); }
  catch(_){ throw new Error(text || `HTTP ${response.status}`); }
}

function openLibraryModal(event){
  if(event) event.preventDefault?.();
  if(!libraryConfig.isLoggedIn || !libraryConfig.customerId){
    showToast('Connectez-vous pour accéder à vos fichiers');
    const returnTo = encodeURIComponent(window.location.href);
    window.location.href = `${libraryConfig.loginUrl}${libraryConfig.loginUrl.includes('?') ? '&' : '?'}return_url=${returnTo}`;
    return;
  }
  if(!libraryRefs.overlay) return;
  libraryRefs.overlay.classList.add('open');
  libraryLoadFiles();
  requestAnimationFrame(()=> libraryRefs.search?.focus());
}

function closeLibraryModal(event){
  if(event && event.target !== event.currentTarget && event.type === 'click') return;
  libraryRefs.overlay?.classList.remove('open');
}

function libraryFilteredFiles(){
  const query = normalizeLibrarySearch(libraryRefs.search?.value);
  if(!query) return libraryState.files;
  return libraryState.files.filter(file => normalizeLibrarySearch(libraryFilename(file)).includes(query));
}

function libraryCreateCard(file){
  const filename = libraryFilename(file);
  const extension = libraryExtension(filename, file?.content_type);
  const size = libraryFormatBytes(file?.size);
  const date = libraryFormatDate(file?.last_modified);
  const width = file?.metadata?.width_mm;
  const height = file?.metadata?.height_mm;
  const thumb = libraryThumbnailUrl(file);
  const previewSrc = libraryPreviewUrl(file, filename);
  const key = String(file?.key || '');

  const card = document.createElement('article');
  card.className = 'library-card';
  card.dataset.fileKey = key;
  card.dataset.filename = filename;
  card.dataset.contentType = String(file?.content_type || '');
  card.tabIndex = 0;
  card.setAttribute('role', 'button');
  card.setAttribute('aria-label', `Ajouter ${filename} à la planche`);
  card.addEventListener('click', (event) => {
    if(event.target.closest('.library-delete, .library-add')) return;
    libraryAddToCanvas(card);
  });
  card.addEventListener('keydown', (event) => {
    if(event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    libraryAddToCanvas(card);
  });

  const preview = document.createElement('div');
  preview.className = 'library-preview';
  if(previewSrc){
    const img = document.createElement('img');
    img.src = previewSrc;
    img.alt = `Aperçu de ${filename}`;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.referrerPolicy = 'no-referrer';
    img.draggable = false;
    img.addEventListener('load', ()=> fitLibraryPreviewImage(img, preview));
    img.addEventListener('error', ()=>{
      if(thumb && img.src !== thumb && !img.dataset.thumbFallback){
        img.dataset.thumbFallback = '1';
        img.src = thumb;
        return;
      }
      img.remove();
      preview.appendChild(Object.assign(document.createElement('span'), {
        className: 'library-preview-placeholder',
        textContent: extension
      }));
    });
    preview.appendChild(img);
  }else{
    preview.appendChild(Object.assign(document.createElement('span'), {
      className: 'library-preview-placeholder',
      textContent: extension
    }));
  }

  const del = document.createElement('button');
  del.type = 'button';
  del.className = 'library-delete';
  del.title = 'Supprimer';
  del.setAttribute('aria-label', `Supprimer ${filename}`);
  del.innerHTML = '<span>&times;</span>';
  del.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    libraryDeleteFile(key, card, del);
  });
  preview.appendChild(del);

  const body = document.createElement('div');
  body.className = 'library-card-body';

  const name = document.createElement('h3');
  name.className = 'library-filename';
  name.textContent = filename;
  name.title = filename;
  body.appendChild(name);

  if(date) body.appendChild(Object.assign(document.createElement('p'), {className:'library-meta', textContent:`Importé le ${date}`}));
  const details = [size, extension].filter(Boolean).join(' · ');
  if(details) body.appendChild(Object.assign(document.createElement('p'), {className:'library-meta', textContent:details}));
  if(width && height) body.appendChild(Object.assign(document.createElement('p'), {className:'library-meta', textContent:`${width} × ${height} mm`}));

  const add = document.createElement('button');
  add.type = 'button';
  add.className = 'library-add';
  add.textContent = 'Ajouter à la planche';
  add.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    libraryAddToCanvas(card);
  });
  body.appendChild(add);

  card.append(preview, body);
  return card;
}

async function libraryRequestDelete(key){
  if(!libraryConfig.customerId || !libraryConfig.deleteUrl || !key){
    throw new Error('Informations de suppression incomplètes.');
  }

  const attempts = [
    {
      query: {user_id: libraryConfig.customerId},
      body: {user_id: libraryConfig.customerId, file_key: key}
    },
    {
      query: {user_id: libraryConfig.customerId, file_key: key},
      body: null
    }
  ];

  let lastError = null;
  for(const attempt of attempts){
    const url = new URL(libraryConfig.deleteUrl, window.location.origin);
    Object.entries(attempt.query).forEach(([name, value]) => url.searchParams.set(name, value));
    const response = await fetch(url.toString(), {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(attempt.body ? {'Content-Type': 'application/json'} : {})
      },
      ...(attempt.body ? {body: JSON.stringify(attempt.body)} : {})
    });
    const json = await libraryParseJson(response).catch(() => ({}));
    if(response.ok || response.status === 404) return json;
    lastError = new Error(json?.message || json?.error || `Suppression impossible (HTTP ${response.status}).`);
    if(response.status !== 400 && response.status !== 422) throw lastError;
  }
  throw lastError || new Error('Impossible de supprimer ce fichier.');
}

async function libraryDeleteFile(key, card, button){
  const fileKey = String(key || '');
  if(!fileKey || libraryState.deletingKeys.has(fileKey)) return;

  const filename = card?.dataset?.filename || libraryFilename(
    libraryState.files.find((item) => String(item?.key || '') === fileKey)
  ) || 'ce fichier';

  const confirmed = window.confirm(
    `Supprimer définitivement « ${filename} » de votre bibliothèque ?`
  );
  if(!confirmed) return;

  libraryState.deletingKeys.add(fileKey);
  card?.classList.add('is-busy', 'is-deleting');
  if(button){
    button.disabled = true;
    button.classList.add('is-loading');
  }
  librarySetStatus(`Suppression de ${filename}…`, 'loading');

  try{
    await libraryRequestDelete(fileKey);
    libraryState.files = libraryState.files.filter((item) => String(item?.key || '') !== fileKey);
    libraryRenderGrid();
    librarySetStatus('Fichier supprimé.', 'success');
    showToast(`${filename} supprimé`);
  }catch(error){
    console.error('[Sherpa library] delete error:', fileKey, error);
    const message = error?.message || 'Impossible de supprimer ce fichier';
    librarySetStatus(message, 'error');
    showToast(message);
    card?.classList.remove('is-busy', 'is-deleting');
    if(button){
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }finally{
    libraryState.deletingKeys.delete(fileKey);
  }
}

function libraryRenderGrid(){
  if(!libraryRefs.grid) return;
  libraryRefs.grid.querySelectorAll('.library-card').forEach(card => card.remove());

  const list = libraryFilteredFiles();
  const hasFiles = libraryState.files.length > 0;
  const hasMatches = list.length > 0;
  const query = normalizeLibrarySearch(libraryRefs.search?.value);

  librarySetVisible(libraryRefs.empty, !hasFiles && !libraryState.loading);
  librarySetVisible(libraryRefs.noResults, hasFiles && Boolean(query) && !hasMatches);
  librarySetVisible(libraryRefs.grid, true);

  const fragment = document.createDocumentFragment();
  list.forEach(file => fragment.appendChild(libraryCreateCard(file)));
  libraryRefs.grid.insertBefore(fragment, libraryRefs.uploadTrigger || null);
}

async function libraryLoadFiles({force = false} = {}){
  if(!libraryConfig.customerId || libraryState.loading) return;
  if(libraryState.loaded && !force){
    libraryRenderGrid();
    return;
  }

  librarySetStatus('');
  librarySetVisible(libraryRefs.error, false);
  librarySetVisible(libraryRefs.empty, false);
  librarySetVisible(libraryRefs.noResults, false);
  libraryState.loading = true;
  librarySetVisible(libraryRefs.loading, true);
  if(libraryRefs.search) libraryRefs.search.disabled = true;
  if(libraryRefs.uploadTrigger) libraryRefs.uploadTrigger.disabled = true;

  try{
    const url = new URL(libraryConfig.listUrl, window.location.origin);
    url.searchParams.set('user_id', libraryConfig.customerId);
    const response = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {Accept: 'application/json'}
    });
    const json = await libraryParseJson(response);
    if(!response.ok) throw new Error(json?.message || `HTTP ${response.status}`);

    const files = Array.isArray(json?.files)
      ? json.files
      : Array.isArray(json?.data?.files)
        ? json.data.files
        : [];

    libraryState.files = files.sort(
      (a, b) => new Date(b?.last_modified || 0) - new Date(a?.last_modified || 0)
    );
    libraryState.loaded = true;
    libraryRenderGrid();
  }catch(error){
    console.error('[Sherpa library] list error:', error);
    librarySetVisible(libraryRefs.error, true);
    librarySetVisible(libraryRefs.grid, false);
    librarySetStatus(error?.message || 'Chargement impossible', 'error');
  }finally{
    libraryState.loading = false;
    librarySetVisible(libraryRefs.loading, false);
    if(libraryRefs.search) libraryRefs.search.disabled = false;
    if(libraryRefs.uploadTrigger) libraryRefs.uploadTrigger.disabled = libraryState.uploading;
  }
}

async function libraryUploadFile(file, meta={}){
  if(!libraryConfig.customerId) throw new Error('Connectez-vous pour utiliser Mes fichiers');
  if(!file) throw new Error('Fichier manquant');
  const ext = String(file.name || '').split('.').pop().toLowerCase();
  if(!['png', 'pdf', 'ai'].includes(ext)){
    throw new Error('Formats acceptés : PNG, PDF et AI.');
  }

  const url = new URL(libraryConfig.uploadUrl, window.location.origin);
  url.searchParams.set('user_id', libraryConfig.customerId);
  const formData = new FormData();
  formData.append('file', file, file.name);
  const widthMm = Number(meta.widthMm);
  const heightMm = Number(meta.heightMm);
  if(Number.isFinite(widthMm) && widthMm > 0) formData.append('width_mm', String(widthMm));
  if(Number.isFinite(heightMm) && heightMm > 0) formData.append('height_mm', String(heightMm));

  const response = await fetch(url.toString(), {
    method: 'POST',
    credentials: 'same-origin',
    body: formData,
    headers: {Accept: 'application/json'}
  });
  const json = await libraryParseJson(response);
  if(!response.ok) throw new Error(json?.message || `HTTP ${response.status}`);
  return json;
}

async function libraryUploadFiles(fileList){
  const selected = Array.from(fileList || []);
  if(!selected.length || libraryState.uploading) return;

  const allowed = new Set(['png', 'pdf', 'ai']);
  const invalid = selected.filter(file => !allowed.has(String(file.name || '').split('.').pop().toLowerCase()));
  if(invalid.length){
    librarySetStatus('Formats acceptés : PNG, PDF et AI.', 'error');
    return;
  }

  libraryState.uploading = true;
  if(libraryRefs.uploadTrigger) libraryRefs.uploadTrigger.disabled = true;

  const failed = [];
  try{
    for(let i = 0; i < selected.length; i += 1){
      const file = selected[i];
      librarySetStatus(`Import ${i + 1}/${selected.length} : ${file.name}`, 'loading');
      try{
        await libraryUploadFile(file);
      }catch(error){
        console.error('[Sherpa library] upload error:', file.name, error);
        failed.push(file.name);
      }
    }
    await libraryLoadFiles({force: true});
    librarySetStatus(
      failed.length
        ? `${failed.length} fichier(s) n'ont pas pu être importé(s).`
        : (selected.length > 1 ? 'Fichiers ajoutés à la bibliothèque.' : 'Fichier ajouté à la bibliothèque.'),
      failed.length ? 'error' : 'success'
    );
  }finally{
    libraryState.uploading = false;
    if(libraryRefs.uploadTrigger) libraryRefs.uploadTrigger.disabled = false;
  }
}

function libraryOriginalUrl(file){
  // Fast Order live (`yt`) : uniquement download_url = fichier serveur original.
  return String(file?.download_url || '').trim();
}

function libraryKnownThumbnailUrl(fileMeta){
  return String(
    fileMeta?.thumbnail?.download_url ||
    fileMeta?.thumbnail?.url ||
    fileMeta?.thumbnail_url ||
    ''
  ).trim();
}

function libraryIsThumbnailUrl(url, fileMeta, infosThumbnail = ''){
  const candidate = String(url || '').trim();
  if(!candidate) return true;
  const known = libraryKnownThumbnailUrl(fileMeta);
  if(known && candidate === known) return true;
  if(infosThumbnail && candidate === infosThumbnail) return true;
  // Éviter le faux positif sur "thumb" dans un hash ; matcher un segment de chemin.
  return /\/(?:thumbnails?|thumbs?)(?:\/|$)/i.test(candidate);
}

async function libraryFetchBlob(url, {sameOrigin = false, timeoutMs = 45000} = {}){
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timer = controller ? window.setTimeout(() => controller.abort(), timeoutMs) : null;
  try{
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: sameOrigin ? 'same-origin' : 'omit',
      cache: 'no-store',
      signal: controller?.signal
    });
    if(!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    if(!blob || blob.size === 0) throw new Error('Fichier vide');
    return blob;
  }catch(error){
    if(error?.name === 'AbortError') throw new Error('Délai dépassé lors du téléchargement');
    throw error;
  }finally{
    if(timer) window.clearTimeout(timer);
  }
}

async function libraryFileInfos(originalUrl, cropTransparent){
  // Même contrat que Fast Order live Cr/zt : filename = download_url original.
  const infosUrl = new URL('/apps/easy-order/file/infos', window.location.origin);
  infosUrl.searchParams.set('filename', originalUrl);
  infosUrl.searchParams.set('crop_transparent_area', cropTransparent ? 'true' : 'false');

  const response = await fetch(infosUrl.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: {Accept: 'application/json'}
  });
  const text = await response.text();
  let json = null;
  try{ json = text ? JSON.parse(text) : null; }
  catch(_){ json = null; }
  if(!response.ok){
    throw new Error(json?.message || json?.STATUS_DESCRIPTION || `infos HTTP ${response.status}`);
  }
  if(json?.STATUS_CODE && Number(json.STATUS_CODE) !== 200){
    throw new Error(json.STATUS_DESCRIPTION || 'Erreur file infos');
  }

  return {
    fileUrl: String(json?.FILE_URL || originalUrl || '').trim(),
    pngFullSize: String(json?.FILE_PNG_FULL_SIZE || '').trim(),
    fileCropped: String(json?.FILE_CROPPED || '').trim(),
    thumbnail: String(json?.FILE_THUMBNAIL || '').trim()
  };
}

async function libraryTryBlobFromUrl(url, fileMeta, infosThumbnail, label){
  const clean = String(url || '').trim();
  if(!clean) throw new Error(`${label} manquant`);
  if(libraryIsThumbnailUrl(clean, fileMeta, infosThumbnail)){
    throw new Error(`${label} pointe vers un thumbnail`);
  }
  return libraryFetchBlob(clean);
}

async function libraryResolveLocalFile(fileMeta, fallbackName, fallbackType){
  const filename = libraryFilename(fileMeta) || fallbackName || 'fichier.png';
  const contentType = String(fileMeta?.content_type || fallbackType || '');
  const originalUrl = libraryOriginalUrl(fileMeta);
  if(!originalUrl){
    throw new Error('Le fichier original est temporairement indisponible.');
  }

  const ext = String(filename).split('.').pop().toLowerCase();
  const isPdfOrAi = ext === 'pdf' || ext === 'ai' || contentType.includes('pdf') || contentType.includes('postscript') || contentType.includes('illustrator');
  let lastError = null;

  // 1) Tentative directe sur le fichier serveur (souvent bloquée par CORS)
  try{
    const blob = await libraryTryBlobFromUrl(originalUrl, fileMeta, '', 'download_url');
    return {
      blob,
      filename,
      contentType: blob.type || contentType || 'application/octet-stream'
    };
  }catch(error){
    lastError = error;
  }

  // 2) Pipeline Fast Order live : file/infos(download_url) puis URLs serveur.
  //    Ordre : FILE_URL (original) → FILE_PNG_FULL_SIZE (plein format, PAS thumbnail).
  const cropOrder = isPdfOrAi ? [false, true] : [true, false];
  for(const crop of cropOrder){
    try{
      const infos = await libraryFileInfos(originalUrl, crop);
      const candidates = [
        {url: infos.fileUrl, filename, contentType},
        {url: originalUrl, filename, contentType},
        {
          url: infos.pngFullSize,
          filename: filename.replace(/\.[^.]+$/, '') + '.png',
          contentType: 'image/png'
        },
        {
          url: infos.fileCropped,
          filename: filename.replace(/\.[^.]+$/, '') + '.png',
          contentType: 'image/png'
        }
      ];

      for(const candidate of candidates){
        try{
          const blob = await libraryTryBlobFromUrl(
            candidate.url,
            fileMeta,
            infos.thumbnail,
            'url serveur'
          );
          return {
            blob,
            filename: candidate.filename || filename,
            contentType: blob.type || candidate.contentType || 'application/octet-stream'
          };
        }catch(error){
          lastError = error;
        }
      }
    }catch(error){
      lastError = error;
    }
  }

  throw lastError || new Error('Import impossible');
}

async function libraryAddToCanvas(card){
  const key = card?.dataset.fileKey || '';
  const fallbackName = card?.dataset.filename || 'fichier.png';
  const fallbackType = card?.dataset.contentType || '';
  const fileMeta = libraryState.files.find((item) => String(item?.key || '') === key);
  if(!fileMeta){
    librarySetStatus('Fichier introuvable dans la bibliothèque.', 'error');
    showToast('Fichier introuvable');
    return;
  }

  card.classList.add('is-busy');
  librarySetStatus(`Import de ${fallbackName}…`, 'loading');
  closeLibraryModal();

  const busyId = beginBusy(`Récupération de ${fallbackName}…`);
  try{
    const resolved = await libraryResolveLocalFile(fileMeta, fallbackName, fallbackType);
    updateBusy(busyId, `Ajout de ${resolved.filename || fallbackName}…`);
    const type = resolved.contentType || 'application/octet-stream';
    const localFile = new File([resolved.blob], resolved.filename || fallbackName, {type});
    const printSize = parseLibraryPrintMm(fileMeta);
    await loadFile(localFile, printSize || {});
    showToast(`${resolved.filename || fallbackName} ajouté à la planche`);
  }catch(error){
    console.error('[Sherpa library] add error:', error);
    const message = error?.message || 'Impossible d’ajouter ce fichier';
    showToast(message);
    openLibraryModal();
    librarySetStatus(message, 'error');
  }finally{
    endBusy(busyId);
    card.classList.remove('is-busy');
  }
}

function bindLibraryUi(){
  if(!libraryRefs.overlay) return;

  libraryRefs.search?.addEventListener('input', () => libraryRenderGrid());
  libraryRefs.retry?.addEventListener('click', () => libraryLoadFiles({force: true}));
  libraryRefs.uploadTrigger?.addEventListener('click', () => libraryRefs.uploadInput?.click());
  libraryRefs.uploadInput?.addEventListener('change', (event) => {
    const files = event.target.files;
    event.target.value = '';
    libraryUploadFiles(files);
  });
}

bindLibraryUi();

mountTextColorHexField();
init();
